var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2083 20.5563L14.3786 20.9584L14.1528 20.1082L16.0983 19.7578L16.2083 20.5563Z",
    fill: "#0000FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.369 20.9576L12.7767 21.4918L12.4351 20.6072L14.1431 20.1074L14.369 20.9576Z",
    fill: "#0000FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0939 19.7575L14.1485 20.1079L13.9458 19.1141L15.9955 18.8154L16.0939 19.7575Z",
    fill: "#0028FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1575 20.1085L12.4494 20.6083L12.1367 19.5743L13.9548 19.1147L14.1575 20.1085Z",
    fill: "#0018FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3324 21.2051L14.6243 21.6417L14.3811 20.9524L16.2108 20.5503L16.3324 21.2051Z",
    fill: "#0000F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6143 21.6479L13.1494 22.2166L12.7788 21.4986L14.3711 20.9644L14.6143 21.6479Z",
    fill: "#0000DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9868 18.8154L13.9429 19.1141L13.7634 18.0054L15.9 17.7642L15.9868 18.8154Z",
    fill: "#0058FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.936 19.1144L12.1237 19.5682L11.8516 18.4078L13.7565 18L13.936 19.1144Z",
    fill: "#0048FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 20.2922L16.2034 20.5564L16.0876 19.7522L18.1952 19.5454L18.2068 20.2922Z",
    fill: "#0014FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4521 21.6819L14.8656 22.1529L14.6108 21.6416L16.3189 21.2051L16.4521 21.6819Z",
    fill: "#0000DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7756 21.4926L11.4728 22.1589L11.0154 21.2455L12.434 20.6079L12.7756 21.4926Z",
    fill: "#0000E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8652 22.1525L13.5334 22.7442L13.1455 22.2157L14.6104 21.647L14.8652 22.1525Z",
    fill: "#0000C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1967 19.5454L16.0891 19.7579L15.9849 18.8159L18.1909 18.6665L18.1967 19.5454Z",
    fill: "#003CFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4442 20.6082L11.0256 21.2458L10.6145 20.1774L12.1373 19.5742L12.4442 20.6082Z",
    fill: "#0008FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2221 20.8952L16.3345 21.2054L16.2129 20.5562L18.2163 20.292L18.2221 20.8952Z",
    fill: "#0000FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1467 22.2107L11.9655 22.8943L11.4734 22.159L12.7762 21.4927L13.1467 22.2107Z",
    fill: "#0000C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8963 17.7648L13.7597 18.0061L13.615 16.8055L15.8268 16.6274L15.8963 17.7648Z",
    fill: "#0090FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7695 18.0053L11.8646 18.4131L11.6445 17.1551L13.6247 16.8047L13.7695 18.0053Z",
    fill: "#0084FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1864 18.6664L15.9804 18.8157L15.8936 17.7645L18.1806 17.6841L18.1864 18.6664Z",
    fill: "#0068FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1296 19.5735L10.6068 20.1766L10.2478 18.9818L11.8632 18.4131L12.1296 19.5735Z",
    fill: "#003CFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2163 21.337L16.4445 21.6874L16.3171 21.2106L18.2047 20.9004L18.2163 21.337Z",
    fill: "#0000F6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5986 21.9746L15.1453 22.4686L14.8848 22.1527L16.4713 21.6816L16.5986 21.9746Z",
    fill: "#0000D1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5342 22.7447L12.4804 23.4397L11.9651 22.894L13.1463 22.2104L13.5342 22.7447Z",
    fill: "#0000AD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.143 22.4688L13.9386 23.0719L13.5449 22.7445L14.8824 22.1528L15.143 22.4688Z",
    fill: "#0000BB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2028 17.6837L15.9157 17.7641L15.8462 16.6267L18.2028 16.6152V17.6837Z",
    fill: "#009CFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8561 18.4129L10.2465 18.9816L9.95117 17.6834L11.6361 17.1606L11.8561 18.4129Z",
    fill: "#0078FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2375 21.6016L16.5873 21.9808L16.4541 21.6878L18.2259 21.3374L18.2375 21.6016Z",
    fill: "#0000ED"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8441 16.6268L13.6322 16.8049L13.5222 15.5412L15.7919 15.4263L15.8441 16.6268Z",
    fill: "#00CCFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2851 20.1595L18.2006 20.2916L18.1948 19.5449L20.3719 19.4702L20.2851 20.1595Z",
    fill: "#002CFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6215 16.8052L11.6413 17.1556L11.4734 15.8344L13.5115 15.5356L13.6215 16.8052Z",
    fill: "#00C4FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1866 20.7111L18.2064 20.8949L18.1948 20.2918L20.2793 20.1597L20.1866 20.7111Z",
    fill: "#0014FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3662 19.4701L18.1891 19.5448L18.1833 18.6659L20.4473 18.6602L20.3662 19.4701Z",
    fill: "#0050FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 22.1585L10.4729 22.934L9.90552 22.0091L11.0056 21.2451L11.4688 22.1585Z",
    fill: "#0000DA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0327 21.2453L9.93263 22.0093L9.4231 20.9236L10.6216 20.1826L11.0327 21.2453Z",
    fill: "#0000FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9397 23.0715L13.0133 23.7723L12.4922 23.4333L13.5518 22.7383L13.9397 23.0715Z",
    fill: "#0000A4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9656 22.8939L11.0855 23.6751L10.4775 22.9283L11.4734 22.1528L11.9656 22.8939Z",
    fill: "#0000B6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.718 22.078L15.3863 22.5835L15.1257 22.4686L16.579 21.9746L16.718 22.078Z",
    fill: "#0000D6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0939 21.1074L18.2179 21.3372L18.2063 20.9006L20.1865 20.7168L20.0939 21.1074Z",
    fill: "#0004FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4531 18.6605L18.1891 18.6663L18.1833 17.6782L20.5226 17.7414L20.4531 18.6605Z",
    fill: "#0078FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3995 22.5841L14.3283 23.193L13.9346 23.0724L15.1389 22.4692L15.3995 22.5841Z",
    fill: "#0000BF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.198 16.6154L15.8414 16.6268L15.7893 15.4263L18.198 15.4837V16.6154Z",
    fill: "#00D8FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6095 20.1772L9.41093 20.9183L8.96509 19.7005L10.2505 18.9824L10.6095 20.1772Z",
    fill: "#0034FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2528 21.6824L16.7242 22.0787L16.5911 21.9753L18.2412 21.5962L18.2528 21.6824Z",
    fill: "#0000F1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4852 23.4394L11.7209 24.2264L11.084 23.6806L11.9641 22.8994L12.4852 23.4394Z",
    fill: "#00009F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6436 17.1551L9.95872 17.6778L9.73291 16.3107L11.4757 15.8281L11.6436 17.1551Z",
    fill: "#00BCFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 21.3372L18.2291 21.6014L18.2175 21.3372L20.0935 21.1074L20.0009 21.3372Z",
    fill: "#0000FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7816 15.4266L13.5119 15.5415L13.4424 14.2432L15.7526 14.1973L15.7816 15.4266Z",
    fill: "#23FFD4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5226 17.7469L18.1833 17.6837V16.6152L20.5805 16.7531L20.5226 17.7469Z",
    fill: "#00ACFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5075 15.5356L11.4694 15.8344L11.3594 14.4787L13.438 14.2432L13.5075 15.5356Z",
    fill: "#1CFFDB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3272 23.193L13.5282 23.8938L13.0071 23.7789L13.9335 23.0781L14.3272 23.193Z",
    fill: "#0000AD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2388 18.9823L8.9534 19.7004L8.58862 18.3734L9.94351 17.6841L10.2388 18.9823Z",
    fill: "#0070FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8588 21.9868L15.6544 22.4923L15.3997 22.5842L16.7256 22.0787L16.8588 21.9868Z",
    fill: "#0000E8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9942 23.773L12.3573 24.5542L11.7146 24.2211L12.4789 23.4341L12.9942 23.773Z",
    fill: "#000096"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1986 15.4834L15.7899 15.426L15.7551 14.1909L18.1986 14.323V15.4834Z",
    fill: "#26FFD1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9081 21.4006L18.2406 21.6821L18.229 21.5959L20.0008 21.3374L19.9081 21.4006Z",
    fill: "#0000FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3504 20.1423L20.2891 20.1595L20.3759 19.4702L22.5125 19.5162L22.3504 20.1423Z",
    fill: "#0044FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1722 20.6365L20.1978 20.7054L20.2904 20.154L22.3459 20.1367L22.1722 20.6365Z",
    fill: "#002CFF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6499 22.4917L14.7061 23.0949L14.324 23.1868L15.3951 22.5779L15.6499 22.4917Z",
    fill: "#0000D1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5805 16.7535L18.1833 16.6156V15.4897L20.6326 15.708L20.5805 16.7535Z",
    fill: "#00E0FB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.274 21.5845L16.8554 21.9866L16.728 22.0785L18.2624 21.6821L18.274 21.5845Z",
    fill: "#0000FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5169 19.5218L20.3804 19.4701L20.4614 18.6602L22.6733 18.7808L22.5169 19.5218Z",
    fill: "#0064FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.472 15.8342L9.72923 16.3167L9.58447 14.9093L11.3678 14.4785L11.472 15.8342Z",
    fill: "#19FFDE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21.977 20.9871L20.0952 21.102L20.1879 20.7057L22.1623 20.6367L21.977 20.9871Z",
    fill: "#001CFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4756 22.9341L9.78654 23.7958L9.12646 22.8709L9.90813 22.0093L10.4756 22.9341Z",
    fill: "#0000D1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0983 23.6813L10.5077 24.5373L9.80127 23.7962L10.4903 22.9346L11.0983 23.6813Z",
    fill: "#0000A8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7586 14.1912L13.4484 14.2372L13.4194 12.939L15.7471 12.9562L15.7586 14.1912Z",
    fill: "#5AFF9D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6622 18.781L20.4504 18.6662L20.5199 17.7471L22.7954 17.9424L22.6622 18.781Z",
    fill: "#008CFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90954 22.0037L9.12787 22.8653L8.53149 21.7739L9.40001 20.918L9.90954 22.0037Z",
    fill: "#0000FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95173 17.6836L8.59684 18.3729L8.32471 16.9713L9.7317 16.3164L9.95173 17.6836Z",
    fill: "#00B8FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13.433 14.2431L11.3544 14.4843L11.3022 13.1229L13.3983 12.9448L13.433 14.2431Z",
    fill: "#5AFF9D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7874 21.1822L19.9924 21.3373L20.0851 21.1076L21.9669 20.9927L21.7874 21.1822Z",
    fill: "#0018FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7145 23.1011L14.0487 23.7904L13.5449 23.8938L14.3382 23.193L14.7145 23.1011Z",
    fill: "#0000BF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5245 23.8931L13.0034 24.6628L12.3665 24.5537L13.0092 23.7725L13.5245 23.8931Z",
    fill: "#00009B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7165 24.2211L11.2301 25.0713L10.489 24.5371L11.0796 23.6812L11.7165 24.2211Z",
    fill: "#000092"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8269 21.291L18.2635 21.584L18.252 21.6816L19.9195 21.4002L19.8269 21.291Z",
    fill: "#000CFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4102 20.9179L8.54169 21.7738L8.02637 20.5388L8.97015 19.6943L9.4102 20.9179Z",
    fill: "#002CFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1987 14.3232L15.7552 14.1911L15.7437 12.9561L18.2044 13.1571L18.1987 14.3232Z",
    fill: "#5DFF9A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6326 15.7019L18.1833 15.4836V14.3232L20.6615 14.6162L20.6326 15.7019Z",
    fill: "#2CFFCA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7943 17.9425L20.5188 17.7472L20.5767 16.7534L22.9043 17.0234L22.7943 17.9425Z",
    fill: "#00B8FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9663 21.6992L15.8778 22.199L15.6404 22.4919L16.8447 21.9864L16.9663 21.6992Z",
    fill: "#0000FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2739 21.3027L16.9653 21.6991L16.8438 21.9863L18.2623 21.5842L18.2739 21.3027Z",
    fill: "#000CFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6247 21.2228L19.9224 21.4009L20.015 21.3377L21.8099 21.1826L21.6247 21.2228Z",
    fill: "#0018FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8838 22.1987L15.0616 22.7904L14.7026 23.1006L15.6464 22.4974L15.8838 22.1987Z",
    fill: "#0000F1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3517 14.4787L9.56833 14.9095L9.50464 13.5022L11.3054 13.123L11.3517 14.4787Z",
    fill: "#56FFA0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3727 24.5544L11.9964 25.3873L11.2437 25.0714L11.73 24.2212L12.3727 24.5544Z",
    fill: "#000089"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95924 19.7L8.02124 20.5444L7.59277 19.2002L8.59446 18.373L8.95924 19.7Z",
    fill: "#006CFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71143 16.3172L8.30442 16.972L8.11914 15.5302L9.56088 14.9155L9.71143 16.3172Z",
    fill: "#16FFE1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.915 17.0234L20.5874 16.7534L20.6337 15.7021L23.0019 16.0526L22.915 17.0234Z",
    fill: "#06ECF1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7356 12.9562L13.408 12.9389L13.4195 11.6694L15.7414 11.7499L15.7356 12.9562Z",
    fill: "#94FF63"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7397 21.0151L18.2748 21.3081L18.2632 21.5896L19.8265 21.2966L19.7397 21.0151Z",
    fill: "#0024FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0377 23.79L13.6324 24.5425L13.0071 24.6632L13.5282 23.8934L14.0377 23.79Z",
    fill: "#0000AD"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0311 20.6648L22.1782 20.6361L22.3577 20.1421L24.28 20.2283L24.0311 20.6648Z",
    fill: "#0044FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2617 20.2289L22.3394 20.1427L22.5015 19.5166L24.4875 19.666L24.2617 20.2289Z",
    fill: "#005CFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6615 14.6164L18.1833 14.3235L18.1891 13.1631L20.6847 13.5307L20.6615 14.6164Z",
    fill: "#5DFF9A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4041 12.9386L11.3022 13.1224L11.3138 11.7954L13.4098 11.6748L13.4041 12.9386Z",
    fill: "#94FF63"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4525 21.1016L19.8313 21.2911L19.9181 21.4003L21.6204 21.2222L21.4525 21.1016Z",
    fill: "#0028FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0522 22.7905L14.5021 23.4626L14.0273 23.79L14.6932 23.1007L15.0522 22.7905Z",
    fill: "#0000DF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7675 20.9699L21.9841 20.9871L22.1694 20.6367L24.0223 20.6654L23.7675 20.9699Z",
    fill: "#0038FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4965 19.6716L22.5105 19.5223L22.6668 18.7812L24.7107 18.9995L24.4965 19.6716Z",
    fill: "#0078FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2044 13.1632L15.7437 12.9622L15.7552 11.7559L18.216 12.0258L18.2044 13.1632Z",
    fill: "#90FF66"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0076 24.6629L12.7354 25.4728L11.9885 25.3866L12.3707 24.5537L13.0076 24.6629Z",
    fill: "#00008D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0692 21.2227L16.0906 21.7052L15.8706 22.1992L16.9591 21.6994L17.0692 21.2227Z",
    fill: "#001CFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5196 21.1302L21.8115 21.1876L21.9968 20.9923L23.7802 20.9751L23.5196 21.1302Z",
    fill: "#0034FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3009 20.8428L17.0907 21.2219L16.9807 21.6987L18.2893 21.3023L18.3009 20.8428Z",
    fill: "#0030FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7143 18.9993L22.6704 18.7811L22.8036 17.9424L24.8996 18.2411L24.7143 18.9993Z",
    fill: "#00A0FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0012 16.0528L20.6331 15.7024L20.6678 14.6167L23.0591 15.0475L23.0012 16.0528Z",
    fill: "#33FFC4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59766 18.3676L7.59597 19.1948L7.27173 17.7759L8.31974 16.9717L8.59766 18.3676Z",
    fill: "#00B0FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78641 23.7954L9.3811 24.7145L8.64575 23.8012L9.12633 22.8706L9.78641 23.7954Z",
    fill: "#0000C8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5064 24.5369L10.1764 25.4388L9.38892 24.715L9.79422 23.7959L10.5064 24.5369Z",
    fill: "#0000A4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0996 21.7046L15.3874 22.279L15.0574 22.796L15.8796 22.2044L16.0996 21.7046Z",
    fill: "#0008FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13862 22.8706L8.65805 23.8012L7.99219 22.7155L8.54225 21.7734L9.13862 22.8706Z",
    fill: "#0000FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3054 13.1228L9.50464 13.502L9.52201 12.1291L11.3169 11.7959L11.3054 13.1228Z",
    fill: "#94FF63"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2558 21.1424L21.6172 21.2234L21.7967 21.1829L23.5048 21.125L23.2558 21.1424Z",
    fill: "#0034FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2802 20.8257L19.74 21.0152L19.8211 21.2967L21.4423 21.1072L21.2802 20.8257Z",
    fill: "#003CFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5621 14.9093L8.12037 15.524L8.03931 14.0764L9.49841 13.502L9.5621 14.9093Z",
    fill: "#56FFA0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2333 25.0708L10.9902 25.9497L10.168 25.4385L10.4922 24.5366L11.2333 25.0708Z",
    fill: "#000089"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6757 20.5674L18.2977 20.8431L18.2861 21.3027L19.751 21.0097L19.6757 20.5674Z",
    fill: "#0044FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8934 18.2349L22.7974 17.9362L22.9132 17.0171L25.0439 17.3962L24.8934 18.2349Z",
    fill: "#00C8FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 13.5309L18.1948 13.1633L18.2006 12.0259L20.6904 12.4682V13.5309Z",
    fill: "#90FF66"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7527 11.7555L13.4309 11.6751L13.483 10.4688L15.7817 10.6066L15.7527 11.7555Z",
    fill: "#CAFF2C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5008 23.4624L14.2113 24.1919L13.6265 24.5366L14.0318 23.7841L14.5008 23.4624Z",
    fill: "#0000CD"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54345 21.7737L7.99339 22.7158L7.42017 21.4865L8.02813 20.5444L8.54345 21.7737Z",
    fill: "#0028FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4097 11.6751L11.3137 11.7957L11.3948 10.5377L13.4676 10.4688L13.4097 11.6751Z",
    fill: "#CEFF29"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2159 12.0254L15.7551 11.7554L15.7841 10.6123L18.2217 10.9455L18.2159 12.0254Z",
    fill: "#C7FF30"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6194 24.543L13.4457 25.3299L12.7219 25.4736L12.9941 24.6636L13.6194 24.543Z",
    fill: "#00009F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0705 15.0468L20.6792 14.616L20.6966 13.5303L23.1053 14.0358L23.0705 15.0468Z",
    fill: "#60FF97"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0039 21.0103L21.4348 21.1022L21.6085 21.2228L23.2471 21.1424L23.0039 21.0103Z",
    fill: "#0040FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3767 22.2739L14.9366 22.923L14.4966 23.463L15.0466 22.7909L15.3767 22.2739Z",
    fill: "#0000FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9886 25.3869L11.8322 26.2428L10.9927 25.9555L11.2359 25.0767L11.9886 25.3869Z",
    fill: "#000080"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32694 16.9656L7.27893 17.7699L7.0647 16.2993L8.14166 15.5181L8.32694 16.9656Z",
    fill: "#16FFE1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0482 17.4027L22.9116 17.0235L22.9985 16.0527L25.164 16.5123L25.0482 17.4027Z",
    fill: "#0FF8E7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3164 20.2173L17.1932 20.5677L17.0947 21.2225L18.3049 20.8434L18.3164 20.2173Z",
    fill: "#0058FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1756 20.5674L16.2897 21.0212L16.0986 21.7048L17.0772 21.2222L17.1756 20.5674Z",
    fill: "#0048FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1363 20.395L19.6714 20.5674L19.7467 21.0097L21.2868 20.8201L21.1363 20.395Z",
    fill: "#0058FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02196 20.5443L7.414 21.4863L6.93921 20.1364L7.59928 19.1943L8.02196 20.5443Z",
    fill: "#0068FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6542 20.78L24.033 20.6651L24.2761 20.2285L25.9495 20.3951L25.6542 20.78Z",
    fill: "#0060FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3282 21.0389L23.759 20.97L24.0138 20.6655L25.635 20.7804L25.3282 21.0389Z",
    fill: "#0054FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M25.936 20.4006L24.2627 20.234L24.4943 19.6768L26.214 19.9065L25.936 20.4006Z",
    fill: "#0074FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6117 19.9702L18.3089 20.2172L18.2974 20.8434L19.6812 20.5676L19.6117 19.9702Z",
    fill: "#006CFF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3029 21.0215L15.6892 21.5615L15.3997 22.2738L16.1118 21.6993L16.3029 21.0215Z",
    fill: "#0038FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8018 20.7339L21.2964 20.8258L21.4585 21.1015L23.0276 21.0096L22.8018 20.7339Z",
    fill: "#0054FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6846 12.4681L18.1948 12.0257L18.2006 10.9458L20.673 11.4513L20.6846 12.4681Z",
    fill: "#C1FF36"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7264 25.4734L12.6512 26.3006L11.8174 26.2431L11.9737 25.3872L12.7264 25.4734Z",
    fill: "#000084"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49841 13.5017L8.03931 14.0761L8.06247 12.6573L9.51578 12.123L9.49841 13.5017Z",
    fill: "#97FF60"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0234 21.1588L23.5063 21.1301L23.7611 20.9692L25.3302 21.0382L25.0234 21.1588Z",
    fill: "#004CFF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3223 11.7956L9.52734 12.1288L9.63157 10.8191L11.4033 10.5376L11.3223 11.7956Z",
    fill: "#D1FF26"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2219 19.9014L24.5022 19.6716L24.7164 18.9995L26.4824 19.304L26.2219 19.9014Z",
    fill: "#0090FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1677 16.5117L23.0022 16.0521L23.0659 15.0469L25.2545 15.5868L25.1677 16.5117Z",
    fill: "#36FFC1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0986 14.0365L20.6899 13.531L20.6957 12.4683L23.0986 13.0484V14.0365Z",
    fill: "#8DFF6A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7752 10.6064L13.4766 10.4685L13.5692 9.35986L15.8273 9.55517L15.7752 10.6064Z",
    fill: "#FFEA00"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9395 22.9224L14.7484 23.6232L14.21 24.1919L14.4995 23.4623L14.9395 22.9224Z",
    fill: "#0000FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7203 21.1536L23.2554 21.1478L23.5101 21.1362L25.0271 21.1652L24.7203 21.1536Z",
    fill: "#0050FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2236 24.1924L14.1483 24.9564L13.4651 25.3298L13.6388 24.5428L14.2236 24.1924Z",
    fill: "#0000C4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4694 19.3043L24.7092 18.9998L24.8945 18.2358L26.6952 18.615L26.4694 19.3043Z",
    fill: "#00B0FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2269 10.9458L15.7893 10.6126L15.8414 9.55566L18.2385 9.94628L18.2269 10.9458Z",
    fill: "#FBF100"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0042 19.8262L19.603 19.9698L19.6667 20.5672L21.1316 20.3949L21.0042 19.8262Z",
    fill: "#0080FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4664 10.4685L11.3936 10.5375L11.5325 9.3771L13.5591 9.35986L13.4664 10.4685Z",
    fill: "#FFE200"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13755 15.5238L7.06059 16.305L6.96216 14.8287L8.05649 14.0762L8.13755 15.5238Z",
    fill: "#53FFA4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60304 19.2005L6.94876 20.1425L6.58398 18.7065L7.2788 17.7759L7.60304 19.2005Z",
    fill: "#00B0FF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6729 21.561L15.3255 22.1757L14.9434 22.9225L15.3834 22.2733L15.6729 21.561Z",
    fill: "#002CFF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5847 20.3203L21.1372 20.395L21.282 20.8258L22.7874 20.7339L22.5847 20.3203Z",
    fill: "#0070FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1666 25.4391L10.0971 26.3123L9.2749 25.6L9.37912 24.7153L10.1666 25.4391Z",
    fill: "#00009F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37731 24.7146L9.27308 25.5993L8.50879 24.6974L8.64196 23.8013L9.37731 24.7146Z",
    fill: "#0000C8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3267 19.4355L17.2729 19.7457L17.186 20.5672L18.3093 20.2168L18.3267 19.4355Z",
    fill: "#008CFF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4269 21.0103L23.0142 21.016L23.2573 21.1492L24.7222 21.155L24.4269 21.0103Z",
    fill: "#005CFF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2769 19.7461L16.4663 20.1597L16.3042 21.0214L17.1901 20.5676L17.2769 19.7461Z",
    fill: "#007CFF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7038 18.6149L24.9031 18.2358L25.0594 17.4028L26.8891 17.8566L26.7038 18.6149Z",
    fill: "#00D8FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M10.991 25.9501L10.9563 26.806L10.0994 26.3062L10.1688 25.4331L10.991 25.9501Z",
    fill: "#000089"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4523 25.3296L13.4581 26.1223L12.6533 26.2946L12.7286 25.4675L13.4523 25.3296Z",
    fill: "#00009B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25.26 15.5871L23.0713 15.0471L23.106 14.0361L25.3063 14.6508L25.26 15.5871Z",
    fill: "#63FF94"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65472 23.8015L8.52154 24.6976L7.83252 23.6177L7.99464 22.7158L8.65472 23.8015Z",
    fill: "#0000FA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5595 19.229L18.3204 19.4358L18.3088 20.217L19.6116 19.97L19.5595 19.229Z",
    fill: "#009CFF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6787 11.4513L18.2063 10.9458L18.2179 9.94629L20.6555 10.5092L20.6787 11.4513Z",
    fill: "#F1FC06"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1044 13.0481L20.7015 12.4679L20.6899 11.4512L23.0755 12.1003L23.1044 13.0481Z",
    fill: "#BEFF39"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4567 20.1597L15.9182 20.6652L15.675 21.5613L16.2888 21.0213L16.4567 20.1597Z",
    fill: "#0070FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M11.827 26.2374V27.0818L10.9585 26.8061L10.9932 25.9502L11.827 26.2374Z",
    fill: "#000080"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1524 20.7339H22.7859L23.0117 21.0096L24.4245 21.0039L24.1524 20.7339Z",
    fill: "#006CFF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51557 12.1291L8.06226 12.6633L8.18964 11.3076L9.6198 10.8193L9.51557 12.1291Z",
    fill: "#D4FF23"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8927 17.8564L25.063 17.4026L25.1846 16.5122L27.0374 17.0464L26.8927 17.8564Z",
    fill: "#19FFDE"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4019 10.5373L9.63013 10.8188L9.81541 9.61247L11.5409 9.37695L11.4019 10.5373Z",
    fill: "#FFDB00"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98458 22.7156L7.82245 23.6175L7.22607 22.3939L7.41136 21.4863L7.98458 22.7156Z",
    fill: "#0024FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4066 19.7803L21.0112 19.8262L21.1386 20.3949L22.5861 20.3202L22.4066 19.7803Z",
    fill: "#0094FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M20.895 19.126L19.5459 19.2294L19.598 19.9704L20.9992 19.8268L20.895 19.126Z",
    fill: "#00ACFF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M15.816 9.55553L13.5579 9.36022L13.691 8.37793L15.8855 8.61919L15.816 9.55553Z",
    fill: "#FFB200"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26521 17.7757L6.5704 18.7063L6.33301 17.2243L7.05098 16.3052L7.26521 17.7757Z",
    fill: "#13FCE4"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7439 23.6289L14.7555 24.3584L14.1301 24.9559L14.2054 24.1919L14.7439 23.6289Z",
    fill: "#0000F1"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2321 9.94609L15.835 9.55547L15.9044 8.61914L18.2436 9.06146L18.2321 9.94609Z",
    fill: "#FFBD00"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3383 22.1758L15.2341 22.8479L14.7593 23.6234L14.9504 22.9225L15.3383 22.1758Z",
    fill: "#0020FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3057 14.6504L23.1055 14.0358L23.1113 13.042L25.3057 13.7313V14.6504Z",
    fill: "#8DFF6A"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M26.589 21.1708L25.3384 21.0329L25.6453 20.7744L26.9307 20.9525L26.589 21.1708Z",
    fill: "#006CFF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9334 20.9581L25.6479 20.78L25.9432 20.4009L27.2634 20.6306L26.9334 20.9581Z",
    fill: "#0078FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05649 14.0767L6.96216 14.8292L6.98532 13.3816L8.07386 12.6636L8.05649 14.0767Z",
    fill: "#97FF60"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M26.256 21.2625L25.04 21.1591L25.3527 21.0327L26.6034 21.1706L26.256 21.2625Z",
    fill: "#0068FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2647 20.6305L25.9446 20.4008L26.2225 19.9067L27.5716 20.1997L27.2647 20.6305Z",
    fill: "#008CFF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5685 9.36062L11.542 9.37786L11.7389 8.34961L13.7017 8.37833L13.5685 9.36062Z",
    fill: "#FFA700"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3269 18.5229L17.331 18.7872L17.2673 19.7522L18.3211 19.4421L18.3269 18.5229Z",
    fill: "#00C4FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6512 26.3005L12.6859 27.1277L11.8174 27.0817V26.2373L12.6512 26.3005Z",
    fill: "#000084"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14.154 24.9565L14.2409 25.7205L13.4824 26.1284L13.4766 25.3357L14.154 24.9565Z",
    fill: "#0000BB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9107 20.3323L22.5906 20.3208L22.7932 20.7344H24.1597L23.9107 20.3323Z",
    fill: "#0084FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9276 20.6655L15.6612 21.2457L15.3428 22.1821L15.6902 21.5674L15.9276 20.6655Z",
    fill: "#0068FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0201 17.046L25.1672 16.5118L25.2483 15.5869L27.1185 16.2016L27.0201 17.046Z",
    fill: "#3CFFBA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5247 18.3672L18.3319 18.5223L18.3203 19.4356L19.5594 19.2288L19.5247 18.3672Z",
    fill: "#00D0FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39985 21.4863L7.21457 22.3939L6.72241 21.0497L6.92507 20.1421L7.39985 21.4863Z",
    fill: "#0064FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9019 21.2349L24.7207 21.1538L25.0276 21.1654L26.2435 21.2696L25.9019 21.2349Z",
    fill: "#0068FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3284 18.7861L16.5815 19.148L16.4541 20.159L17.2647 19.7454L17.3284 18.7861Z",
    fill: "#00B8FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5744 20.1941L26.2195 19.9011L26.4742 19.3037L27.8523 19.6656L27.5744 20.1941Z",
    fill: "#00A4FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0702 12.1001L20.6847 11.451L20.6558 10.5146L23.0123 11.2212L23.0702 12.1001Z",
    fill: "#EBFF0C"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6551 10.515L18.2175 9.95202L18.2291 9.06738L20.6146 9.67629L20.6551 10.515Z",
    fill: "#FFC800"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2731 19.1196L20.9182 19.1254L21.0224 19.8262L22.4179 19.7802L22.2731 19.1196Z",
    fill: "#00BCFF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5803 21.0792L24.4338 21.0103L24.7291 21.1539L25.9103 21.2343L25.5803 21.0792Z",
    fill: "#0074FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8507 19.6655L26.4727 19.3036L26.6927 18.6143L28.0997 19.0451L27.8507 19.6655Z",
    fill: "#00C4FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8415 18.3154L19.533 18.3671L19.5677 19.2288L20.9168 19.1254L20.8415 18.3154Z",
    fill: "#00DCFE"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5706 19.1489L16.0959 19.6085L15.9048 20.6654L16.4433 20.1599L16.5706 19.1489Z",
    fill: "#00B0FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3062 13.7377L23.1117 13.0484L23.0828 12.1006L25.2656 12.8588L25.3062 13.7377Z",
    fill: "#B7FF40"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6934 19.8151L22.408 19.7749L22.5817 20.3206L23.9018 20.3321L23.6934 19.8151Z",
    fill: "#00A4FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1173 16.202L25.2471 15.5873L25.2876 14.6567L27.1636 15.3461L27.1173 16.202Z",
    fill: "#63FF94"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4639 26.1226L13.5276 26.9325L12.6881 27.1221L12.6533 26.2949L13.4639 26.1226Z",
    fill: "#000096"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05242 16.3054L6.33445 17.2245L6.23022 15.731L6.95978 14.8291L7.05242 16.3054Z",
    fill: "#53FFA4"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62913 10.819L8.19897 11.3073L8.42479 10.055L9.81441 9.60693L9.62913 10.819Z",
    fill: "#FFD700"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8893 8.61912L13.6948 8.37786L13.8627 7.54492L15.9761 7.8264L15.8893 8.61912Z",
    fill: "#FF7A00"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5494 9.37785L9.82397 9.61337L10.0845 8.53917L11.7463 8.34961L11.5494 9.37785Z",
    fill: "#FF9C00"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2328 9.06121L15.8936 8.6189L15.9804 7.82617L18.2443 8.3087L18.2328 9.06121Z",
    fill: "#FF8900"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2659 20.8028L24.1484 20.7339L24.4206 21.0096L25.567 21.0786L25.2659 20.8028Z",
    fill: "#0084FF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0971 26.3057L10.1955 27.1041L9.37912 26.3976L9.2749 25.5991L10.0971 26.3057Z",
    fill: "#00009F"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0964 19.045L26.6895 18.6142L26.8747 17.856L28.2991 18.3615L28.0964 19.045Z",
    fill: "#00E4F8"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26729 25.5996L9.37152 26.3981L8.60722 25.4962L8.50879 24.6978L9.26729 25.5996Z",
    fill: "#0000C8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2341 22.8481L15.3267 23.549L14.7766 24.3589L14.7593 23.6294L15.2341 22.8481Z",
    fill: "#0018FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93473 20.1369L6.73207 21.0445L6.35571 19.6142L6.57574 18.7065L6.93473 20.1369Z",
    fill: "#00ACFF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9563 26.8059L11.0547 27.6044L10.1978 27.1046L10.0994 26.3062L10.9563 26.8059Z",
    fill: "#000089"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M15.657 21.2451L15.628 21.8827L15.2285 22.8535L15.3327 22.1815L15.657 21.2451Z",
    fill: "#005CFF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3319 17.4941L17.3708 17.6952L17.3245 18.7809L18.3204 18.5224L18.3319 17.4941Z",
    fill: "#16FFE1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7667 24.3584L14.923 25.0879L14.2282 25.7198L14.1414 24.9558L14.7667 24.3584Z",
    fill: "#0000ED"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0187 11.221L20.6621 10.5145L20.6216 9.67578L22.9376 10.434L23.0187 11.221Z",
    fill: "#FFD700"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5014 17.4028L18.3434 17.4947L18.3318 18.523L19.5245 18.3679L19.5014 17.4028Z",
    fill: "#1CFFDB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0734 12.6581L6.98486 13.3819L7.12962 11.9975L8.20079 11.314L8.0734 12.6581Z",
    fill: "#D7FF1F"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51562 24.6976L8.61405 25.4961L7.92502 24.4219L7.8208 23.6177L8.51562 24.6976Z",
    fill: "#0000FA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 18.3614L20.8499 18.3154L20.9251 19.1254L22.28 19.1196L22.17 18.3614Z",
    fill: "#02E8F4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6889 8.37794L11.7261 8.34922L11.9808 7.47607L13.8568 7.54501L13.6889 8.37794Z",
    fill: "#FF6F00"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6145 9.67625L18.229 9.0616L18.2406 8.30908L20.5566 8.96394L20.6145 9.67625Z",
    fill: "#FF9800"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3843 17.7012L16.6779 18.0114L16.5911 19.1545L17.338 18.7926L17.3843 17.7012Z",
    fill: "#13FCE4"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M24.996 20.4182L23.9075 20.332L24.1564 20.7341L25.2739 20.8088L24.996 20.4182Z",
    fill: "#009CFF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1154 19.6079L15.9128 20.1479L15.6638 21.2451L15.9302 20.6649L16.1154 19.6079Z",
    fill: "#00A8FF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M23.526 19.1952L22.2695 19.1147L22.4143 19.7753L23.6997 19.8155L23.526 19.1952Z",
    fill: "#00CCFF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3191 18.3609L26.8948 17.8554L27.0395 17.0454L28.4813 17.6256L28.3191 18.3609Z",
    fill: "#1FFFD7"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M11.827 27.0814L11.9255 27.8799L11.0569 27.6041L10.9585 26.8057L11.827 27.0814Z",
    fill: "#000080"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1685 15.3462L25.2925 14.6569V13.7378L27.1685 14.5018V15.3462Z",
    fill: "#8DFF6A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2549 12.8588L23.0721 12.1006L23.0142 11.2217L25.1739 12.0374L25.2549 12.8588Z",
    fill: "#E1FF16"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8011 17.4143L19.5215 17.4028L19.5446 18.3679L20.8532 18.3162L20.8011 17.4143Z",
    fill: "#23FFD4"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82824 23.6176L7.93247 24.4218L7.3303 23.1983L7.22607 22.394L7.82824 23.6176Z",
    fill: "#0024FF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4378 21.3665L26.5867 21.1769L26.9283 20.9644L27.7968 21.1941L27.4378 21.3665Z",
    fill: "#0084FF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2351 25.7202L14.3335 26.5129L13.5403 26.938L13.4766 26.1281L14.2351 25.7202Z",
    fill: "#0000BB"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0824 21.4232L26.2544 21.2623L26.6018 21.1704L27.4472 21.3657L27.0824 21.4232Z",
    fill: "#0080FF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7992 21.1939L26.9307 20.9642L27.2607 20.6367L28.1466 20.9182L27.7992 21.1939Z",
    fill: "#0090FF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M26.721 21.3716L25.9104 21.228L26.252 21.2567L27.08 21.4176L26.721 21.3716Z",
    fill: "#0084FF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1588 20.9119L27.2729 20.6304L27.5798 20.1938L28.4889 20.5328L28.1588 20.9119Z",
    fill: "#00A0FF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M16.672 18.0054L16.2377 18.4132L16.1104 19.6081L16.5851 19.1485L16.672 18.0054Z",
    fill: "#0CF4EB"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58919 18.7063L6.36916 19.6139L6.12598 18.1318L6.35758 17.23L6.58919 18.7063Z",
    fill: "#13FCE4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7446 19.9303L23.6792 19.8154L23.8934 20.3324L24.982 20.4186L24.7446 19.9303Z",
    fill: "#00B8FF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2488 8.30935L15.9849 7.82682L16.0891 7.20068L18.2662 7.71193L18.2488 8.30935Z",
    fill: "#FF6000"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4637 17.6263L27.022 17.0461L27.1204 16.2017L28.5679 16.8623L28.4637 17.6263Z",
    fill: "#43FFB4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9483 14.8289L6.21875 15.7308L6.2477 14.2602L6.97146 13.3813L6.9483 14.8289Z",
    fill: "#97FF60"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6859 27.1275L12.7785 27.926L11.9158 27.88L11.8174 27.0815L12.6859 27.1275Z",
    fill: "#000084"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M15.985 7.82598L13.8774 7.54451L14.0801 6.88965L16.0951 7.20559L15.985 7.82598Z",
    fill: "#FF4E00"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9326 10.4344L20.6166 9.67617L20.5645 8.96387L22.8226 9.76234L22.9326 10.4344Z",
    fill: "#FFAB00"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3614 21.2112L25.5681 21.0791L25.8924 21.2342L26.703 21.3778L26.3614 21.2112Z",
    fill: "#008CFF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0955 17.5173L20.7927 17.4082L20.839 18.3101L22.165 18.356L22.0955 17.5173Z",
    fill: "#2CFFCA"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M28.475 20.5328L27.5718 20.1939L27.8555 19.6597L28.7761 20.056L28.475 20.5328Z",
    fill: "#00B8FF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81687 9.61326L8.42725 10.0613L8.75149 8.94691L10.0774 8.53906L9.81687 9.61326Z",
    fill: "#FF9400"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7384 8.34337L10.0767 8.53293L10.4125 7.61957L11.9932 7.47021L11.7384 8.34337Z",
    fill: "#FF6400"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3886 18.4876L22.1553 18.3555L22.2653 19.1137L23.5217 19.1942L23.3886 18.4876Z",
    fill: "#0CF4EB"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4952 16.3564L18.3488 16.3794L18.343 17.4938L19.501 17.4019L19.4952 16.3564Z",
    fill: "#50FFA7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3485 16.3857L17.4048 16.5236L17.3816 17.7012L18.3427 17.5001L18.3485 16.3857Z",
    fill: "#4DFFAA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1751 14.4954L25.2991 13.7314L25.2585 12.8525L27.123 13.6797L27.1751 14.4954Z",
    fill: "#B4FF43"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M15.628 21.8828L15.7844 22.5492L15.3212 23.5487L15.2285 22.8479L15.628 21.8828Z",
    fill: "#0058FF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5565 8.9637L18.2405 8.30884L18.2521 7.71143L20.4928 8.39501L20.5565 8.9637Z",
    fill: "#FF6F00"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21457 22.3939L7.31879 23.1981L6.82663 21.8539L6.72241 21.0439L7.21457 22.3939Z",
    fill: "#0068FF"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1694 12.0373L23.0097 11.2216L22.9229 10.4346L25.0478 11.302L25.1694 12.0373Z",
    fill: "#FFE200"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3264 23.5493L15.5406 24.2501L14.9268 25.0888L14.7705 24.3593L15.3264 23.5493Z",
    fill: "#0014FF"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9024 20.1421L15.9313 20.7395L15.6187 21.8769L15.6476 21.2393L15.9024 20.1421Z",
    fill: "#00A0FF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0456 20.9406L25.2698 20.8027L25.5767 21.0785L26.3699 21.2106L26.0456 20.9406Z",
    fill: "#009CFF"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7783 16.4432L19.5103 16.3628L19.516 17.4083L20.7956 17.4198L20.7783 16.4432Z",
    fill: "#53FFA4"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7673 20.0623L27.8467 19.6659L28.0957 19.0513L29.0279 19.5166L28.7673 20.0623Z",
    fill: "#00D4FF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8757 7.54537L11.9998 7.47643L12.3008 6.78711L14.0784 6.89051L13.8757 7.54537Z",
    fill: "#FF3F00"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18867 11.3076L7.12329 11.9911L7.38964 10.7102L8.42028 10.061L8.18867 11.3076Z",
    fill: "#FFD300"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4062 16.5176L16.7172 16.7646L16.6709 18.0054L17.3773 17.6952L17.4062 16.5176Z",
    fill: "#49FFAD"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M24.56 19.35L23.5178 19.2007L23.6915 19.8211L24.7569 19.936L24.56 19.35Z",
    fill: "#00DCFE"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5723 16.8568L27.1248 16.1962L27.1769 15.3403L28.6302 16.0756L28.5723 16.8568Z",
    fill: "#66FF90"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2294 18.4131L16.0673 18.9071L15.8936 20.1479L16.0962 19.6079L16.2294 18.4131Z",
    fill: "#09F0EE"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5271 26.9316L13.6197 27.7301L12.7801 27.9197L12.6875 27.1212L13.5271 26.9316Z",
    fill: "#00009B"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9275 25.0884L15.0549 25.8639L14.3311 26.5072L14.2327 25.7145L14.9275 25.0884Z",
    fill: "#0000E8"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7644 20.5673L25.0059 20.418L25.2838 20.8028L26.0597 20.9407L25.7644 20.5673Z",
    fill: "#00B0FF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0299 19.5102L28.0977 19.0449L28.3003 18.3613L29.2441 18.8956L29.0299 19.5102Z",
    fill: "#0CF4EB"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3028 17.712L22.0869 17.5225L22.1564 18.3611L23.3897 18.4933L23.3028 17.712Z",
    fill: "#33FFC4"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0612 16.6209L20.77 16.4429L20.7874 17.4137L22.0902 17.5171L22.0612 16.6209Z",
    fill: "#56FFA0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2647 7.71187L16.0876 7.20062L16.2034 6.7583L18.2763 7.29253L18.2647 7.71187Z",
    fill: "#FF3B00"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2168 27.1044L10.3731 27.8167L9.56251 27.1159L9.40039 26.3921L10.2168 27.1044Z",
    fill: "#0000A8"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1127 13.6859L25.2483 12.8587L25.1672 12.043L27.0143 12.9276L27.1127 13.6859Z",
    fill: "#D7FF1F"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8179 9.76267L20.5598 8.9642L20.4961 8.39551L22.6848 9.2227L22.8179 9.76267Z",
    fill: "#FF8600"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37562 26.3981L9.53775 27.1219L8.78503 26.2315L8.61133 25.502L9.37562 26.3981Z",
    fill: "#0000CD"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3421 17.2245L6.1105 18.1264L6.00049 16.6271L6.23209 15.731L6.3421 17.2245Z",
    fill: "#53FFA4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7221 16.7646L16.311 17.1151L16.2473 18.4133L16.6816 18.0054L16.7221 16.7646Z",
    fill: "#46FFB1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0765 7.20029L14.0615 6.88435L14.2931 6.4248L16.1923 6.75798L16.0765 7.20029Z",
    fill: "#FF2900"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73207 21.0441L6.83629 21.8541L6.45994 20.4295L6.35571 19.6138L6.73207 21.0441Z",
    fill: "#00B0FF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M19.501 15.2656L18.3488 15.2139L18.343 16.3857L19.4894 16.3627L19.501 15.2656Z",
    fill: "#80FF77"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0591 27.6044L11.2038 28.3167L10.3585 27.8227L10.2021 27.1104L11.0591 27.6044Z",
    fill: "#000092"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0553 11.3017L22.9303 10.4343L22.8203 9.76221L24.899 10.6698L25.0553 11.3017Z",
    fill: "#FFB900"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3482 15.2139L17.3986 15.2771L17.3928 16.5178L18.3366 16.38L18.3482 15.2139Z",
    fill: "#80FF77"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4115 18.6888L23.3809 18.4878L23.514 19.1944L24.5563 19.3437L24.4115 18.6888Z",
    fill: "#16FFE1"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4982 8.40065L18.2632 7.71707L18.2748 7.29199L20.4229 7.9928L20.4982 8.40065Z",
    fill: "#FF4E00"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M28.635 16.0753L27.1816 15.34V14.4956L28.635 15.2998V16.0753Z",
    fill: "#8AFF6D"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97694 13.381L6.25317 14.2599L6.4153 12.8467L7.12169 11.9966L6.97694 13.381Z",
    fill: "#D7FF1F"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62408 25.496L8.79778 26.2255L8.11455 25.1628L7.93506 24.416L8.62408 25.496Z",
    fill: "#0000FF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5018 20.1025L24.7549 19.9302L24.9923 20.4184L25.7508 20.5678L25.5018 20.1025Z",
    fill: "#00C8FF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7841 15.426L19.5104 15.2651L19.4988 16.3566L20.7668 16.437L20.7841 15.426Z",
    fill: "#80FF77"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2485 18.896L28.3047 18.3617L28.461 17.6265L29.4106 18.2296L29.2485 18.896Z",
    fill: "#29FFCE"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9899 7.47583L10.4092 7.62519L10.8145 6.90139L12.2968 6.78076L11.9899 7.47583Z",
    fill: "#FF3000"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0737 8.53884L8.7478 8.94669L9.16469 7.99887L10.4096 7.62549L10.0737 8.53884Z",
    fill: "#FF5900"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4498 21.6361L27.0676 21.4235L27.4324 21.3604L27.8203 21.5959L27.4498 21.6361Z",
    fill: "#0098FF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8165 21.596L27.4343 21.3662L27.7933 21.1938L28.187 21.4638L27.8165 21.596Z",
    fill: "#009CFF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9176 27.8802L12.0565 28.5868L11.1938 28.3168L11.0491 27.6045L11.9176 27.8802Z",
    fill: "#000084"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0888 21.567L26.7124 21.3774L27.0714 21.4291L27.4477 21.6359L27.0888 21.567Z",
    fill: "#0098FF"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4171 15.2769L16.728 15.4549V16.7646L17.4171 16.5176V15.2769Z",
    fill: "#80FF77"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2045 21.4636L27.8108 21.1936L28.1582 20.9121L28.5519 21.2281L28.2045 21.4636Z",
    fill: "#00A4FF"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9423 20.7456L16.1507 21.3775L15.786 22.5436L15.6296 21.883L15.9423 20.7456Z",
    fill: "#009CFF"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3382 26.5132L14.4308 27.3174L13.6376 27.7367L13.5449 26.9383L14.3382 26.5132Z",
    fill: "#0000BB"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7945 22.5488L16.0609 23.2209L15.5455 24.2549L15.3313 23.5541L15.7945 22.5488Z",
    fill: "#0054FF"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0642 6.88476L12.2866 6.78136L12.6282 6.29883L14.29 6.42521L14.0642 6.88476Z",
    fill: "#FF1600"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2743 16.8796L22.0642 16.6211L22.0932 17.5172L23.3091 17.7068L23.2743 16.8796Z",
    fill: "#5AFF9D"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7447 21.3948L26.3799 21.2109L26.7273 21.3718L27.1036 21.5613L26.7447 21.3948Z",
    fill: "#00A0FF"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93103 24.4218L8.11052 25.1686L7.51993 23.9622L7.32886 23.1982L7.93103 24.4218Z",
    fill: "#0028FF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0673 18.9077L16.1367 19.4649L15.9225 20.7459L15.8936 20.1485L16.0673 18.9077Z",
    fill: "#06ECF1"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0316 12.9275L25.1846 12.0429L25.063 11.3076L26.8811 12.244L27.0316 12.9275Z",
    fill: "#FBF100"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 15.6848L20.7816 15.4263L20.77 16.443L22.0612 16.6211L22.0786 15.6848Z",
    fill: "#80FF77"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5485 21.2224L28.1548 20.9065L28.4848 20.5273L28.8843 20.8892L28.5485 21.2224Z",
    fill: "#00B4FF"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3176 19.5568L24.5823 19.3442L24.7791 19.9244L25.5261 20.0968L25.3176 19.5568Z",
    fill: "#02E8F4"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7014 9.22234L20.5128 8.39516L20.4375 7.9873L22.5509 8.83173L22.7014 9.22234Z",
    fill: "#FF6400"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42207 10.0607L7.39722 10.7098L7.77937 9.56094L8.75211 8.94629L8.42207 10.0607Z",
    fill: "#FF9100"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4139 18.2356L28.4644 17.6267L28.5744 16.8569L29.5297 17.5348L29.4139 18.2356Z",
    fill: "#46FFB1"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3201 17.9709L23.301 17.7124L23.3879 18.4879L24.4185 18.6889L24.3201 17.9709Z",
    fill: "#39FFBE"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2745 7.29209L16.2017 6.75787L16.329 6.5166L18.2861 7.05083L18.2745 7.29209Z",
    fill: "#FF2200"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6302 15.3001L27.1769 14.4959L27.1248 13.6802L28.5723 14.5476L28.6302 15.3001Z",
    fill: "#ADFF49"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3017 17.1152L16.1628 17.5576L16.0759 18.9075L16.238 18.4135L16.3017 17.1152Z",
    fill: "#43FFB4"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4024 21.1306L26.0376 20.9468L26.3618 21.2168L26.7266 21.4006L26.4024 21.1306Z",
    fill: "#00B0FF"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9107 10.6702L22.8321 9.76263L22.6931 9.22266L24.7197 10.159L24.9107 10.6702Z",
    fill: "#FF9800"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5554 24.25L15.7059 25.014L15.069 25.8699L14.9417 25.0944L15.5554 24.25Z",
    fill: "#0014FF"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5299 14.1507L18.3603 14.0186L18.3545 15.2134L19.5067 15.2651L19.5299 14.1507Z",
    fill: "#B4FF43"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8753 20.895L28.4758 20.5331L28.7711 20.062L29.1764 20.4814L28.8753 20.895Z",
    fill: "#00C8FF"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7884 27.9258L12.9158 28.6324L12.0589 28.5864L11.9199 27.8799L12.7884 27.9258Z",
    fill: "#00008D"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4228 7.99346L18.2747 7.29265L18.2862 7.05713L20.3301 7.76369L20.4228 7.99346Z",
    fill: "#FF3800"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36348 19.6139L6.47349 20.4296L6.22451 18.9533L6.1145 18.1318L6.36348 19.6139Z",
    fill: "#13FCE4"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8359 14.392L19.5446 14.145L19.5215 15.2594L20.7953 15.4203L20.8359 14.392Z",
    fill: "#ADFF49"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3543 14.0193L17.3816 14.0078L17.399 15.2831L18.3485 15.2199L18.3543 14.0193Z",
    fill: "#B7FF40"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2062 6.7578L14.3013 6.42463L14.5502 6.17188L16.3336 6.51654L16.2062 6.7578Z",
    fill: "#F60B00"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7268 15.4551L16.3157 15.7423V17.1152L16.7268 16.7648V15.4551Z",
    fill: "#80FF77"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23209 15.7307L6.00049 16.6268L6.02944 15.1448L6.26104 14.2544L6.23209 15.7307Z",
    fill: "#97FF60"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1095 20.7684L25.7505 20.5674L26.04 20.9408L26.4048 21.1246L26.1095 20.7684Z",
    fill: "#00C0FF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32883 23.1987L7.51411 23.9569L7.02774 22.63L6.83667 21.8545L7.32883 23.1987Z",
    fill: "#0068FF"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1519 18.9475L24.4224 18.689L24.5671 19.3496L25.3025 19.5621L25.1519 18.9475Z",
    fill: "#1FFFD7"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1678 20.4815L28.7625 20.0622L29.023 19.5107L29.4341 19.9875L29.1678 20.4815Z",
    fill: "#00E0FB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2859 16.0235L22.0758 15.6846L22.0642 16.6209L23.2743 16.8794L23.2859 16.0235Z",
    fill: "#80FF77"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5337 17.5343L28.5784 16.8564L28.6305 16.0752L29.5858 16.8162L29.5337 17.5343Z",
    fill: "#66FF90"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8775 12.2381L25.0594 11.3018L24.9031 10.6699L26.6864 11.6465L26.8775 12.2381Z",
    fill: "#FFCC00"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1306 14.7368L20.822 14.3921L20.7815 15.4261L22.0785 15.6846L22.1306 14.7368Z",
    fill: "#AAFF4D"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4003 14.001L16.6824 14.1101L16.7229 15.4543L17.4119 15.2762L17.4003 14.001Z",
    fill: "#BAFF3C"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2801 17.2068L23.2668 16.8794L23.3016 17.7066L24.3206 17.9651L24.2801 17.2068Z",
    fill: "#5AFF9D"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5464 8.83776L20.433 7.99333L20.3462 7.75781L22.3727 8.60224L22.5464 8.83776Z",
    fill: "#FF4E00"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1312 11.991L6.4248 12.8469L6.7201 11.5314L7.39754 10.71L7.1312 11.991Z",
    fill: "#FFD000"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5679 14.5475L27.1204 13.6801L27.022 12.9219L28.4521 13.841L28.5679 14.5475Z",
    fill: "#D1FF26"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2865 6.78673L10.8101 6.90736L11.2675 6.39611L12.6339 6.3042L12.2865 6.78673Z",
    fill: "#F10800"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8742 20.3261L25.521 20.1021L25.77 20.5673L26.129 20.7684L25.8742 20.3261Z",
    fill: "#00D8FF"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0592 25.8691L15.1519 26.6791L14.4281 27.3225L14.3354 26.5183L15.0592 25.8691Z",
    fill: "#0000ED"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7161 10.1585L22.6895 9.22216L22.5332 8.83154L24.496 9.77937L24.7161 10.1585Z",
    fill: "#FF7A00"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3136 6.42529L12.6519 6.29891L13.0282 6.03467L14.5626 6.17253L14.3136 6.42529Z",
    fill: "#DF0000"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5646 13.042L18.3545 12.8237V14.0128L19.5241 14.1449L19.5646 13.042Z",
    fill: "#E4FF13"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 7.05686L16.3286 6.51689L16.4618 6.48242L18.303 7.01091L18.2857 7.05686Z",
    fill: "#FA0F00"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4055 7.62527L9.16064 7.99866L9.65859 7.24614L10.8166 6.90723L10.4055 7.62527Z",
    fill: "#FF2500"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4475 19.9928L29.0364 19.516L29.2506 18.9014L29.6617 19.4413L29.4475 19.9928Z",
    fill: "#16FFE1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6298 27.7363L13.7457 28.4486L12.9177 28.6325L12.7903 27.9259L13.6298 27.7363Z",
    fill: "#00009F"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3301 7.75751L18.2861 7.05095L18.2977 7.01074L20.2374 7.70581L20.3301 7.75751Z",
    fill: "#FF2500"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9051 13.3752L19.585 13.042L19.5444 14.1507L20.8356 14.3977L20.9051 13.3752Z",
    fill: "#DBFF1C"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3604 12.8243L17.3472 12.7324L17.3877 14.0019L18.3604 14.0134V12.8243Z",
    fill: "#EBFF0C"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M16.142 19.4648L16.3852 20.068L16.1362 21.3835L15.9277 20.7516L16.142 19.4648Z",
    fill: "#02E8F4"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0433 18.2809L24.3196 17.9707L24.4122 18.6887L25.1418 18.9472L25.0433 18.2809Z",
    fill: "#3CFFBA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1595 21.3774L16.4664 22.0208L16.0669 23.2214L15.8005 22.5493L16.1595 21.3774Z",
    fill: "#0098FF"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1628 17.5576L16.2554 18.0746L16.1454 19.4648L16.0759 18.9075L16.1628 17.5576Z",
    fill: "#43FFB4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3256 6.51829L14.5422 6.17363L14.8086 6.13916L16.4588 6.48382L16.3256 6.51829Z",
    fill: "#DF0000"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3494 27.8224L10.5 28.4198L9.70673 27.7305L9.53882 27.1216L10.3494 27.8224Z",
    fill: "#0000B2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5909 16.8163L28.6355 16.0753V15.2998L29.5851 16.1098L29.5909 16.8163Z",
    fill: "#8AFF6D"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54666 27.1163L9.71458 27.7252L8.97344 26.8521L8.79395 26.2202L9.54666 27.1163Z",
    fill: "#0000DA"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3548 15.1562L22.1331 14.7368L22.0752 15.6846L23.2853 16.0236L23.3548 15.1562Z",
    fill: "#A7FF50"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3062 15.7422L16.1672 16.1328V17.5574L16.3062 17.1151V15.7422Z",
    fill: "#80FF77"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6516 19.8151L25.3042 19.5566L25.5069 20.1024L25.8601 20.3264L25.6516 19.8151Z",
    fill: "#0CF4EB"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3643 21.883L27.4685 21.636L27.8391 21.6016L27.729 21.8715L27.3643 21.883Z",
    fill: "#00A8FF"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6722 11.6465L24.8888 10.6699L24.6978 10.1587L26.4406 11.1582L26.6722 11.6465Z",
    fill: "#FFAB00"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83485 21.86L7.02593 22.6298L6.65536 21.2224L6.4585 20.4297L6.83485 21.86Z",
    fill: "#00B0FF"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2339 13.8006L20.8964 13.3755L20.8269 14.398L22.1355 14.7426L22.2339 13.8006Z",
    fill: "#D4FF23"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9878 21.7967L27.0862 21.5669L27.451 21.6358L27.3468 21.8828L26.9878 21.7967Z",
    fill: "#00ACFF"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74813 8.94722L7.77539 9.55613L8.26176 8.57384L9.16502 7.99365L8.74813 8.94722Z",
    fill: "#FF5500"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1105 18.1259L6.22051 18.9531L6.1105 17.4595L6.00049 16.6323L6.1105 18.1259Z",
    fill: "#53FFA4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1859 28.3163L11.3191 28.9079L10.4911 28.4254L10.3406 27.8223L11.1859 28.3163Z",
    fill: "#00009B"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3621 8.60218L20.3356 7.75775L20.2429 7.70605L22.1826 8.53899L22.3621 8.60218Z",
    fill: "#FF3F00"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7195 21.8717L27.8295 21.6017L28.1943 21.4639L28.0785 21.7626L27.7195 21.8717Z",
    fill: "#00ACFF"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6816 14.1108L16.2473 14.3406L16.311 15.748L16.7221 15.4608L16.6816 14.1108Z",
    fill: "#BEFF39"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0534 23.2217L16.2271 23.9684L15.6886 25.0139L15.5381 24.2499L16.0534 23.2217Z",
    fill: "#0050FF"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2975 16.426L23.2842 16.0239L23.2668 16.8856L24.2801 17.213L24.2975 16.426Z",
    fill: "#80FF77"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6545 19.4358L29.2434 18.8958L29.4113 18.2295L29.8224 18.8327L29.6545 19.4358Z",
    fill: "#30FFC7"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4585 13.8468L27.0283 12.9277L26.8835 12.2441L28.2963 13.2149L28.4585 13.8468Z",
    fill: "#F1FC06"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6438 21.619L26.7422 21.395L27.0954 21.5674L26.997 21.7971L26.6438 21.619Z",
    fill: "#00B4FF"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77966 26.2254L8.95916 26.8573L8.2933 25.8176L8.09644 25.1685L8.77966 26.2254Z",
    fill: "#0000FF"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4874 9.78551L22.5245 8.83769L22.3508 8.60791L24.2442 9.55573L24.4874 9.78551Z",
    fill: "#FF6400"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0862 21.7623L28.202 21.4635L28.5552 21.228L28.4394 21.5669L28.0862 21.7623Z",
    fill: "#00B8FF"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6282 11.9735L18.366 11.6748V12.8294L19.5761 13.0477L19.6282 11.9735Z",
    fill: "#FFD700"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M17.361 12.7324L16.6025 12.7669L16.6894 14.1111L17.4074 14.0019L17.361 12.7324Z",
    fill: "#F1FC06"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2954 7.0109L16.4541 6.48242L16.5931 6.65475L18.3069 7.166L18.2954 7.0109Z",
    fill: "#ED0400"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2371 7.70581L18.2974 7.01074L18.3089 7.16584L20.1444 7.83793L20.2371 7.70581Z",
    fill: "#FF1E00"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9872 12.3935L19.6207 11.9741L19.5686 13.0426L20.8888 13.3757L20.9872 12.3935Z",
    fill: "#FFE200"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3228 21.3548L26.4154 21.125L26.7454 21.395L26.647 21.619L26.3228 21.3548Z",
    fill: "#00C0FF"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26627 14.2544L6.03467 15.1448L6.20837 13.7202L6.43419 12.8413L6.26627 14.2544Z",
    fill: "#D7FF1F"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0722 28.5869L12.188 29.1728L11.3426 28.9028L11.2095 28.3169L12.0722 28.5869Z",
    fill: "#000092"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M18.35 11.6753L17.2788 11.5029L17.3425 12.7322L18.3558 12.8241V11.6753H18.35Z",
    fill: "#FFCC00"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4302 21.5614L28.546 21.2225L28.876 20.895L28.7544 21.2741L28.4302 21.5614Z",
    fill: "#00C4FF"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0034 17.5804L24.2854 17.207L24.3259 17.971L25.0497 18.2812L25.0034 17.5804Z",
    fill: "#5DFF9A"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4805 19.2465L25.1331 18.9478L25.2894 19.5624L25.6368 19.8209L25.4805 19.2465Z",
    fill: "#26FFD1"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5804 16.1099L28.625 15.3L28.5671 14.5532L29.5167 15.4206L29.5804 16.1099Z",
    fill: "#AAFF4D"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5529 6.17184L13.0186 6.03398L13.4181 5.99951L14.8135 6.13738L14.5529 6.17184Z",
    fill: "#C80000"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4139 27.3174L14.5239 28.0354L13.7423 28.449L13.6265 27.7367L14.4139 27.3174Z",
    fill: "#0000C4"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0146 21.0098L26.1073 20.7686L26.4026 21.1247L26.3099 21.3545L26.0146 21.0098Z",
    fill: "#00D0FF"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6345 6.29902L11.2681 6.39668L11.7718 6.1152L13.0167 6.04053L12.6345 6.29902Z",
    fill: "#CD0000"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4701 14.3058L22.231 13.8003L22.1326 14.7366L23.3543 15.156L23.4701 14.3058Z",
    fill: "#CEFF29"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M22.179 8.53899L20.2393 7.70605L20.1409 7.83818L21.9821 8.64239L22.179 8.53899Z",
    fill: "#FF3800"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M22.372 12.9047L20.9997 12.3877L20.8955 13.3757L22.233 13.8066L22.372 12.9047Z",
    fill: "#FBF100"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8369 18.8382L29.4258 18.235L29.5358 17.5342L29.9469 18.2005L29.8369 18.8382Z",
    fill: "#4DFFAA"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11329 25.1629L8.31016 25.812L7.73115 24.6286L7.52271 23.9565L8.11329 25.1629Z",
    fill: "#0030FF"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4778 6.48382L14.8276 6.13916L15.0998 6.32872L16.6168 6.65615L16.4778 6.48382Z",
    fill: "#D10000"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4593 11.1579L24.7164 10.1584L24.5022 9.7793L26.1987 10.7903L26.4593 11.1579Z",
    fill: "#FF9100"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6828 25.0137L15.7755 25.8236L15.1385 26.6738L15.0459 25.8638L15.6828 25.0137Z",
    fill: "#0014FF"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6862 10.9743L18.3545 10.5952V11.6809L19.6167 11.9796L19.6862 10.9743Z",
    fill: "#FFA700"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7397 21.2737L28.8613 20.8946L29.1624 20.481L29.0408 20.9118L28.7397 21.2737Z",
    fill: "#00D8FF"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3669 15.633L23.3478 15.1562L23.2783 16.0237L24.2916 16.4258L24.3669 15.633Z",
    fill: "#A4FF53"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2569 9.55007L22.3635 8.60225L22.1782 8.53906L24.0021 9.4754L24.2569 9.55007Z",
    fill: "#FF5500"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2813 13.2089L26.8686 12.2439L26.6775 11.6465L28.0671 12.6517L28.2813 13.2089Z",
    fill: "#FFDB00"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 7.83811L18.3203 7.16602L18.3319 7.51642L20.0515 8.15405L20.15 7.83811Z",
    fill: "#FF1E00"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38838 10.7099L6.71094 11.5314L7.13362 10.3538L7.76474 9.56104L7.38838 10.7099Z",
    fill: "#FF8D00"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1081 11.4739L19.6837 10.9741L19.6143 11.9736L20.9807 12.393L21.1081 11.4739Z",
    fill: "#FFB600"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3279 7.16604L16.614 6.65479L16.753 7.03391L18.3453 7.5107L18.3279 7.16604Z",
    fill: "#F10800"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M10.816 6.90724L9.66382 7.24616L10.2312 6.70619L11.2793 6.396L10.816 6.90724Z",
    fill: "#E40000"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7734 20.5847L25.8603 20.3262L26.1151 20.7685L26.0224 21.0098L25.7734 20.5847Z",
    fill: "#02E8F4"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2821 11.5032L16.4541 11.4688L16.5815 12.7727L17.34 12.7383L17.2821 11.5032Z",
    fill: "#FFC100"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3724 10.5893L17.2202 10.3423L17.3013 11.5026L18.3724 11.675V10.5893Z",
    fill: "#FF9800"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9195 28.6324L13.0237 29.2183L12.1842 29.1724L12.0684 28.5864L12.9195 28.6324Z",
    fill: "#000096"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5909 12.7666L16.1104 12.9332L16.2435 14.3348L16.6778 14.105L16.5909 12.7666Z",
    fill: "#F8F500"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4046 18.6259L25.063 18.2812L25.1614 18.9476L25.5088 19.2463L25.4046 18.6259Z",
    fill: "#43FFB4"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4507 20.4299L6.64757 21.2226L6.40438 19.7636L6.20752 18.9536L6.4507 20.4299Z",
    fill: "#13FCE4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9778 8.64211L20.1365 7.83789L20.0381 8.14809L21.7867 8.91209L21.9778 8.64211Z",
    fill: "#FF3800"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M16.238 14.3408L16.0759 14.6797L16.1628 16.1388L16.3017 15.7482L16.238 14.3408Z",
    fill: "#C1FF36"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0207 16.8624L24.3028 16.4258L24.2854 17.2128L25.0034 17.5861L25.0207 16.8624Z",
    fill: "#80FF77"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7673 10.0665L18.3545 9.60693L18.3603 10.5892L19.692 10.9683L19.7673 10.0665Z",
    fill: "#FF7E00"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0593 20.9064L29.1867 20.4756L29.4473 19.9873L29.3199 20.4698L29.0593 20.9064Z",
    fill: "#09F0EE"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1672 16.1328L16.2599 16.6096V18.0744L16.1672 17.5574V16.1328Z",
    fill: "#83FF73"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 12.0715L21.1157 11.4741L20.9883 12.3932L22.3605 12.9102L22.5342 12.0715Z",
    fill: "#FFC400"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0515 8.14848L18.3318 7.5166L18.3434 8.05083L19.953 8.63676L20.0515 8.14848Z",
    fill: "#FF2900"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2602 18.0747L16.5266 18.6434L16.3992 20.0622L16.156 19.4591L16.2602 18.0747Z",
    fill: "#40FFB7"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2635 10.6466L19.7696 10.0664L19.6943 10.974L21.1187 11.4738L21.2635 10.6466Z",
    fill: "#FF9100"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5068 15.4153L28.5572 14.5479L28.4414 13.8413L29.3794 14.7604L29.5068 15.4153Z",
    fill: "#CAFF2C"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9511 18.2004L29.54 17.5341L29.5979 16.8218L30.009 17.5513L29.9511 18.2004Z",
    fill: "#6AFF8D"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6363 13.496L22.3741 12.9043L22.2351 13.8004L23.4742 14.3059L23.6363 13.496Z",
    fill: "#F1FC06"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M16.405 20.062L16.7408 20.6824L16.4629 22.0209L16.156 21.3775L16.405 20.062Z",
    fill: "#00E4F8"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1851 10.7958L24.4886 9.77909L24.2512 9.54932L25.9014 10.5661L26.1851 10.7958Z",
    fill: "#FF7A00"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 9.4754L22.1752 8.53906L21.9841 8.64246L23.7327 9.55007L23.9991 9.4754Z",
    fill: "#FF4E00"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M18.343 7.51633L16.7507 7.03955L16.8839 7.61399L18.3488 8.05056L18.343 7.51633Z",
    fill: "#FF1300"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6086 6.65507L15.0916 6.32764L15.3637 6.73549L16.7475 7.03994L16.6086 6.65507Z",
    fill: "#D60000"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8599 9.27995L18.3545 8.75146L18.3603 9.60738L19.7731 10.0669L19.8599 9.27995Z",
    fill: "#FF5900"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00049 16.6271L6.1105 17.4543L6.13945 15.978L6.02944 15.145L6.00049 16.6271Z",
    fill: "#97FF60"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9527 8.63671L18.343 8.05078L18.3546 8.7516L19.86 9.28008L19.9527 8.63671Z",
    fill: "#FF3B00"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51689 23.9568L7.71954 24.6347L7.24475 23.3364L7.03052 22.6299L7.51689 23.9568Z",
    fill: "#0070FF"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 20.1026L25.6435 19.8154L25.8519 20.3267L25.7651 20.5852L25.5566 20.1026Z",
    fill: "#16FFE1"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8038 8.91781L20.0552 8.15381L19.9568 8.63633L21.6185 9.34863L21.8038 8.91781Z",
    fill: "#FF4300"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3623 9.60696L17.1174 9.29102L17.2159 10.3422L18.3681 10.5892L18.3623 9.60696Z",
    fill: "#FF6C00"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4357 9.92879L19.8608 9.27393L19.7739 10.0609L21.2678 10.6411L21.4357 9.92879Z",
    fill: "#FF6F00"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5046 14.8634L23.474 14.3062L23.3582 15.1563L24.3772 15.6331L24.5046 14.8634Z",
    fill: "#C7FF30"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17132 7.99898L8.26807 8.57341L8.84708 7.78644L9.66927 7.24072L9.17132 7.99898Z",
    fill: "#FF1E00"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8206 6.13738L13.4194 5.99951L13.8305 6.19482L15.0928 6.32694L14.8206 6.13738Z",
    fill: "#BB0000"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0597 12.6519L26.6701 11.6466L26.4385 11.1641L27.7991 12.1923L28.0597 12.6519Z",
    fill: "#FFBD00"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6199 9.34853L19.9581 8.63623L19.8655 9.2796L21.4404 9.93446L21.6199 9.34853Z",
    fill: "#FF5500"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4527 22.0205L16.6438 22.7558L16.2269 23.9679L16.0532 23.2211L16.4527 22.0205Z",
    fill: "#0098FF"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3314 8.05034L16.8665 7.61377L16.988 8.37203L18.3429 8.75116L18.3314 8.05034Z",
    fill: "#FF2900"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3528 8.7512L17.0037 8.37207L17.1195 9.29117L18.3643 9.60711L18.3528 8.7512Z",
    fill: "#FF4700"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7407 11.3248L21.27 10.647L21.1252 11.4742L22.5438 12.0716L22.7407 11.3248Z",
    fill: "#FFA300"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2132 10.3422L16.3042 10.2388L16.4721 11.4623L17.3001 11.4968L17.2132 10.3422Z",
    fill: "#FF8900"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3003 20.4695L29.4277 19.987L29.6477 19.4355L29.5145 19.9698L29.3003 20.4695Z",
    fill: "#1CFFDB"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7512 9.54921L22.0026 8.6416L21.8115 8.91159L23.4849 9.77899L23.7512 9.54921Z",
    fill: "#FF5200"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3475 17.9822L25.0059 17.5801L25.0464 18.2809L25.388 18.6256L25.3475 17.9822Z",
    fill: "#60FF97"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4255 22.0669L26.9988 21.7969L27.3577 21.883L26.7729 22.1645L26.4255 22.0669Z",
    fill: "#00BCFF"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0108 6.03425L11.7717 6.11531L12.3044 6.06899L13.4103 5.99951L13.0108 6.03425Z",
    fill: "#B20000"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7693 22.165L27.3541 21.8836L27.7189 21.8721L27.1225 22.1708L26.7693 22.165Z",
    fill: "#00B8FF"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1505 26.6738L15.2547 27.4034L14.5368 28.0352L14.4268 27.3172L15.1505 26.6738Z",
    fill: "#0000F1"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0718 21.8829L26.6392 21.6187L26.9866 21.7967L26.4134 22.0667L26.0718 21.8829Z",
    fill: "#00C4FF"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M23.833 12.7439L22.536 12.0718L22.3623 12.9047L23.6303 13.4964L23.833 12.7439Z",
    fill: "#FFD700"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0959 16.1499L24.3721 15.6387L24.2969 16.4314L25.0148 16.8737L25.0959 16.1499Z",
    fill: "#A0FF56"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M25.915 10.566L24.2648 9.54929L24.01 9.47461L25.6023 10.4741L25.915 10.566Z",
    fill: "#FF6F00"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7493 7.03932L15.3655 6.73486L15.6318 7.34951L16.8825 7.61375L16.7493 7.03932Z",
    fill: "#E40000"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M22.976 10.6817L21.4416 9.9292L21.2737 10.6415L22.7444 11.3193L22.976 10.6817Z",
    fill: "#FF8200"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4431 12.8467L6.21729 13.7256L6.52995 12.3987L6.7384 11.5312L6.4431 12.8467Z",
    fill: "#FFD000"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7495 28.4487L13.8364 29.0404L13.02 29.2185L12.9158 28.6326L13.7495 28.4487Z",
    fill: "#0000A8"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4548 11.4688L15.9048 11.5721L16.1016 12.9336L16.5822 12.767L16.4548 11.4688Z",
    fill: "#FFB900"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4182 19.5678L25.5051 19.2461L25.6614 19.8148L25.5745 20.102L25.4182 19.5678Z",
    fill: "#30FFC7"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1248 22.1701L27.7211 21.8714L28.0859 21.7622L27.478 22.0896L27.1248 22.1701Z",
    fill: "#00BCFF"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0026 17.5458L29.5915 16.8163L29.5857 16.104L29.9968 16.891L30.0026 17.5458Z",
    fill: "#87FF70"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4758 9.78537L21.8025 8.91797L21.6172 9.3488L23.221 10.1645L23.4758 9.78537Z",
    fill: "#FF5900"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3877 14.7662L28.4497 13.8471L28.2817 13.2095L29.2082 14.1745L29.3877 14.7662Z",
    fill: "#E7FF0F"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7622 21.6192L26.3181 21.355L26.6423 21.6192L26.0749 21.8835L25.7622 21.6192Z",
    fill: "#00D0FF"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2067 10.1643L21.6028 9.34863L21.4233 9.92882L22.9577 10.6813L23.2067 10.1643Z",
    fill: "#FF6C00"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1119 9.2911L16.0986 9.12451L16.2955 10.2389L17.2045 10.3423L17.1119 9.2911Z",
    fill: "#FF5D00"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5032 28.4199L10.6074 28.8737L9.83734 28.2074L9.70996 27.7363L10.5032 28.4199Z",
    fill: "#0000C4"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6823 14.1342L23.6343 13.4966L23.4722 14.3065L24.5028 14.8637L24.6823 14.1342Z",
    fill: "#E7FF0F"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4685 22.0895L28.0765 21.7621L28.4239 21.561L27.8043 21.9172L27.4685 22.0895Z",
    fill: "#00C4FF"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M27.819 12.1919L26.4583 11.1637L26.1978 10.8018L27.5295 11.8415L27.819 12.1919Z",
    fill: "#FFA700"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8693 7.61385L15.6187 7.34961L15.8676 8.15382L16.9967 8.37211L16.8693 7.61385Z",
    fill: "#FF1300"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70214 27.7309L9.82952 28.202L9.11155 27.3518L8.9668 26.8521L9.70214 27.7309Z",
    fill: "#0000E8"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54 19.9699L29.6732 19.4357L29.8411 18.8325L29.708 19.4184L29.54 19.9699Z",
    fill: "#36FFC1"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4868 21.2802L26.0369 21.0103L26.3322 21.3549L25.7763 21.6192L25.4868 21.2802Z",
    fill: "#00E0FB"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9939 8.37209L15.8706 8.15381L16.0964 9.13035L17.1097 9.29694L16.9939 8.37209Z",
    fill: "#FF3400"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M16.102 12.9331L15.8936 13.2203L16.0673 14.6737L16.2294 14.3347L16.102 12.9331Z",
    fill: "#FBF100"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2308 23.9683L16.3176 24.784L15.7792 25.8237L15.6865 25.0137L16.2308 23.9683Z",
    fill: "#0054FF"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2843 6.39671L10.2363 6.70691L10.8559 6.40245L11.7823 6.11523L11.2843 6.39671Z",
    fill: "#BB0000"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0882 6.32743L13.8318 6.19531L14.2429 6.62039L15.3662 6.73528L15.0882 6.32743Z",
    fill: "#BF0000"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0851 12.0772L22.7476 11.3247L22.5449 12.0715L23.8419 12.7436L24.0851 12.0772Z",
    fill: "#FFB600"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5889 10.4741L23.9966 9.47461L23.7361 9.55503L25.2763 10.5316L25.5889 10.4741Z",
    fill: "#FF6800"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3285 28.9029L11.4095 29.3453L10.6047 28.8742L10.5005 28.4204L11.3285 28.9029Z",
    fill: "#0000AD"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04586 22.63L7.2601 23.3308L6.90111 21.9522L6.67529 21.2227L7.04586 22.63Z",
    fill: "#00B4FF"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22451 18.9535L6.42138 19.7635L6.31137 18.2872L6.1145 17.46L6.22451 18.9535Z",
    fill: "#53FFA4"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3648 17.3276L25.0232 16.8623L25.0059 17.5804L25.3475 17.9825L25.3648 17.3276Z",
    fill: "#7DFF7A"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76589 9.55553L7.13477 10.354L7.67904 9.33724L8.25226 8.57324L7.76589 9.55553Z",
    fill: "#FF4E00"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8223 21.9236L28.4418 21.5675L28.7718 21.2803L28.1465 21.6766L27.8223 21.9236Z",
    fill: "#00D4FF"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97341 26.8576L9.11816 27.3574L8.46967 26.3464L8.30176 25.8179L8.97341 26.8576Z",
    fill: "#0004FF"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3042 18.9941L25.391 18.6265L25.4953 19.2411L25.4084 19.5628L25.3042 18.9941Z",
    fill: "#49FFAD"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0759 14.6797L16.1512 15.1163L16.2612 16.6155L16.1686 16.1388L16.0759 14.6797Z",
    fill: "#C1FF36"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2241 20.878L25.7626 20.5908L26.0174 21.0102L25.4673 21.2801L25.2241 20.878Z",
    fill: "#0CF4EB"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2274 15.4551L24.5036 14.8691L24.3762 15.6389L25.1 16.1501L25.2274 15.4551Z",
    fill: "#C1FF36"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3599 11.5026L22.9761 10.6812L22.7502 11.3245L24.0878 12.077L24.3599 11.5026Z",
    fill: "#FF9800"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3007 10.2388L15.6638 10.2847L15.9186 11.5657L16.4686 11.4623L16.3007 10.2388Z",
    fill: "#FF7E00"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2787 10.5259L23.7385 9.54932L23.4722 9.77909L24.9602 10.7154L25.2787 10.5259Z",
    fill: "#FF6C00"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9921 16.8913L29.581 16.1044L29.5173 15.415L29.9284 16.248L29.9921 16.8913Z",
    fill: "#A7FF50"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2211 14.1683L28.2947 13.2032L28.0747 12.646L28.9895 13.6398L29.2211 14.1683Z",
    fill: "#FFEA00"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9171 13.4617L23.846 12.7437L23.6433 13.4962L24.6913 14.1338L24.9171 13.4617Z",
    fill: "#FFE600"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5316 11.8359L26.1999 10.7962L25.9104 10.5664L27.2132 11.6061L27.5316 11.8359Z",
    fill: "#FF9400"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M16.27 16.6099L16.5364 17.1498V18.6434L16.27 18.0747V16.6099Z",
    fill: "#83FF73"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6534 11.0487L23.2175 10.1641L22.9685 10.6811L24.3581 11.5025L24.6534 11.0487Z",
    fill: "#FF8200"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9683 10.7156L23.4803 9.7793L23.2197 10.1584L24.6557 11.0431L24.9683 10.7156Z",
    fill: "#FF7300"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1705 29.1723L12.2284 29.6089L11.4063 29.3447L11.3252 28.9023L12.1705 29.1723Z",
    fill: "#0000A4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4155 5.99951L12.3096 6.06844L12.8596 6.26375L13.8324 6.19482L13.4155 5.99951Z",
    fill: "#A40000"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6785 19.4243L29.8116 18.8383L29.9216 18.2007L29.7827 18.8441L29.6785 19.4243Z",
    fill: "#50FFA7"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1318 21.6704L28.763 21.2797L29.0583 20.9121L28.4213 21.3429L28.1318 21.6704Z",
    fill: "#00E4F8"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3559 6.73501L14.2327 6.62012L14.638 7.26349L15.6223 7.34966L15.3559 6.73501Z",
    fill: "#CD0000"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5244 18.6426L16.8776 19.24L16.7328 20.6819L16.397 20.0615L16.5244 18.6426Z",
    fill: "#40FFB7"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 20.4122L25.5727 20.1021L25.7812 20.5846L25.2427 20.8718L25.04 20.4122Z",
    fill: "#1FFFD7"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03467 15.1449L6.14468 15.9779L6.31838 14.5648L6.20837 13.7261L6.03467 15.1449Z",
    fill: "#D7FF1F"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67327 7.24065L8.85107 7.78637L9.51115 7.21768L10.2349 6.70068L9.67327 7.24065Z",
    fill: "#DA0000"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5279 28.0356L14.5974 28.6388L13.8273 29.0409L13.7405 28.4492L14.5279 28.0356Z",
    fill: "#0000CD"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30296 25.8122L8.47087 26.3407L7.90923 25.1919L7.72974 24.6289L8.30296 25.8122Z",
    fill: "#003CFF"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1066 9.1244L15.3655 9.11865L15.6666 10.2848L16.3035 10.2388L16.1066 9.1244Z",
    fill: "#FF4E00"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4457 16.6784L25.1041 16.1499L25.0288 16.868L25.3704 17.3332L25.4457 16.6784Z",
    fill: "#9DFF5A"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2585 18.396L25.3454 17.9824L25.3917 18.6258L25.3049 18.9934L25.2585 18.396Z",
    fill: "#63FF94"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6179 7.34935L14.6335 7.26318L15.0099 8.10186L15.8668 8.15356L15.6179 7.34935Z",
    fill: "#E80000"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1764 12.8645L24.0821 12.0718L23.8389 12.7439L24.91 13.4619L25.1764 12.8645Z",
    fill: "#FFC400"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9125 11.5718L15.6404 11.813L15.9009 13.2262L16.1094 12.9389L15.9125 11.5718Z",
    fill: "#FFAE00"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1947 11.6063L25.8977 10.5665L25.5908 10.4746L26.8531 11.5029L27.1947 11.6063Z",
    fill: "#FF8600"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4285 14.7944L24.6932 14.1338L24.5137 14.8633L25.2374 15.4493L25.4285 14.7944Z",
    fill: "#DEFF19"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M16.732 20.6821L16.9347 21.4059L16.6452 22.7558L16.4541 22.0206L16.732 20.6821Z",
    fill: "#00E4F8"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8687 8.15375L15.0117 8.10205L15.3591 9.11881L16.1003 9.12455L15.8687 8.15375Z",
    fill: "#FF2200"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7856 25.8242L15.884 26.5652L15.2529 27.4039L15.1487 26.6744L15.7856 25.8242Z",
    fill: "#0018FF"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9977 13.6457L28.077 12.6519L27.8223 12.1924L28.7255 13.2091L28.9977 13.6457Z",
    fill: "#FFD000"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4072 21.343L29.0441 20.9122L29.3047 20.4756L28.6562 20.9524L28.4072 21.343Z",
    fill: "#0FF8E7"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9185 16.2538L29.5132 15.4151L29.3916 14.7603L29.7969 15.6449L29.9185 16.2538Z",
    fill: "#C1FF36"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8804 19.9068L25.4131 19.5679L25.5694 20.1021L25.0367 20.4123L24.8804 19.9068Z",
    fill: "#33FFC4"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0219 29.2187L13.0567 29.6495L12.2403 29.6036L12.1824 29.167L13.0219 29.2187Z",
    fill: "#0000A8"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M29.804 18.8446L29.9429 18.2012L29.995 17.5464L29.8561 18.2415L29.804 18.8446Z",
    fill: "#6AFF8D"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7707 6.11578L10.8442 6.403L11.4927 6.34556L12.2976 6.06982L11.7707 6.11578Z",
    fill: "#9F0000"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4067 22.3709L26.42 22.0664L26.7732 22.1641L25.7426 22.48L25.4067 22.3709Z",
    fill: "#00C8FF"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4853 12.3646L24.362 11.5029L24.0898 12.0716L25.19 12.8643L25.4853 12.3646Z",
    fill: "#FFAB00"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0645 22.1815L26.0661 21.8828L26.402 22.0666L25.3887 22.3711L25.0645 22.1815Z",
    fill: "#00D0FF"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8622 11.5029L25.6 10.4746L25.2815 10.5263L26.509 11.5316L26.8622 11.5029Z",
    fill: "#FF8200"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65603 21.2226L6.87605 21.9522L6.63866 20.5218L6.41284 19.7578L6.65603 21.2226Z",
    fill: "#16FFE1"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72407 11.5316L6.51562 12.399L6.95568 11.2042L7.14675 10.354L6.72407 11.5316Z",
    fill: "#FF8D00"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7395 22.4805L26.7701 22.1646L27.1233 22.1703L26.0811 22.5035L25.7395 22.4805Z",
    fill: "#00C8FF"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7776 21.9175L25.7677 21.6245L26.0804 21.8888L25.0787 22.1875L24.7776 21.9175Z",
    fill: "#00D8FF"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8321 6.19482L12.8594 6.26376L13.4094 6.69458L14.2432 6.61991L13.8321 6.19482Z",
    fill: "#A80000"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8936 13.2202L15.9283 13.6166L16.1483 15.1101L16.073 14.6735L15.8936 13.2202Z",
    fill: "#FEED00"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8078 11.9621L24.6498 11.043L24.3545 11.4968L25.4836 12.3527L25.8078 11.9621Z",
    fill: "#FF9800"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5176 11.5312L25.2901 10.5259L24.9717 10.7154L26.1644 11.6863L26.5176 11.5312Z",
    fill: "#FF8200"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2759 17.7929L25.3628 17.3276L25.3454 17.9825L25.2585 18.3961L25.2759 17.7929Z",
    fill: "#7DFF7A"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5622 16.0467L25.2206 15.4551L25.0874 16.1501L25.429 16.6786L25.5622 16.0467Z",
    fill: "#BAFF3C"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6478 14.1967L24.9009 13.4614L24.675 14.1335L25.4104 14.7941L25.6478 14.1967Z",
    fill: "#FBF100"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0718 22.503L27.114 22.1698L27.4672 22.0894L26.4076 22.4398L26.0718 22.503Z",
    fill: "#00C8FF"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6697 20.9468L29.3182 20.47L29.5324 19.9702L28.8781 20.4872L28.6697 20.9468Z",
    fill: "#26FFD1"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5137 21.579L25.4922 21.2803L25.7759 21.6192L24.7858 21.9122L24.5137 21.579Z",
    fill: "#02E8F4"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71813 24.6289L7.89762 25.1919L7.43441 23.9338L7.23755 23.3364L7.71813 24.6289Z",
    fill: "#0078FF"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1461 11.6872L24.9533 10.7222L24.6406 11.0496L25.7986 11.9687L26.1461 11.6872Z",
    fill: "#FF8900"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7127 13.2088L27.8095 12.1863L27.5142 11.8359L28.4 12.8699L28.7127 13.2088Z",
    fill: "#FFB900"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6527 22.7563L16.7396 23.5835L16.3227 24.7899L16.2358 23.9742L16.6527 22.7563Z",
    fill: "#0098FF"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1145 17.4543L6.31137 18.2815L6.34032 16.8282L6.13766 15.978L6.1145 17.4543Z",
    fill: "#97FF60"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6673 10.291L15.3083 10.4863L15.6442 11.8133L15.9163 11.572L15.6673 10.291Z",
    fill: "#FF7300"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7664 19.367L25.2933 18.9937L25.3975 19.5681L24.8648 19.907L24.7664 19.367Z",
    fill: "#4DFFAA"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7882 15.6505L29.3829 14.7659L29.2092 14.1685L29.6087 15.0933L29.7882 15.6505Z",
    fill: "#DEFF19"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2573 8.57372L7.68408 9.33772L8.33257 8.52202L8.8421 7.79248L8.2573 8.57372Z",
    fill: "#FF1A00"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4255 22.4398L27.4851 22.0894L27.821 21.9229L26.7498 22.302L26.4255 22.4398Z",
    fill: "#00D0FF"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2512 21.1823L25.2182 20.8721L25.4671 21.2799L24.4886 21.5786L24.2512 21.1823Z",
    fill: "#13FCE4"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M29.85 18.241L29.9889 17.546L29.9831 16.8911L29.8384 17.6379L29.85 18.241Z",
    fill: "#87FF70"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M16.156 15.1104L16.405 15.6216L16.5324 17.1496L16.266 16.6096L16.156 15.1104Z",
    fill: "#C4FF33"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2417 6.62012L13.408 6.69479L13.9407 7.3554L14.6471 7.26349L14.2417 6.62012Z",
    fill: "#B60000"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9394 13.669L25.1809 12.8647L24.9146 13.4622L25.6615 14.1974L25.9394 13.669Z",
    fill: "#FFD700"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4089 12.8697L27.523 11.8357L27.2046 11.606L28.0731 12.6399L28.4089 12.8697Z",
    fill: "#FFA700"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2432 27.4038L15.3011 28.0185L14.6005 28.6388L14.531 28.0357L15.2432 27.4038Z",
    fill: "#0000FA"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M13.835 29.0405L13.8465 29.4828L13.0533 29.6552L13.0186 29.2243L13.835 29.0405Z",
    fill: "#0000BB"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8767 20.487L29.531 19.97L29.6989 19.4243L29.0388 19.9872L28.8767 20.487Z",
    fill: "#3CFFBA"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7466 22.2964L27.8178 21.9173L28.1362 21.6646L27.0477 22.0724L26.7466 22.2964Z",
    fill: "#00DCFE"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7625 15.4545L25.4209 14.7939L25.2356 15.4488L25.5772 16.0405L25.7625 15.4545Z",
    fill: "#D4FF23"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3764 9.125L14.9189 9.2801L15.3243 10.4864L15.6832 10.2911L15.3764 9.125Z",
    fill: "#FF3F00"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M25.345 17.1951L25.4319 16.6724L25.3566 17.3215L25.2698 17.7868L25.345 17.1951Z",
    fill: "#9AFF5D"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2169 6.70631L9.49316 7.2233L10.2169 6.89013L10.8365 6.40186L10.2169 6.70631Z",
    fill: "#B20000"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M10.617 28.8742L10.6517 29.1615L9.91061 28.5181L9.84692 28.2021L10.617 28.8742Z",
    fill: "#0000D6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0786 20.7343L25.0398 20.4126L25.2424 20.8721L24.2755 21.1823L24.0786 20.7343Z",
    fill: "#26FFD1"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83876 28.2017L9.90245 28.5177L9.20763 27.6962L9.11499 27.3516L9.83876 28.2017Z",
    fill: "#0000FA"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7319 18.8097L25.2588 18.4019L25.3052 18.9993L24.7725 19.3727L24.7319 18.8097Z",
    fill: "#63FF94"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5227 17.1494L16.8759 17.7296V19.2404L16.5227 18.643V17.1494Z",
    fill: "#83FF73"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6464 7.26318L13.9458 7.35509L14.4495 8.22249L15.0228 8.10186L14.6464 7.26318Z",
    fill: "#D60000"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3009 6.06934L11.4961 6.33932L12.1735 6.52889L12.851 6.26464L12.3009 6.06934Z",
    fill: "#960000"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M29.616 15.0931L29.2165 14.1682L28.9907 13.6455L29.3844 14.5991L29.616 15.0931Z",
    fill: "#F4F802"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0227 8.10205L14.4495 8.22268L14.9127 9.2739L15.3701 9.1188L15.0227 8.10205Z",
    fill: "#FF1300"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4193 29.3447L11.4251 29.6204L10.6492 29.1666L10.6145 28.8794L11.4193 29.3447Z",
    fill: "#0000BF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2442 13.2259L25.4683 12.3643L25.1672 12.864L25.9257 13.6682L26.2442 13.2259Z",
    fill: "#FFC100"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21729 13.7258L6.3273 14.5644L6.63996 13.2432L6.52995 12.3931L6.21729 13.7258Z",
    fill: "#FFD000"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0822 12.6403L27.2137 11.6063L26.8721 11.5029L27.7174 12.5254L28.0822 12.6403Z",
    fill: "#FF9C00"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8449 17.6383L29.9897 16.8915L29.926 16.2539L29.7812 17.0466L29.8449 17.6383Z",
    fill: "#A0FF56"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6356 11.8135L15.6067 12.1754L15.9251 13.623L15.8904 13.2266L15.6356 11.8135Z",
    fill: "#FFAB00"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13286 27.3517L9.2255 27.6964L8.60018 26.7198L8.48438 26.335L9.13286 27.3517Z",
    fill: "#0014FF"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0334 22.0781L28.122 21.6702L28.4115 21.3428L27.3114 21.7793L27.0334 22.0781Z",
    fill: "#06ECF1"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24759 23.3365L7.44445 23.934L7.09126 22.5955L6.88281 21.9521L7.24759 23.3365Z",
    fill: "#00BCFF"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3278 24.7842L16.4204 25.5367L15.8877 26.5649L15.7893 25.8239L16.3278 24.7842Z",
    fill: "#0054FF"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9182 20.2455L24.8736 19.9009L25.0299 20.4064L24.0688 20.7281L23.9182 20.2455Z",
    fill: "#39FFBE"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6101 12.881L25.8169 11.9619L25.4868 12.3583L26.2627 13.2199L26.6101 12.881Z",
    fill: "#FFAE00"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 19.2407L17.0927 19.9588L16.9422 21.4064L16.7395 20.6826L16.8843 19.2407Z",
    fill: "#40FFB7"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6939 12.5254L26.8486 11.5029L26.4954 11.5259L27.3233 12.5254H27.6939Z",
    fill: "#FF9800"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41428 19.7635L6.64589 20.5275L6.54166 19.0857L6.31006 18.293L6.41428 19.7635Z",
    fill: "#56FFA0"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0364 19.9869L29.6965 19.4239L29.8065 18.8438L29.1406 19.4527L29.0364 19.9869Z",
    fill: "#53FFA4"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M26.003 14.9211L25.6556 14.1973L25.4182 14.8004L25.7598 15.461L26.003 14.9211Z",
    fill: "#EEFF09"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9659 12.6457L26.1553 11.6807L25.8079 11.9621L26.6011 12.8812L26.9659 12.6457Z",
    fill: "#FF9F00"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3328 12.5254L26.5048 11.5259L26.1516 11.681L26.9622 12.646L27.3328 12.5254Z",
    fill: "#FF9800"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4772 16.6272L25.5699 16.0527L25.4367 16.6846L25.3499 17.2074L25.4772 16.6272Z",
    fill: "#B4FF43"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2272 29.609L12.2041 29.8732L11.4108 29.6205L11.405 29.3447L12.2272 29.609Z",
    fill: "#0000B6"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7019 22.5148L25.0684 22.1816L25.3926 22.3712L24.0088 22.7101L23.7019 22.5148Z",
    fill: "#00D8FF"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3927 14.5996L28.9989 13.646L28.7268 13.2095L29.1147 14.186L29.3927 14.5996Z",
    fill: "#FFDE00"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7377 18.2463L25.2704 17.7925L25.2588 18.3956L24.7319 18.8035L24.7377 18.2463Z",
    fill: "#7DFF7A"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0215 22.7105L25.4053 22.3716L25.7411 22.4807L24.3399 22.8311L24.0215 22.7105Z",
    fill: "#00D0FF"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M23.415 22.2449L24.7699 21.9175L25.071 22.1817L23.7045 22.5149L23.415 22.2449Z",
    fill: "#00E0FB"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3311 22.8304L25.7323 22.48L26.0739 22.503L24.6553 22.8706L24.3311 22.8304Z",
    fill: "#00D0FF"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15323 10.3537L6.96216 11.2038L7.5238 10.1756L7.6975 9.33691L7.15323 10.3537Z",
    fill: "#FF4E00"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1741 21.906L24.5174 21.5786L24.7895 21.9118L23.4346 22.2392L23.1741 21.906Z",
    fill: "#09F0EE"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3301 21.7797L28.4302 21.3431L28.6792 20.9468L27.5675 21.4178L27.3301 21.7797Z",
    fill: "#19FFDE"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47399 26.3408L8.5898 26.7256L8.04553 25.617L7.91235 25.1919L8.47399 26.3408Z",
    fill: "#0048FF"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8162 19.7348L24.7657 19.3672L24.8642 19.9072L23.9088 20.2518L23.8162 19.7348Z",
    fill: "#50FFA7"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7717 17.0463L29.9164 16.2536L29.789 15.6504L29.6443 16.4833L29.7717 17.0463Z",
    fill: "#BEFF39"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8598 6.26367L12.1824 6.52791L12.8598 6.95874L13.4099 6.6945L12.8598 6.26367Z",
    fill: "#960000"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2791 14.4502L25.9317 13.6689L25.6479 14.1974L25.9954 14.9212L26.2791 14.4502Z",
    fill: "#FFE600"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6019 28.6382L14.5903 29.092L13.8434 29.4826L13.8318 29.0403L14.6019 28.6382Z",
    fill: "#0000DA"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6521 22.8714L26.0707 22.5037L26.4065 22.4463L24.9763 22.8312L24.6521 22.8714Z",
    fill: "#00D0FF"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9277 13.6167L16.142 14.105L16.3967 15.6215L16.1478 15.1102L15.9277 13.6167Z",
    fill: "#FFEA00"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9229 21.51L24.2546 21.1826L24.492 21.579L23.1487 21.9064L22.9229 21.51Z",
    fill: "#16FFE1"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M15.31 10.4863L15.2058 10.8195L15.6227 12.1809L15.6516 11.819L15.31 10.4863Z",
    fill: "#FF6C00"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14893 15.9833L6.35158 16.8277L6.51949 15.4319L6.32263 14.5645L6.14893 15.9833Z",
    fill: "#D7FF1F"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1506 19.4479L29.8165 18.839L29.8686 18.2358L29.197 18.885L29.1506 19.4479Z",
    fill: "#6DFF8A"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84547 7.78647L8.33594 8.516L9.07128 7.91859L9.49975 7.21777L8.84547 7.78647Z",
    fill: "#D10000"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1078 14.1851L28.7199 13.2085L28.4072 12.8696L28.7894 13.8577L29.1078 14.1851Z",
    fill: "#FFCC00"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9377 21.4062L17.0245 22.2392L16.735 23.5834L16.6482 22.7562L16.9377 21.4062Z",
    fill: "#00E4F8"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6721 16.087L25.7705 15.4551L25.5795 16.0467L25.4868 16.6212L25.6721 16.087Z",
    fill: "#CEFF29"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8504 6.40206L10.2251 6.89033L10.9894 6.80991L11.5047 6.33887L10.8504 6.40206Z",
    fill: "#960000"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8072 17.6957L25.3399 17.2017L25.2646 17.7991L24.7319 18.2529L24.8072 17.6957Z",
    fill: "#97FF60"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0407 29.6553L12.9828 29.9196L12.1953 29.8736L12.2185 29.6094L13.0407 29.6553Z",
    fill: "#0000BB"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9832 22.8249L26.4133 22.44L26.7376 22.2964L25.29 22.6985L24.9832 22.8249Z",
    fill: "#00D8FF"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8826 26.5645L15.9289 27.1963L15.3094 28.0178L15.2515 27.4031L15.8826 26.5645Z",
    fill: "#0020FF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5598 21.418L28.6715 20.947L28.88 20.4932L27.7625 20.9987L27.5598 21.418Z",
    fill: "#29FFCE"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7502 21.0728L24.0704 20.7339L24.2673 21.1819L22.9355 21.5094L22.7502 21.0728Z",
    fill: "#29FFCE"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6162 14.0648L26.263 13.2261L25.9446 13.6684L26.292 14.4496L26.6162 14.0648Z",
    fill: "#FFD000"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7705 19.2001L24.7201 18.8037L24.7664 19.3609L23.8168 19.7286L23.7705 19.2001Z",
    fill: "#66FF90"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6512 16.4772L29.7959 15.65L29.6164 15.0928L29.4717 15.9544L29.6512 16.4772Z",
    fill: "#D4FF23"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7872 13.8579L28.4051 12.8699L28.0635 12.6401L28.4398 13.6282L28.7872 13.8579Z",
    fill: "#FFB900"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4094 6.69482L12.8594 6.95907L13.5194 7.62541L13.9421 7.35543L13.4094 6.69482Z",
    fill: "#A80000"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88974 21.9523L7.09818 22.5957L6.86658 21.2055L6.65234 20.522L6.88974 21.9523Z",
    fill: "#19FFDE"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 15.6221L16.7386 16.1908L16.8776 17.7303L16.5244 17.1501L16.397 15.6221Z",
    fill: "#C4FF33"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8995 9.27393L14.7026 9.57838L15.2006 10.8134L15.3048 10.4802L14.8995 9.27393Z",
    fill: "#FF3400"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90608 25.1915L8.03925 25.6166L7.59341 24.4045L7.44287 23.9277L7.90608 25.1915Z",
    fill: "#0080FF"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9608 13.7718L26.6018 12.8872L26.2544 13.2319L26.6076 14.0705L26.9608 13.7718Z",
    fill: "#FFC100"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2925 22.7047L26.74 22.3026L27.0411 22.0786L25.5762 22.5037L25.2925 22.7047Z",
    fill: "#00E4F8"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1906 18.89L29.8623 18.2408L29.8565 17.6377L29.1848 18.327L29.1906 18.89Z",
    fill: "#87FF70"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6133 20.5908L23.9334 20.2461L24.084 20.7344L22.758 21.0675L22.6133 20.5908Z",
    fill: "#3CFFBA"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8911 15.6102L25.9896 14.9209L25.7464 15.4609L25.6479 16.0927L25.8911 15.6102Z",
    fill: "#E4FF13"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4548 13.6283L28.0785 12.6403L27.7195 12.5254L28.0901 13.5019L28.4548 13.6283Z",
    fill: "#FFB200"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9449 7.35547L13.5222 7.62545L14.1418 8.51009L14.4486 8.22287L13.9449 7.35547Z",
    fill: "#C80000"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M14.437 8.22314L14.1301 8.51036L14.6976 9.58457L14.8944 9.28011L14.437 8.22314Z",
    fill: "#F10800"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9399 17.1669L25.4784 16.627L25.3452 17.2014L24.8125 17.6954L24.9399 17.1669Z",
    fill: "#B1FF46"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3219 13.5762L26.9629 12.6514L26.5981 12.8869L26.9571 13.7773L27.3219 13.5762Z",
    fill: "#FFB200"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 12.399L6.62564 13.2492L7.06569 12.0659L6.95568 11.21L6.51562 12.399Z",
    fill: "#FF8D00"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7651 20.9925L28.8826 20.487L29.039 19.9814L27.9099 20.5157L27.7651 20.9925Z",
    fill: "#40FFB7"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0827 13.5019L27.7121 12.5254H27.3416L27.7063 13.4847L28.0827 13.5019Z",
    fill: "#FFAB00"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6887 13.4847L27.3239 12.5254L26.9534 12.646L27.3124 13.5709L27.6887 13.4847Z",
    fill: "#FFAE00"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7763 18.6717L24.7317 18.2466L24.7201 18.8095L23.7705 19.2059L23.7763 18.6717Z",
    fill: "#7DFF7A"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0642 22.8828L23.7028 22.5151L24.0155 22.7104L22.3537 23.0896L22.0642 22.8828Z",
    fill: "#00DCFE"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 22.6012L23.4271 22.2393L23.7166 22.5092L22.078 22.8826L21.8 22.6012Z",
    fill: "#00E4F8"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29883 18.2872L6.53043 19.0799L6.55938 17.6553L6.32778 16.8281L6.29883 18.2872Z",
    fill: "#97FF60"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4635 15.9553L29.6083 15.0936L29.3767 14.5996L29.2319 15.49L29.4635 15.9553Z",
    fill: "#EBFF0C"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6295 29.1614L10.5948 29.2763L9.88257 28.6617V28.5181L10.6295 29.1614Z",
    fill: "#0000ED"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7498 23.583L16.8367 24.3528L16.4198 25.5418L16.3271 24.7893L16.7498 23.583Z",
    fill: "#009CFF"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8722 17.7295L17.0807 18.4418L17.0749 19.9583L16.8665 19.2403L16.8722 17.7295Z",
    fill: "#83FF73"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3508 23.0891L24.0126 22.71L24.331 22.8306L22.6577 23.227L22.3508 23.0891Z",
    fill: "#00D4FF"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9068 28.5178V28.6615L9.24672 27.886L9.21777 27.7021L9.9068 28.5178Z",
    fill: "#0000FF"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 12.1753L15.7688 12.6406L16.1394 14.1054L15.9251 13.6171L15.6067 12.1753Z",
    fill: "#FFA300"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5376 22.2562L23.153 21.9058L23.4136 22.2447L21.7866 22.6066L21.5376 22.2562Z",
    fill: "#0CF4EB"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5681 22.4972L27.033 22.0721L27.3109 21.7734L25.8345 22.2215L25.5681 22.4972Z",
    fill: "#0CF4EB"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8524 29.4766L13.7656 29.7465L13.0071 29.9131L13.065 29.6489L13.8524 29.4766Z",
    fill: "#0000CD"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5105 20.0905L23.8249 19.7344L23.9233 20.2514L22.6031 20.596L22.5105 20.0905Z",
    fill: "#50FFA7"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4251 29.6204L11.3556 29.7181L10.6145 29.2873L10.6492 29.1724L11.4251 29.6204Z",
    fill: "#0000D6"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1883 15.1907L26.2925 14.4497L26.0088 14.915L25.9104 15.6043L26.1883 15.1907Z",
    fill: "#F8F500"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6704 23.2269L24.3438 22.8306L24.668 22.8708L22.9773 23.2786L22.6704 23.2269Z",
    fill: "#00D4FF"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4965 6.33887L10.9812 6.80416L11.7687 6.97649L12.174 6.52269L11.4965 6.33887Z",
    fill: "#890000"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M21.342 21.8598L22.9459 21.5151L23.1717 21.9115L21.5563 22.2619L21.342 21.8598Z",
    fill: "#19FFDE"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3001 28.0181L15.2711 28.4891L14.5879 29.0865L14.5995 28.6327L15.3001 28.0181Z",
    fill: "#0000FF"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1745 18.3264L29.8461 17.6371L29.7766 17.0454L29.105 17.7692L29.1745 18.3264Z",
    fill: "#A0FF56"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20248 27.7021L9.23143 27.8859L8.63505 26.9554L8.57715 26.7256L9.20248 27.7021Z",
    fill: "#0024FF"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69641 9.33719L7.52271 10.1759L8.20015 9.34293L8.33911 8.52148L7.69641 9.33719Z",
    fill: "#FF1600"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1224 16.6787L25.6725 16.0928L25.4872 16.627L24.9487 17.167L25.1224 16.6787Z",
    fill: "#C7FF30"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2399 15.4895L29.3847 14.5991L29.1067 14.1855L28.9678 15.0932L29.2399 15.4895Z",
    fill: "#FEED00"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8923 20.5215L29.0214 19.9872L29.1256 19.4473L27.9908 20.016L27.8923 20.5215Z",
    fill: "#56FFA0"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4978 7.22282L9.06934 7.92364L9.87416 7.56174L10.2216 6.88965L9.4978 7.22282Z",
    fill: "#A80000"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9685 23.279L24.6592 22.8712L24.9777 22.8252L23.2696 23.2503L22.9685 23.279Z",
    fill: "#00D4FF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8512 18.1549L24.8066 17.6953L24.7371 18.2468L23.7817 18.6718L23.8512 18.1549Z",
    fill: "#97FF60"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1482 21.412L22.7405 21.0674L22.9258 21.5097L21.3219 21.8544L21.1482 21.412Z",
    fill: "#29FFCE"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45232 23.9337L7.60286 24.4104L7.26703 23.118L7.09912 22.5952L7.45232 23.9337Z",
    fill: "#00C4FF"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M25.842 22.2274L27.3243 21.7794L27.5617 21.4175L26.0679 21.8828L25.842 22.2274Z",
    fill: "#1CFFDB"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2048 29.868L12.1006 29.9542L11.3479 29.7129L11.4174 29.6152L12.2048 29.868Z",
    fill: "#0000CD"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4648 19.5741L23.7792 19.2007L23.8255 19.7292L22.5112 20.0853L22.4648 19.5741Z",
    fill: "#66FF90"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4985 14.8519L26.6085 14.0649L26.29 14.4498L26.1858 15.1908L26.4985 14.8519Z",
    fill: "#FFDE00"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31006 14.5644L6.50692 15.4318L6.8138 14.1278L6.61693 13.2432L6.31006 14.5644Z",
    fill: "#FFD300"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0856 19.959L17.1725 20.7977L17.0219 22.2395L16.9351 21.4066L17.0856 19.959Z",
    fill: "#40FFB7"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2668 23.2503L24.9749 22.8252L25.2818 22.7046L23.5564 23.1412L23.2668 23.2503Z",
    fill: "#00DCFE"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9654 15.0929L29.1044 14.1853L28.7859 13.8579L28.647 14.777L28.9654 15.0929Z",
    fill: "#FFDB00"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1123 17.7701L29.784 17.0463L29.6566 16.4834L28.9907 17.2359L29.1123 17.7701Z",
    fill: "#B7FF40"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1445 14.105L16.463 14.6622L16.7409 16.1902L16.3993 15.6215L16.1445 14.105Z",
    fill: "#FFE600"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59359 26.7254L8.65149 26.9551L8.13617 25.8982L8.04932 25.6167L8.59359 26.7254Z",
    fill: "#0054FF"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64834 20.5214L6.86258 21.205L6.75836 19.8034L6.53833 19.0796L6.64834 20.5214Z",
    fill: "#56FFA0"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0112 20.9355L22.5977 20.5908L22.7425 21.0676L21.1502 21.4123L21.0112 20.9355Z",
    fill: "#3CFFBA"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4033 25.542L16.438 26.1969L15.9169 27.2021L15.8706 26.5702L16.4033 25.542Z",
    fill: "#005CFF"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2058 10.8135L15.2985 11.2673L15.779 12.6402L15.6169 12.1749L15.2058 10.8135Z",
    fill: "#FF6400"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8257 14.5987L26.9415 13.7715L26.5941 14.0644L26.4841 14.8514L26.8257 14.5987Z",
    fill: "#FFD000"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3359 16.2417L25.8918 15.6099L25.6544 16.0924L25.1101 16.6783L25.3359 16.2417Z",
    fill: "#DEFF19"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1656 6.52881L11.7603 6.98261L12.5477 7.40195L12.8372 6.95964L12.1656 6.52881Z",
    fill: "#890000"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9949 20.0161L29.1297 19.4474L29.1761 18.8901L28.0354 19.4933L27.9949 20.0161Z",
    fill: "#6DFF8A"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6463 14.7768L28.7853 13.8577L28.4379 13.6279L28.3047 14.547L28.6463 14.7768Z",
    fill: "#FFCC00"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9661 17.661L24.9331 17.167L24.8057 17.6955L23.8503 18.155L23.9661 17.661Z",
    fill: "#ADFF49"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0603 21.8829L27.5484 21.4119L27.7452 20.9868L26.2456 21.4808L26.0603 21.8829Z",
    fill: "#2CFFCA"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4652 19.0625L23.7796 18.6719L23.768 19.2004L22.4536 19.5738L22.4652 19.0625Z",
    fill: "#7DFF7A"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3618 23.4393L22.2088 22.997L21.9251 22.75L20.0723 23.1866L20.3618 23.4393Z",
    fill: "#00DCFE"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0747 23.1866L21.9275 22.75L21.667 22.4341L19.8083 22.8649L20.0747 23.1866Z",
    fill: "#02E8F4"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2139 14.4383L27.3355 13.5767L26.9649 13.772L26.8491 14.5992L27.2139 14.4383Z",
    fill: "#FFC400"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5857 29.0923L14.4699 29.3795L13.752 29.7529L13.8388 29.4829L14.5857 29.0923Z",
    fill: "#0000ED"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M23.575 23.141L25.3004 22.7045L25.5899 22.5034L23.8471 22.9572L23.575 23.141Z",
    fill: "#02E8F4"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M20.676 23.6117L22.5173 23.1694L22.2162 22.9971L20.3691 23.4394L20.676 23.6117Z",
    fill: "#00D4FF"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0115 29.914L12.8667 29.9951L12.114 29.9545L12.2182 29.8677L13.0115 29.914Z",
    fill: "#0000D1"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3028 14.5474L28.4359 13.6283L28.0712 13.502L27.938 14.4153L28.3028 14.5474Z",
    fill: "#FFC400"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9084 20.436L22.4949 20.0913L22.5876 20.5968L21.0011 20.9415L20.9084 20.436Z",
    fill: "#53FFA4"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7948 22.8706L21.6476 22.4398L21.416 22.0664L19.5574 22.4915L19.7948 22.8706Z",
    fill: "#0FF8E7"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5752 14.3748L27.7025 13.4844L27.3262 13.5763L27.2046 14.4379L27.5752 14.3748Z",
    fill: "#FFC100"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9764 17.2356L29.648 16.4773L29.4685 15.9546L28.7969 16.7416L28.9764 17.2356Z",
    fill: "#CEFF29"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9533 14.4156L28.0865 13.508L27.7101 13.4907L27.5828 14.3811L27.9533 14.4156Z",
    fill: "#FFBD00"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9741 23.704L22.8154 23.256L22.5085 23.1641L20.6672 23.6064L20.9741 23.704Z",
    fill: "#00D4FF"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6162 15.8688L26.1836 15.1909L25.9057 15.6045L25.3499 16.2364L25.6162 15.8688Z",
    fill: "#F1FC06"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7026 9.57812L14.7142 10.0204L15.2932 11.267L15.2006 10.8132L14.7026 9.57812Z",
    fill: "#FF2D00"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5759 22.4918L21.4346 22.0667L21.2377 21.6416L19.3733 22.0609L19.5759 22.4918Z",
    fill: "#1CFFDB"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96216 11.204L7.07217 12.0599L7.6396 11.0374L7.52959 10.1758L6.96216 11.204Z",
    fill: "#FF4E00"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7507 16.1899L16.9534 16.8965L17.0981 18.4417L16.8897 17.7294L16.7507 16.1899Z",
    fill: "#C4FF33"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8615 6.95947L12.572 7.40179L13.3363 8.06239L13.5158 7.62582L12.8615 6.95947Z",
    fill: "#9B0000"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 16.828L6.56461 17.6552L6.73252 16.288L6.50092 15.4321L6.33301 16.828Z",
    fill: "#D4FF23"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02714 25.6223L8.11399 25.9038L7.68552 24.7492L7.5813 24.416L8.02714 25.6223Z",
    fill: "#008CFF"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0524 19.4933L29.193 18.8901L29.1814 18.3271L28.0408 18.959L28.0524 19.4933Z",
    fill: "#87FF70"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2782 23.7213L23.1137 23.2732L22.8068 23.2617L20.9656 23.7098L21.2782 23.7213Z",
    fill: "#00D4FF"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 6.89048L9.8811 7.56257L10.7322 7.45343L10.9928 6.81006L10.2285 6.89048Z",
    fill: "#8D0000"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1437 17.2072L25.1223 16.6787L24.9428 17.167L23.9758 17.661L24.1437 17.2072Z",
    fill: "#C4FF33"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2544 21.487L27.754 20.993L27.9046 20.522L26.3934 21.039L26.2544 21.487Z",
    fill: "#43FFB4"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8389 22.9512L25.5817 22.4974L25.8422 22.2217L24.0878 22.687L23.8389 22.9512Z",
    fill: "#0FF8E7"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9341 27.2026L15.8878 27.6967L15.2856 28.4894L15.3146 28.0183L15.9341 27.2026Z",
    fill: "#0028FF"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0344 22.2393L17.1213 23.032L16.8376 24.3532L16.7507 23.5834L17.0344 22.2393Z",
    fill: "#02E8F4"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 18.563L23.8544 18.1494L23.7907 18.6664L22.4763 19.057L22.5342 18.563Z",
    fill: "#94FF63"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08519 22.5952L7.2531 23.118L7.03308 21.7853L6.85938 21.2051L7.08519 22.5952Z",
    fill: "#1CFFDB"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6166 29.2762L10.5413 29.2187L9.86963 28.6328L9.91016 28.6615L10.6166 29.2762Z",
    fill: "#0000FF"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M20.884 19.9238L22.4705 19.5791L22.5168 20.0961L20.9304 20.4408L20.884 19.9238Z",
    fill: "#66FF90"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90634 28.661L9.86581 28.6323L9.24048 27.8913V27.874L9.90634 28.661Z",
    fill: "#0010FF"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3643 22.0609L21.2287 21.6416L21.0724 21.1763L19.2021 21.5899L19.3643 22.0609Z",
    fill: "#30FFC7"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8157 16.7416L29.4815 15.9604L29.2499 15.4951L28.5898 16.2993L28.8157 16.7416Z",
    fill: "#E4FF13"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1199 8.51025L14.0388 8.94683L14.6989 10.021L14.6873 9.57871L14.1199 8.51025Z",
    fill: "#E80000"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5079 7.62549L13.3284 8.06206L14.0521 8.94669L14.1332 8.51012L13.5079 7.62549Z",
    fill: "#BB0000"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33794 8.52124L8.19897 9.34268L8.96327 8.72804L9.07328 7.92383L8.33794 8.52124Z",
    fill: "#D10000"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9092 15.5639L26.4882 14.8516L26.1697 15.1905L25.6023 15.8683L25.9092 15.5639Z",
    fill: "#FEED00"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3511 29.7129L11.2353 29.6325L10.5347 29.2246L10.6099 29.2821L11.3511 29.7129Z",
    fill: "#0000F1"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 12.6401L16.0558 13.1916L16.4669 14.6621L16.1484 14.1049L15.7778 12.6401Z",
    fill: "#FF9F00"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5975 23.6463L23.4329 23.1982L23.1319 23.2672L21.2964 23.7152L21.5975 23.6463Z",
    fill: "#00D8FF"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24214 27.8862V27.9034L8.6747 27.0245L8.64575 26.9556L9.24214 27.8862Z",
    fill: "#0038FF"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7568 29.7471L13.5831 29.839L12.8594 29.9998L13.0041 29.9194L13.7568 29.7471Z",
    fill: "#0000E3"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M28.036 18.9534L29.1708 18.3272L29.1013 17.77L27.9607 18.4249L28.036 18.9534Z",
    fill: "#9DFF5A"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1922 21.5897L21.0624 21.1761L20.9466 20.6821L19.0764 21.09L19.1922 21.5897Z",
    fill: "#43FFB4"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5768 16.2933L29.2369 15.4891L28.959 15.0928L28.3047 15.9085L28.5768 16.2933Z",
    fill: "#F4F802"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0898 22.6866L25.8442 22.2271L26.0701 21.8882L24.3041 22.365L24.0898 22.6866Z",
    fill: "#1FFFD7"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3514 16.8046L25.3358 16.2417L25.1099 16.6783L24.1372 17.2068L24.3514 16.8046Z",
    fill: "#D7FF1F"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4715 23.9282L20.3707 23.4399L20.0811 23.1929L18.1704 23.6697L18.4715 23.9282Z",
    fill: "#00D8FF"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4026 21.0386L27.9138 20.5216L28.0122 20.0161L26.4952 20.5503L26.4026 21.0386Z",
    fill: "#56FFA0"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1632 23.6633L20.0739 23.1865L19.8076 22.8706L17.8853 23.3359L18.1632 23.6633Z",
    fill: "#00E4F8"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2634 15.3464L26.854 14.5996L26.5066 14.8524L25.9333 15.5647L26.2634 15.3464Z",
    fill: "#FFDE00"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8956 19.4129L22.4821 19.0625L22.4705 19.5738L20.884 19.9184L20.8956 19.4129Z",
    fill: "#7DFF7A"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6432 18.0915L23.9691 17.6606L23.8533 18.1547L22.5332 18.5683L22.6432 18.0915Z",
    fill: "#AAFF4D"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M12.118 29.9539L11.9558 29.8562L11.2437 29.6265L11.3595 29.7069L12.118 29.9539Z",
    fill: "#0000E8"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7872 24.1058L20.6748 23.6118L20.3737 23.4395L18.4688 23.9277L18.7872 24.1058Z",
    fill: "#00D0FF"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53833 19.0794L6.75835 19.8032L6.78731 18.4245L6.56728 17.6548L6.53833 19.0794Z",
    fill: "#94FF63"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M17.893 23.3361L19.8153 22.8708L19.5779 22.4917L17.644 22.9398L17.893 23.3361Z",
    fill: "#0CF4EB"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8728 23.497L23.7024 23.0547L23.4187 23.204L21.5833 23.6521L21.8728 23.497Z",
    fill: "#00E4F8"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M17.089 18.4419L17.1759 19.2863L17.1701 20.7971L17.0833 19.9584L17.089 18.4419Z",
    fill: "#83FF73"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62964 13.2439L6.8265 14.1285L7.26655 12.9567L7.07547 12.0605L6.62964 13.2439Z",
    fill: "#FF9100"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2829 28.4888L15.144 28.799L14.4839 29.3734L14.5997 29.0862L15.2829 28.4888Z",
    fill: "#0008FF"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3189 15.9085L28.9732 15.0928L28.6605 14.7769L28.0178 15.604L28.3189 15.9085Z",
    fill: "#FFE600"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0968 24.2035L20.9785 23.7037L20.6659 23.6118L18.7783 24.1058L19.0968 24.2035Z",
    fill: "#00CCFF"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 24.353L16.8485 25.0366L16.4432 26.197L16.4084 25.5421L16.8195 24.353Z",
    fill: "#00A0FF"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5904 24.4106L7.69462 24.7438L7.37037 23.5145L7.24878 23.1182L7.5904 24.4106Z",
    fill: "#00CCFF"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6076 15.214L27.2098 14.4385L26.845 14.5993L26.2544 15.3461L26.6076 15.214Z",
    fill: "#FFD300"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64025 26.9555L8.6692 27.0245L8.17704 26.0307L8.11914 25.9043L8.64025 26.9555Z",
    fill: "#0064FF"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 22.9399L19.5639 22.4919L19.3612 22.061L17.4158 22.4919L17.63 22.9399Z",
    fill: "#1CFFDB"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0931 21.0906L20.9633 20.6827L20.8938 20.1772L19.0178 20.5736L19.0931 21.0906Z",
    fill: "#5AFF9D"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9893 6.81006L10.7288 7.45343L11.6031 7.60278L11.771 6.98239L10.9893 6.81006Z",
    fill: "#800000"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9625 18.4244L29.1031 17.7696L28.9815 17.2354L27.8467 17.9132L27.9625 18.4244Z",
    fill: "#B4FF43"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0097 15.599L28.6524 14.7718L28.3107 14.542L27.6738 15.3634L28.0097 15.599Z",
    fill: "#FFDB00"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M24.615 16.4602L25.6109 15.8628L25.3388 16.2362L24.3545 16.7991L24.615 16.4602Z",
    fill: "#E7FF0F"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9571 15.173L27.5709 14.3745L27.2003 14.4377L26.5981 15.2132L26.9571 15.173Z",
    fill: "#FFD000"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4063 24.2212L21.2766 23.7215L20.9697 23.71L19.0879 24.2097L19.4063 24.2212Z",
    fill: "#00D0FF"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2969 22.3598L26.0629 21.8831L26.2481 21.481L24.4706 21.9692L24.2969 22.3598Z",
    fill: "#30FFC7"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6833 15.3691L28.3202 14.5476L27.9554 14.4155L27.3301 15.2312L27.6833 15.3691Z",
    fill: "#FFD000"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3124 15.2253L27.9377 14.4153L27.5671 14.3809L26.9534 15.1793L27.3124 15.2253Z",
    fill: "#FFCC00"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4727 20.5559L27.9897 20.0216L28.036 19.4932L26.5132 20.0446L26.4727 20.5559Z",
    fill: "#6DFF8A"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9476 18.9244L22.5399 18.5625L22.482 19.0623L20.8955 19.4127L20.9476 18.9244Z",
    fill: "#94FF63"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8038 17.6612L24.1413 17.2017L23.9734 17.6555L22.6475 18.0863L22.8038 17.6612Z",
    fill: "#C1FF36"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1307 23.2675L23.9603 22.8252L23.6998 23.0492L21.8701 23.4915L22.1307 23.2675Z",
    fill: "#0CF4EB"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4125 22.4917L19.358 22.0609L19.1959 21.5898L17.2446 22.0034L17.4125 22.4917Z",
    fill: "#2CFFCA"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2971 11.2676L15.5229 11.819L16.0556 13.1919L15.7777 12.6405L15.2971 11.2676Z",
    fill: "#FF6000"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4541 14.6621L16.651 15.3687L16.9405 16.8967L16.7378 16.1901L16.4541 14.6621Z",
    fill: "#FFE600"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8524 29.9954L12.6497 29.897L11.9434 29.8564L12.1055 29.9549L12.8524 29.9954Z",
    fill: "#0000ED"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85502 21.2054L7.02873 21.7855L6.93609 20.4356L6.75659 19.8037L6.85502 21.2054Z",
    fill: "#56FFA0"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M19.024 20.579L20.9 20.1826L20.8826 19.6714L19.0066 20.062L19.024 20.579Z",
    fill: "#6DFF8A"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7428 24.1462L21.5956 23.6465L21.2946 23.7154L19.4302 24.2152L19.7428 24.1462Z",
    fill: "#00D4FF"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52271 10.1758L7.63272 11.0375L8.30437 10.2103L8.19436 9.34863L7.52271 10.1758Z",
    fill: "#FF1A00"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8532 17.9136L28.9881 17.2357L28.8144 16.7417L27.6853 17.4368L27.8532 17.9136Z",
    fill: "#CAFF2C"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5418 29.2185L10.4666 28.9944L9.83545 28.4487L9.87019 28.6326L10.5418 29.2185Z",
    fill: "#000CFF"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M14.461 29.3735L14.2526 29.4827L13.5693 29.8388L13.7488 29.7527L14.461 29.3735Z",
    fill: "#0000FF"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6284 24.4617L18.4697 23.9274L18.1686 23.6689L16.3042 24.1917L16.6284 24.4617Z",
    fill: "#00D0FF"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2914 24.186L18.1558 23.6633L17.8779 23.3301L15.9961 23.8298L16.2914 24.186Z",
    fill: "#00DCFE"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86581 28.6378L9.83107 28.454L9.24627 27.7646L9.24048 27.9025L9.86581 28.6378Z",
    fill: "#0028FF"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M24.896 16.1906L25.9092 15.5645L25.6023 15.8632L24.6064 16.4606L24.896 16.1906Z",
    fill: "#F8F500"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0751 7.91854L8.96509 8.72275L9.80465 8.34936L9.87993 7.55664L9.0751 7.91854Z",
    fill: "#A40000"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9611 24.6574L18.785 24.1117L18.4665 23.9336L16.6252 24.4678L16.9611 24.6574Z",
    fill: "#00C8FF"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M16.438 26.1973L16.3743 26.7257L15.8706 27.6965L15.9169 27.2025L16.438 26.1973Z",
    fill: "#0064FF"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 15.432L6.74723 16.2879L7.04831 15.0184L6.8225 14.1338L6.51562 15.432Z",
    fill: "#FFD700"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11824 25.8983L8.17614 26.0247L7.77662 24.9332L7.69556 24.7437L8.11824 25.8983Z",
    fill: "#0098FF"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2563 22.0037L19.2076 21.5901L19.0918 21.0903L17.1289 21.4867L17.2563 22.0037Z",
    fill: "#43FFB4"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M16.01 23.8361L17.8918 23.3363L17.6428 22.9399L15.7437 23.4167L16.01 23.8361Z",
    fill: "#06ECF1"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2307 29.6323L11.1091 29.3852L10.4548 28.9946L10.5301 29.2187L11.2307 29.6323Z",
    fill: "#0000FF"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4795 21.9754L26.2571 21.4871L26.396 21.0391L24.6069 21.5388L24.4795 21.9754Z",
    fill: "#43FFB4"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5184 20.0447L28.0412 19.4932L28.0296 18.959L26.5068 19.5334L26.5184 20.0447Z",
    fill: "#83FF73"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7783 6.98193L11.6104 7.60233L12.4847 8.00443L12.5657 7.40702L11.7783 6.98193Z",
    fill: "#840000"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M22.37 22.9688L24.1938 22.5322L23.9622 22.8309L22.1326 23.2733L22.37 22.9688Z",
    fill: "#19FFDE"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1704 20.7974L17.2572 21.6073L17.1125 23.0377L17.0256 22.2507L17.1704 20.7974Z",
    fill: "#40FFB7"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2879 24.7609L19.0886 24.2095L18.7644 24.1118L16.9463 24.6575L17.2879 24.7609Z",
    fill: "#00C4FF"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.2818L24.3491 16.7993L24.1349 17.2014L22.7974 17.661L23 17.2818Z",
    fill: "#D4FF23"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0354 18.4652L22.6334 18.0918L22.5234 18.5628L20.9312 18.9247L21.0354 18.4652Z",
    fill: "#AAFF4D"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2301 27.8973L9.23589 27.7594L8.70899 26.938L8.66846 27.0242L9.2301 27.8973Z",
    fill: "#004CFF"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0238 23.9911L21.8708 23.4971L21.5813 23.6464L19.7285 24.1462L20.0238 23.9911Z",
    fill: "#00E0FB"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7355 23.4165L17.6289 22.9398L17.4146 22.4917L15.5039 22.9398L15.7355 23.4165Z",
    fill: "#16FFE1"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6771 17.4371L28.8061 16.742L28.5803 16.2939L27.457 17.0005L27.6771 17.4371Z",
    fill: "#DEFF19"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7134 10.0205L14.8755 10.5777L15.5182 11.8185L15.2924 11.267L14.7134 10.0205Z",
    fill: "#FF2900"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2273 16.0007L26.2522 15.3516L25.9163 15.5698L24.9031 16.196L25.2273 16.0007Z",
    fill: "#FFEA00"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0066 20.0564L20.8826 19.6658L20.9116 19.166L19.0298 19.5509L19.0066 20.0564Z",
    fill: "#83FF73"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26202 23.1183L7.38361 23.5147L7.17517 22.2452L7.04199 21.7856L7.26202 23.1183Z",
    fill: "#1FFFD7"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9519 29.8562L11.7898 29.5919L11.1182 29.3794L11.2398 29.6264L11.9519 29.8562Z",
    fill: "#0000FF"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6261 24.7782L19.4152 24.221L19.0968 24.2095L17.2903 24.7609L17.6261 24.7782Z",
    fill: "#00C4FF"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1243 21.4866L19.0872 21.0902L19.0177 20.5732L17.0491 20.9466L17.1243 21.4866Z",
    fill: "#56FFA0"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M13.574 29.839L13.3309 29.7471L12.6418 29.8964L12.8445 29.9941L13.574 29.839Z",
    fill: "#0000FF"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5223 22.9456L17.433 22.4976L17.2651 22.0093L15.3428 22.4286L15.5223 22.9456Z",
    fill: "#29FFCE"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4594 17.0055L28.5826 16.2989L28.3163 15.9141L27.2046 16.6264L27.4594 17.0055Z",
    fill: "#EEFF09"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5732 7.40137L12.4922 7.99878L13.3433 8.64215L13.3375 8.06197L12.5732 7.40137Z",
    fill: "#920000"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8783 27.6963L15.7162 28.0352L15.1372 28.7992L15.2762 28.489L15.8783 27.6963Z",
    fill: "#0038FF"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5599 15.8917L26.6022 15.2139L26.249 15.346L25.2241 15.9951L25.5599 15.8917Z",
    fill: "#FFDE00"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5022 19.5278L28.025 18.9591L27.9555 18.4307L26.4385 19.0166L26.5022 19.5278Z",
    fill: "#9AFF5D"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67412 27.024L8.71465 26.9378L8.25723 26.0015L8.18774 26.0244L8.67412 27.024Z",
    fill: "#0074FF"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M24.595 21.5384L26.3841 21.0387L26.4768 20.5562L24.6818 21.0617L24.595 21.5384Z",
    fill: "#5AFF9D"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9295 25.0419L16.6144 24.4618L16.296 24.186L14.5879 24.749L14.9295 25.0419Z",
    fill: "#00C4FF"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5968 24.7493L16.3049 24.1863L16.0096 23.8359L14.2783 24.3702L14.5968 24.7493Z",
    fill: "#00D0FF"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58398 17.6554L6.80401 18.4251L6.96613 17.1039L6.7519 16.2939L6.58398 17.6554Z",
    fill: "#D1FF26"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2516 16.9655L24.618 16.46L24.3633 16.7989L23.0142 17.2814L23.2516 16.9655Z",
    fill: "#E4FF13"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0388 8.94092L14.1257 9.50387L14.861 10.5723L14.6989 10.0151L14.0388 8.94092Z",
    fill: "#DF0000"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5592 22.6066L24.383 22.1758L24.1862 22.5377L22.3623 22.9742L22.5592 22.6066Z",
    fill: "#29FFCE"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9351 16.897L17.0277 17.7471L17.1725 19.2866L17.0856 18.4422L16.9351 16.897Z",
    fill: "#C4FF33"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3006 25.2546L16.9624 24.6572L16.6266 24.4619L14.9417 25.0421L15.3006 25.2546Z",
    fill: "#00BCFF"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2817 23.7555L22.123 23.2729L21.8624 23.5027L20.0154 23.9967L20.2817 23.7555Z",
    fill: "#09F0EE"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1902 18.0403L22.7998 17.6611L22.6435 18.092L21.0454 18.4596L21.1902 18.0403Z",
    fill: "#BEFF39"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3284 8.06201L13.3342 8.64219L14.139 9.50959L14.0521 8.94665L13.3284 8.06201Z",
    fill: "#B20000"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9684 24.6975L19.7344 24.146L19.4217 24.2207L17.6326 24.7779L17.9684 24.6975Z",
    fill: "#00CCFF"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M14.281 24.3706L16.0122 23.8363L15.7459 23.417L13.9915 23.9168L14.281 24.3706Z",
    fill: "#00E0FB"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1918 16.6264L28.3035 15.9083L27.9966 15.5981L26.8965 16.3162L27.1918 16.6264Z",
    fill: "#FBF100"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07617 12.0601L7.26725 12.962L7.82889 11.951L7.6436 11.0376L7.07617 12.0601Z",
    fill: "#FF5200"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8926 15.8689L26.9464 15.1738L26.5874 15.214L25.5452 15.8919L25.8926 15.8689Z",
    fill: "#FFDB00"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0532 13.1919L16.2327 13.9042L16.6612 15.3748L16.4643 14.6682L16.0532 13.1919Z",
    fill: "#FF9F00"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69876 24.7435L7.77982 24.933L7.47294 23.7727L7.37451 23.5142L7.69876 24.7435Z",
    fill: "#00D4FF"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4608 28.9947L10.4492 28.6271L9.8644 28.1216L9.83545 28.449L10.4608 28.9947Z",
    fill: "#0028FF"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6677 25.37L17.3005 24.7611L16.9589 24.6577L15.2971 25.2551L15.6677 25.37Z",
    fill: "#00B8FF"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0408 19.5506L20.9226 19.1657L21.0036 18.689L19.1218 19.0624L19.0408 19.5506Z",
    fill: "#9AFF5D"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1045 23.0317L17.1277 23.744L16.8498 25.0365L16.8208 24.3529L17.1045 23.0317Z",
    fill: "#02E8F4"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82528 28.4547L9.85423 28.1273L9.31575 27.4839L9.24048 27.7654L9.82528 28.4547Z",
    fill: "#0040FF"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0488 20.9524L19.0174 20.579L18.9943 20.062L17.0256 20.4124L17.0488 20.9524Z",
    fill: "#6DFF8A"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 22.4227L17.2556 22.0033L17.1282 21.4863L15.1943 21.8712L15.3333 22.4227Z",
    fill: "#40FFB7"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9051 16.3165L28.0052 15.5984L27.6752 15.3687L26.5867 16.0867L26.9051 16.3165Z",
    fill: "#FFE600"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2578 15.9375L27.329 15.2309L26.97 15.1792L25.9104 15.8743L26.2578 15.9375Z",
    fill: "#FFD700"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M12.646 29.8964L12.4376 29.6321L11.7717 29.5977L11.9338 29.8619L12.646 29.8964Z",
    fill: "#0000FF"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5902 16.0868L27.6788 15.3687L27.3256 15.2251L26.2544 15.9374L26.5902 16.0868Z",
    fill: "#FFDB00"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9837 23.9165L15.7381 23.4167L15.5123 22.9399L13.7405 23.4052L13.9837 23.9165Z",
    fill: "#0FF8E7"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1092 29.3796L11.0513 28.989L10.4434 28.6328L10.4549 29.0005L11.1092 29.3796Z",
    fill: "#0018FF"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88802 7.56178L9.81274 8.35451L10.6986 8.22813L10.7392 7.45264L9.88802 7.56178Z",
    fill: "#890000"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1349 28.7988L14.8917 28.9309L14.2664 29.4767L14.4748 29.3675L15.1349 28.7988Z",
    fill: "#0018FF"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4615 19.0108L27.9843 18.4248L27.8627 17.9136L26.3457 18.511L26.4615 19.0108Z",
    fill: "#B1FF46"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5218 16.7127L24.8999 16.1899L24.6104 16.4599L23.2439 16.9654L23.5218 16.7127Z",
    fill: "#F1FC06"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24102 27.7598L9.31629 27.4784L8.82412 26.7144L8.71411 26.9384L9.24102 27.7598Z",
    fill: "#0060FF"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6863 21.0613L26.4812 20.5558L26.5217 20.0503L24.721 20.5673L24.6863 21.0613Z",
    fill: "#6DFF8A"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0286 25.3869L17.6382 24.778L17.2966 24.7607L15.6638 25.3696L16.0286 25.3869Z",
    fill: "#00B8FF"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75659 19.8034L6.93609 20.4352L6.96504 19.1083L6.78554 18.4189L6.75659 19.8034Z",
    fill: "#94FF63"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M18.272 24.5306L20.0264 23.9849L19.7311 24.14L17.9651 24.6914L18.272 24.5306Z",
    fill: "#00D8FF"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4762 25.6681L14.9237 25.0477L14.5821 24.749L13.0999 25.3407L13.4762 25.6681Z",
    fill: "#00B4FF"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M22.724 22.1873L24.5478 21.7622L24.3915 22.1758L22.5676 22.6066L22.724 22.1873Z",
    fill: "#3CFFBA"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5437 23.4398L22.3734 22.9688L22.1418 23.2675L20.3005 23.75L20.5437 23.4398Z",
    fill: "#16FFE1"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1035 25.3409L14.5858 24.7492L14.2673 24.3701L12.7561 24.9273L13.1035 25.3409Z",
    fill: "#00C0FF"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1807 26.0241L8.25018 26.0011L7.87382 24.9786L7.77539 24.9326L8.1807 26.0241Z",
    fill: "#00A8FF"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3962 17.6719L23.0174 17.2812L22.8147 17.6604L21.2051 18.0395L21.3962 17.6719Z",
    fill: "#D1FF26"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18774 9.34268L8.29776 10.2043L9.06205 9.59543L8.95783 8.72803L8.18774 9.34268Z",
    fill: "#D10000"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M13.876 25.8928L15.2946 25.2551L14.9356 25.0483L13.488 25.6687L13.876 25.8928Z",
    fill: "#00A8FF"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7476 23.4055L15.5194 22.9402L15.3399 22.4175L13.5449 22.8426L13.7476 23.4055Z",
    fill: "#23FFD4"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7848 29.5978L11.6806 29.1899L11.061 28.9946L11.1189 29.3852L11.7848 29.5978Z",
    fill: "#0010FF"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7646 24.9275L14.2759 24.3703L13.9921 23.9165L12.4578 24.4335L12.7646 24.9275Z",
    fill: "#00D4FF"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1956 21.8717L17.1295 21.4869L17.0542 20.9526L15.1145 21.303L15.1956 21.8717Z",
    fill: "#56FFA0"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2658 29.4829L13.9878 29.4082L13.3394 29.7471L13.5825 29.839L14.2658 29.4829Z",
    fill: "#0008FF"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0256 20.4124L18.9943 20.062L19.0232 19.5508L17.0546 19.884L17.0256 20.4124Z",
    fill: "#83FF73"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0994 19.0623L20.9812 18.6889L21.1086 18.2466L19.2267 18.6142L19.0994 19.0623Z",
    fill: "#B1FF46"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3364 18.5107L27.8534 17.9133L27.6797 17.4365L26.1743 18.0397L26.3364 18.5107Z",
    fill: "#C4FF33"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2884 26.0189L15.6723 25.3698L15.3075 25.2549L13.8889 25.8925L14.2884 26.0189Z",
    fill: "#00A8FF"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8304 16.5408L25.2258 15.9951L24.9073 16.1847L23.5293 16.7074L23.8304 16.5408Z",
    fill: "#FEED00"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8433 25.0361L16.768 25.5991L16.3743 26.725L16.438 26.1965L16.8433 25.0361Z",
    fill: "#00A8FF"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3779 25.3009L17.9644 24.6978L17.6344 24.7724L16.0305 25.3871L16.3779 25.3009Z",
    fill: "#00C0FF"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4544 28.6329L10.576 28.1504L10.0375 27.6851L9.86963 28.1274L10.4544 28.6329Z",
    fill: "#0040FF"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71931 26.9381L8.82932 26.7198L8.40086 25.8467L8.2561 26.0018L8.71931 26.9381Z",
    fill: "#0088FF"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03764 21.7851L7.17081 22.2447L7.07817 20.9637L6.93921 20.4409L7.03764 21.7851Z",
    fill: "#5AFF9D"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86483 28.1268L10.0327 27.6844L9.529 27.0928L9.32056 27.4891L9.86483 28.1268Z",
    fill: "#0058FF"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81372 14.1279L7.03953 15.0125L7.47379 13.8694L7.25956 12.9561L6.81372 14.1279Z",
    fill: "#FF9400"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4545 24.4389L13.9889 23.9219L13.7457 23.4106L12.1824 23.8817L12.4545 24.4389Z",
    fill: "#06ECF1"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3083 26.3122L13.4721 25.6689L13.0958 25.3472L11.8972 25.9561L12.3083 26.3122Z",
    fill: "#00A0FF"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5527 24.2838L20.2897 23.7554L20.0176 23.9909L18.2632 24.5366L18.5527 24.2838Z",
    fill: "#02E8F4"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9012 25.9555L13.1055 25.3408L12.7581 24.9272L11.519 25.5017L11.9012 25.9555Z",
    fill: "#00B0FF"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1918 19.2866L17.2787 20.1138L17.2729 21.6073L17.186 20.7974L17.1918 19.2866Z",
    fill: "#83FF73"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0456 28.9891L11.1151 28.4778L10.5535 28.1504L10.4319 28.6329L11.0456 28.9891Z",
    fill: "#0034FF"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7208 20.5618L26.5215 20.0448L26.51 19.5278L24.7092 20.0448L24.7208 20.5618Z",
    fill: "#83FF73"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M13.344 29.7468L13.0892 29.4883L12.4465 29.6319L12.655 29.8961L13.344 29.7468Z",
    fill: "#0008FF"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5415 22.8486L15.3364 22.4235L15.2032 21.8721L13.3967 22.2512L13.5415 22.8486Z",
    fill: "#39FFBE"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5154 11.8188L15.6717 12.5312L16.2276 13.9041L16.0481 13.1918L15.5154 11.8188Z",
    fill: "#FF6000"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M12.738 26.5592L13.8671 25.8929L13.4734 25.6631L12.3096 26.3065L12.738 26.5592Z",
    fill: "#0094FF"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6037 17.3678L23.2423 16.96L22.9992 17.2759L21.3779 17.6665L21.6037 17.3678Z",
    fill: "#E1FF16"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7271 23.0606L22.5568 22.6011L22.3599 22.963L20.5303 23.434L20.7271 23.0606Z",
    fill: "#29FFCE"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8315 21.7221L24.6612 21.3027L24.5512 21.7623L22.7273 22.1874L22.8315 21.7221Z",
    fill: "#53FFA4"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32053 27.4843L9.52898 27.0879L9.07156 26.3813L8.82837 26.7145L9.32053 27.4843Z",
    fill: "#0074FF"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6778 26.036L16.0327 25.3869L15.6679 25.3696L14.2783 26.0187L14.6778 26.036Z",
    fill: "#00A8FF"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M26.176 18.0398L27.6872 17.4367L27.4672 17.0059L25.9675 17.6148L26.176 18.0398Z",
    fill: "#D7FF1F"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5396 25.5022L12.7787 24.9277L12.466 24.4395L11.198 24.9622L11.5396 25.5022Z",
    fill: "#00C4FF"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1458 16.4545L25.5586 15.8916L25.2228 16.0007L23.8274 16.5465L24.1458 16.4545Z",
    fill: "#FFE600"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36616 23.5146L7.46459 23.7731L7.26773 22.5725L7.15771 22.2451L7.36616 23.5146Z",
    fill: "#26FFD1"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4488 29.6326L12.2983 29.219L11.6787 29.1846L11.7829 29.5924L12.4488 29.6326Z",
    fill: "#0014FF"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1093 21.303L17.049 20.9526L17.0258 20.4126L15.0803 20.7343L15.1093 21.303Z",
    fill: "#6DFF8A"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7349 7.45264L10.6943 8.22812L11.6092 8.36024V7.59625L10.7349 7.45264Z",
    fill: "#800000"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M10.558 28.1499L10.8765 27.5812L10.3843 27.1504L10.0195 27.6846L10.558 28.1499Z",
    fill: "#005CFF"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4558 26.9555L12.3185 26.3063L11.9074 25.9502L11.0042 26.5648L11.4558 26.9555Z",
    fill: "#008CFF"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0196 27.685L10.3844 27.1566L9.92118 26.6108L9.51587 27.0934L10.0196 27.685Z",
    fill: "#0070FF"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1744 23.8763L13.7377 23.4052L13.535 22.8423L11.9543 23.2674L12.1744 23.8763Z",
    fill: "#1CFFDB"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M10.997 26.5645L11.9002 25.9499L11.5181 25.4961L10.5801 26.0648L10.997 26.5645Z",
    fill: "#009CFF"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1789 26.6968L14.2732 26.019L13.8737 25.8926L12.7446 26.5589L13.1789 26.6968Z",
    fill: "#0094FF"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6686 29.184L11.6918 28.6555L11.1186 28.4717L11.0491 28.9829L11.6686 29.184Z",
    fill: "#002CFF"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6597 15.3687L16.7523 16.2246L17.0418 17.7468L16.9492 16.8967L16.6597 15.3687Z",
    fill: "#FFE600"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7101 25.1224L18.2734 24.5308L17.9608 24.6973L16.3743 25.3005L16.7101 25.1224Z",
    fill: "#00CCFF"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3866 26.7256L16.2071 27.099L15.7207 28.0353L15.8828 27.6964L16.3866 26.7256Z",
    fill: "#0070FF"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0605 19.8841L19.0292 19.5509L19.1102 19.0684L17.1416 19.3843L17.0605 19.8841Z",
    fill: "#9AFF5D"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2249 18.6146L21.1066 18.247L21.2803 17.8506L19.3986 18.2125L19.2249 18.6146Z",
    fill: "#C4FF33"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8672 27.5812L11.4404 26.9551L10.9888 26.5645L10.375 27.1504L10.8672 27.5812Z",
    fill: "#0074FF"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9309 27.231L12.7531 26.5589L12.3246 26.3062L11.4619 26.9553L11.9309 27.231Z",
    fill: "#0080FF"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M11.119 28.4772L11.3911 27.8798L10.8758 27.5811L10.5574 28.1497L11.119 28.4772Z",
    fill: "#004CFF"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78961 24.9328L7.88804 24.9788L7.60433 23.8931L7.48853 23.7725L7.78961 24.9328Z",
    fill: "#00E0FB"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9597 17.6146L27.4594 17.0057L27.2046 16.6323L25.7166 17.2412L25.9597 17.6146Z",
    fill: "#E7FF0F"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3744 27.1503L10.9882 26.5643L10.5713 26.0703L9.91699 26.6103L10.3744 27.1503Z",
    fill: "#0084FF"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4672 16.4483L25.8974 15.8682L25.55 15.8911L24.1372 16.4541L24.4672 16.4483Z",
    fill: "#FFE200"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1737 24.9623L12.4417 24.4395L12.1696 23.8823L10.8784 24.3534L11.1737 24.9623Z",
    fill: "#00E0FB"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5843 26.0706L11.5223 25.5019L11.1807 24.9619L10.2021 25.4789L10.5843 26.0706Z",
    fill: "#00B4FF"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52096 27.0873L9.92627 26.6048L9.50938 25.9614L9.06934 26.3808L9.52096 27.0873Z",
    fill: "#008CFF"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25997 26.0018L8.40473 25.8467L8.05732 24.8989L7.8894 24.9793L8.25997 26.0018Z",
    fill: "#00B4FF"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3937 27.8804L11.9206 27.2313L11.4516 26.9556L10.8784 27.5817L11.3937 27.8804Z",
    fill: "#0068FF"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7043 20.0447L26.505 19.5277L26.4414 19.0107L24.6406 19.5277L24.7043 20.0447Z",
    fill: "#9AFF5D"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 26.714L9.07619 26.3809L8.68247 25.5767L8.40454 25.8409L8.83301 26.714Z",
    fill: "#009CFF"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8203 23.9507L20.5457 23.4395L20.3083 23.7496L18.5713 24.2781L18.8203 23.9507Z",
    fill: "#13FCE4"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0501 25.9495L16.376 25.3062L16.0229 25.3923L14.668 26.0472L15.0501 25.9495Z",
    fill: "#00B0FF"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73389 16.2879L6.94812 17.0979L7.24341 15.8629L7.03497 15.0127L6.73389 16.2879Z",
    fill: "#FFDB00"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3923 22.2506L15.1988 21.8714L15.1177 21.3027L13.3054 21.6359L13.3923 22.2506Z",
    fill: "#53FFA4"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8725 17.138L23.5227 16.7129L23.2448 16.9599L21.6062 17.3677L21.8725 17.138Z",
    fill: "#EEFF09"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7133 17.2355L27.2071 16.6266L26.9176 16.3164L25.4412 16.9253L25.7133 17.2355Z",
    fill: "#F4F802"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92697 26.6106L10.587 26.0707L10.2107 25.479L9.51587 25.9615L9.92697 26.6106Z",
    fill: "#00A0FF"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8095 16.523L26.2571 15.9314L25.9096 15.8682L24.4795 16.4483L24.8095 16.523Z",
    fill: "#FFE200"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 27.38L13.1878 26.6965L12.7536 26.5586L11.9314 27.2307L12.4062 27.38Z",
    fill: "#007CFF"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6142 26.7199L14.668 26.0363L14.2685 26.019L13.1799 26.6969L13.6142 26.7199Z",
    fill: "#0094FF"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7182 28.0356L15.4461 28.208L14.896 28.9375L15.1392 28.8054L15.7182 28.0356Z",
    fill: "#0044FF"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61548 11.0318L7.80076 11.9451L8.46663 11.1294L8.28713 10.2046L7.61548 11.0318Z",
    fill: "#FF1E00"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8724 21.2227L24.7021 20.8091L24.6442 21.2974L22.8203 21.7167L22.8724 21.2227Z",
    fill: "#66FF90"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7029 28.6611L11.9287 28.0465L11.4018 27.8799L11.1296 28.4773L11.7029 28.6611Z",
    fill: "#0048FF"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4227 16.926L26.8991 16.3171L26.5807 16.0815L25.1216 16.6847L25.4227 16.926Z",
    fill: "#FEED00"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M20.898 22.6303L22.7218 22.188L22.5655 22.6073L20.7358 23.0669L20.898 22.6303Z",
    fill: "#3CFFBA"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1248 16.6842L26.5839 16.081L26.2481 15.9316L24.8005 16.5233L25.1248 16.6842Z",
    fill: "#FFE200"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9566 23.2676L13.5373 22.8425L13.3925 22.2451L11.7944 22.6128L11.9566 23.2676Z",
    fill: "#36FFC1"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9205 28.0471L12.401 27.3808L11.9205 27.2314L11.3936 27.8806L11.9205 28.0471Z",
    fill: "#0064FF"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2168 25.4789L11.1954 24.9619L10.9001 24.353L9.89258 24.8068L10.2168 25.4789Z",
    fill: "#00D0FF"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8848 10.5781L15.0179 11.2962L15.6838 12.5312L15.5275 11.8189L14.8848 10.5781Z",
    fill: "#FF2900"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0803 20.7281L17.0258 20.4064L17.0548 19.8779L15.1093 20.1651L15.0803 20.7281Z",
    fill: "#87FF70"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2983 29.2183L12.2693 28.6899L11.7019 28.6611L11.6787 29.1896L12.2983 29.2183Z",
    fill: "#0030FF"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8861 24.3529L12.1831 23.8819L11.963 23.2729L10.6487 23.6865L10.8861 24.3529Z",
    fill: "#13FCE4"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2567 21.6016L17.2741 22.3426L17.1294 23.7385L17.1062 23.0319L17.2567 21.6016Z",
    fill: "#43FFB4"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06797 26.3807L9.50802 25.9614L9.14904 25.2261L8.66846 25.5822L9.06797 26.3807Z",
    fill: "#00ACFF"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 28.9313L14.5935 28.8911L14.0029 29.4081L14.2809 29.477L14.9062 28.9313Z",
    fill: "#002CFF"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95532 8.72788L9.05954 9.59528L9.89911 9.22189L9.7891 8.35449L8.95532 8.72788Z",
    fill: "#A80000"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0234 24.8528L18.5636 24.2783L18.2799 24.5311L16.7166 25.1227L17.0234 24.8528Z",
    fill: "#00DCFE"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6104 7.59668V8.36068L12.5252 8.74555L12.4905 7.99879L11.6104 7.59668Z",
    fill: "#800000"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0857 29.488L12.883 29.0859L12.2866 29.2181L12.4372 29.6317L13.0857 29.488Z",
    fill: "#0020FF"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4075 18.212L21.2893 17.8501L21.4977 17.5112L19.6159 17.8674L19.4075 18.212Z",
    fill: "#D7FF1F"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50816 25.9613L10.203 25.4787L9.87293 24.8066L9.14917 25.226L9.50816 25.9613Z",
    fill: "#00C0FF"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0016 29.4079L13.7063 29.1724L13.0984 29.4883L13.3532 29.7468L14.0016 29.4079Z",
    fill: "#0020FF"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1404 19.3782L19.109 19.0623L19.2364 18.6143L17.2678 18.9072L17.1404 19.3782Z",
    fill: "#B1FF46"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6579 19.528L26.4586 19.011L26.3428 18.5112L24.5479 19.0282L24.6579 19.528Z",
    fill: "#B1FF46"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77954 18.4242L6.95903 19.1136L7.11537 17.8441L6.94166 17.103L6.77954 18.4242Z",
    fill: "#CEFF29"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8871 27.4086L13.6283 26.7193L13.194 26.6963L12.4124 27.3799L12.8871 27.4086Z",
    fill: "#007CFF"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1538 16.9771L23.8214 16.5405L23.5203 16.7129L21.8701 17.1322L22.1538 16.9771Z",
    fill: "#FBF100"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4107 25.7544L16.7077 25.1226L16.3718 25.3006L15.0459 25.944L15.4107 25.7544Z",
    fill: "#00BCFF"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3925 25.8466L8.67042 25.5766L8.34618 24.6978L8.03931 24.8931L8.3925 25.8466Z",
    fill: "#00C4FF"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0319 26.6223L15.0509 25.9502L14.6688 26.0364L13.615 26.7199L14.0319 26.6223Z",
    fill: "#009CFF"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2945 21.6361L15.1068 21.303L15.0779 20.7285L13.2598 21.0157L13.2945 21.6361Z",
    fill: "#6DFF8A"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2691 28.6902L12.4428 28.0756L11.9217 28.0469L11.7017 28.6615L12.2691 28.6902Z",
    fill: "#004CFF"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0153 23.5493L20.7291 23.061L20.5265 23.4402L18.801 23.9514L19.0153 23.5493Z",
    fill: "#23FFD4"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M12.441 28.0756L12.8753 27.4092L12.4005 27.3862L11.9199 28.0526L12.441 28.0756Z",
    fill: "#0064FF"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87352 24.8071L10.881 24.3532L10.6378 23.6812L9.60718 24.0718L9.87352 24.8071Z",
    fill: "#09F0EE"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1301 9.50928L14.2343 10.2388L14.9986 11.3015L14.8655 10.5835L14.1301 9.50928Z",
    fill: "#DF0000"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8888 20.7053L24.7185 20.3032L24.7069 20.8145L22.8772 21.2281L22.8888 20.7053Z",
    fill: "#7DFF7A"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8708 24.9791L8.03872 24.8987L7.77237 23.8877L7.5813 23.8934L7.8708 24.9791Z",
    fill: "#02E8F4"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93921 20.4417L7.07817 20.9644L7.10712 19.7007L6.96816 19.1147L6.93921 20.4417Z",
    fill: "#94FF63"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 7.99902L12.5269 8.74579L13.4128 9.37767L13.3433 8.64239L12.4922 7.99902Z",
    fill: "#920000"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0055 22.1409L22.8294 21.7158L22.7194 22.1811L20.8955 22.6234L21.0055 22.1409Z",
    fill: "#50FFA7"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8059 22.6185L13.404 22.2509L13.3113 21.6362L11.7017 21.9522L11.8059 22.6185Z",
    fill: "#50FFA7"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6401 23.6814L11.9545 23.2678L11.7923 22.6187L10.4548 22.9748L10.6401 23.6814Z",
    fill: "#30FFC7"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5445 19.0276L26.3395 18.5106L26.1773 18.0396L24.3882 18.5565L24.5445 19.0276Z",
    fill: "#C4FF33"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46859 23.7728L7.58439 23.8935L7.39911 22.7676L7.27173 22.5723L7.46859 23.7728Z",
    fill: "#2CFFCA"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68313 25.5822L9.15792 25.2261L8.86263 24.4219L8.35889 24.7033L8.68313 25.5822Z",
    fill: "#00D4FF"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18029 22.2447L7.2903 22.5722L7.20345 21.3601L7.08765 20.958L7.18029 22.2447Z",
    fill: "#5AFF9D"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3394 8.64209L13.4088 9.37737L14.2484 10.2333L14.1442 9.50375L13.3394 8.64209Z",
    fill: "#B20000"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15784 25.2259L9.88161 24.8066L9.61526 24.0713L8.86255 24.4217L9.15784 25.2259Z",
    fill: "#00E4F8"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4678 16.9027L24.1528 16.4546L23.8343 16.5465L22.1667 16.9831L22.4678 16.9027Z",
    fill: "#FFEA00"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1145 20.1711L17.06 19.8839L17.141 19.3784L15.1956 19.6369L15.1145 20.1711Z",
    fill: "#9DFF5A"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M19.603 17.8732L21.4848 17.5171L21.728 17.2471L19.8462 17.6032L19.603 17.8732Z",
    fill: "#E7FF0F"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M17.292 24.4964L18.8148 23.9507L18.5658 24.2839L17.0256 24.8583L17.292 24.4964Z",
    fill: "#09F0EE"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1283 23.7388L17.0473 24.3419L16.7751 25.5942L16.8504 25.0313L17.1283 23.7388Z",
    fill: "#06ECF1"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8835 29.0862L12.814 28.5635L12.2639 28.6841L12.2871 29.2126L12.8835 29.0862Z",
    fill: "#003CFF"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3446 27.2999L14.0452 26.6221L13.6225 26.7197L12.8813 27.409L13.3446 27.2999Z",
    fill: "#0088FF"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0376 17.7471L17.1244 18.5972L17.2634 20.1138L17.1766 19.2866L17.0376 17.7471Z",
    fill: "#C4FF33"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2358 13.9038L16.3285 14.7655L16.757 16.2303L16.6643 15.3744L16.2358 13.9038Z",
    fill: "#FF9F00"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2561 18.9133L19.2247 18.6204L19.3984 18.2183L17.4298 18.4997L17.2561 18.9133Z",
    fill: "#C7FF30"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24878 12.9564L7.46301 13.8698L8.01307 12.8875L7.80463 11.9512L7.24878 12.9564Z",
    fill: "#FF5900"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7372 25.4614L17.0052 24.8525L16.6984 25.1225L15.4014 25.7544L15.7372 25.4614Z",
    fill: "#00D0FF"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3682 18.5567L26.1574 18.0397L25.949 17.6089L24.1714 18.1201L24.3682 18.5567Z",
    fill: "#D7FF1F"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4211 26.4093L15.4054 25.7544L15.0464 25.9497L14.0273 26.6218L14.4211 26.4093Z",
    fill: "#00ACFF"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7663 16.9083L24.4686 16.4487L24.1385 16.4545L22.4536 16.9025L22.7663 16.9083Z",
    fill: "#FFE600"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9503 27.9609L13.344 27.3003L12.8808 27.4037L12.4465 28.07L12.9503 27.9609Z",
    fill: "#0070FF"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M12.814 28.569L12.9472 27.9658L12.4434 28.0807L12.2639 28.6954L12.814 28.569Z",
    fill: "#0054FF"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2598 21.0216L15.0779 20.7343L15.1068 20.1714L13.2887 20.4184L13.2598 21.0216Z",
    fill: "#87FF70"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M22.843 20.183L24.6785 19.7866L24.719 20.3036L22.8893 20.7057L22.843 20.183Z",
    fill: "#94FF63"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61996 24.0718L10.6506 23.6812L10.4711 22.9746L9.4231 23.2963L9.61996 24.0718Z",
    fill: "#26FFD1"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1914 23.0894L20.8995 22.6299L20.7432 23.0665L19.0293 23.549L19.1914 23.0894Z",
    fill: "#39FFBE"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6979 29.1731L13.4547 28.7939L12.8931 29.0869L13.0957 29.489L13.6979 29.1731Z",
    fill: "#0038FF"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05321 24.8984L8.36009 24.7031L8.1169 23.7725L7.78687 23.8873L8.05321 24.8984Z",
    fill: "#0CF4EB"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0577 21.6248L22.8815 21.2227L22.8236 21.7224L20.9998 22.1475L21.0577 21.6248Z",
    fill: "#66FF90"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7749 25.5991L16.578 26.0185L16.2017 27.1041L16.3812 26.7308L16.7749 25.5991Z",
    fill: "#00B0FF"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M24.179 18.1263L25.9566 17.6151L25.7076 17.2417L23.9417 17.7472L24.179 18.1263Z",
    fill: "#E4FF13"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6965 21.9515L13.3062 21.6355L13.2714 21.0151L11.656 21.2794L11.6965 21.9515Z",
    fill: "#6AFF8D"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0758 17.0001L24.7955 16.5233L24.4655 16.4429L22.7632 16.9024L23.0758 17.0001Z",
    fill: "#FFE600"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4564 22.9743L11.7939 22.6239L11.6897 21.9575L10.3406 22.2447L10.4564 22.9743Z",
    fill: "#49FFAD"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8655 17.5969L21.7473 17.2407L22.0194 17.0454L20.1376 17.3958L19.8655 17.5969Z",
    fill: "#F4F802"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80127 8.34915L9.90549 9.22229L10.7972 9.10166L10.6929 8.22852L9.80127 8.34915Z",
    fill: "#8D0000"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5807 28.891L14.2449 28.6899L13.6948 29.1782L13.9901 29.4137L14.5807 28.891Z",
    fill: "#0040FF"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8543 24.4222L9.60702 24.0718L9.40436 23.2905L8.63428 23.5663L8.8543 24.4222Z",
    fill: "#1FFFD7"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35109 24.7038L8.85483 24.4223L8.63481 23.5664L8.10791 23.7732L8.35109 24.7038Z",
    fill: "#16FFE1"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9341 17.7415L25.7001 17.236L25.4221 16.9258L23.6677 17.4198L23.9341 17.7415Z",
    fill: "#F1FC06"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1943 19.6369L17.1398 19.3784L17.2672 18.9131L15.3275 19.1429L15.1943 19.6369Z",
    fill: "#B4FF43"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3951 17.1726L25.1321 16.6843L24.8137 16.5234L23.094 17.0002L23.3951 17.1726Z",
    fill: "#FFE600"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1941 27.0986L15.8988 27.3112L15.4355 28.2016L15.7077 28.0292L16.1941 27.0986Z",
    fill: "#007CFF"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M23.676 17.4252L25.4305 16.9312L25.1294 16.6899L23.3923 17.1782L23.676 17.4252Z",
    fill: "#FEED00"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5046 24.0663L19.0159 23.5493L18.8016 23.9514L17.2788 24.4971L17.5046 24.0663Z",
    fill: "#1CFFDB"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4337 28.2075H15.0863L14.5652 28.8968L14.8779 28.9371L15.4337 28.2075Z",
    fill: "#0054FF"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30176 10.2046L8.48125 11.1295L9.23975 10.532L9.06605 9.5957L8.30176 10.2046Z",
    fill: "#D60000"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7736 27.0703L14.4337 26.4097L14.04 26.6222L13.3394 27.3L13.7736 27.0703Z",
    fill: "#0098FF"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4385 18.4938L19.4013 18.2123L19.6098 17.8677L17.6527 18.1319L17.4385 18.4938Z",
    fill: "#D7FF1F"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05347 15.0128L7.26191 15.8629L7.6788 14.7543L7.48772 13.8696L7.05347 15.0128Z",
    fill: "#FF9C00"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59397 23.8935L7.78505 23.8877L7.61135 22.8423L7.40869 22.7676L7.59397 23.8935Z",
    fill: "#30FFC7"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7517 19.6655L24.5872 19.2749L24.674 19.7862L22.8386 20.1825L22.7517 19.6655Z",
    fill: "#AAFF4D"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4444 28.7937L13.3286 28.2939L12.8132 28.5697L12.8827 29.0924L13.4444 28.7937Z",
    fill: "#0050FF"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0446 25.0764L17.2895 24.502L17.0232 24.8581L15.7551 25.4613L16.0446 25.0764Z",
    fill: "#00E4F8"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8084 26.0938L15.7638 25.4619L15.4338 25.7549L14.4495 26.4097L14.8084 26.0938Z",
    fill: "#00C0FF"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1294 17.3964L22.0112 17.046L22.3065 16.9312L20.4305 17.2816L20.1294 17.3964Z",
    fill: "#FEED00"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2825 20.4126L15.1006 20.1656L15.1816 19.6313L13.3635 19.8324L13.2825 20.4126Z",
    fill: "#A0FF56"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M19.295 22.5724L20.9973 22.1416L20.8873 22.6299L19.1792 23.0894L19.295 22.5724Z",
    fill: "#50FFA7"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4247 27.7079L13.7779 27.0703L13.3437 27.3001L12.95 27.9607L13.4247 27.7079Z",
    fill: "#0080FF"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41351 23.2962L10.4615 22.9745L10.3457 22.2393L9.28613 22.4863L9.41351 23.2962Z",
    fill: "#46FFB1"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2504 20.1138L17.2678 20.8893L17.262 22.3483L17.2446 21.6073L17.2504 20.1138Z",
    fill: "#83FF73"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0685 21.0901L22.8923 20.7109L22.8808 21.2279L21.0569 21.63L21.0685 21.0901Z",
    fill: "#7DFF7A"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3343 28.2934L13.4212 27.7075L12.9464 27.9603L12.8132 28.5634L13.3343 28.2934Z",
    fill: "#0068FF"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26727 22.5724L7.39466 22.7677L7.31938 21.6361L7.18042 21.3604L7.26727 22.5724Z",
    fill: "#5DFF9A"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M15.675 12.5312L15.7677 13.3987L16.3178 14.7658L16.2251 13.9042L15.675 12.5312Z",
    fill: "#FF6000"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96216 17.0978L7.13586 17.8389L7.41958 16.6555L7.25746 15.8628L6.96216 17.0978Z",
    fill: "#FFE200"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M11.656 21.2796L13.2714 21.0211L13.2946 20.418L11.6792 20.6248L11.656 21.2796Z",
    fill: "#87FF70"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M10.357 22.2396L11.7061 21.9524L11.6598 21.2803L10.3049 21.5043L10.357 22.2396Z",
    fill: "#6AFF8D"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6248 19.1716L24.466 18.7925L24.5992 19.2808L22.7637 19.6714L22.6248 19.1716Z",
    fill: "#BEFF39"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78339 23.8876L8.11343 23.7727L7.95709 22.8076L7.61548 22.8421L7.78339 23.8876Z",
    fill: "#36FFC1"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3313 19.1369L17.271 18.9071L17.4447 18.4878L15.5166 18.6888L15.3313 19.1369Z",
    fill: "#CAFF2C"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 18.1376L19.6238 17.8734L19.8728 17.5977L17.9215 17.8504L17.6667 18.1376Z",
    fill: "#E7FF0F"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08765 20.9582L7.20345 21.3603L7.2324 20.1712L7.1166 19.7002L7.08765 20.9582Z",
    fill: "#90FF66"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97339 19.1141L7.11235 19.7L7.26289 18.488L7.13551 17.8389L6.97339 19.1141Z",
    fill: "#CAFF2C"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65208 23.5663L9.42216 23.2905L9.29478 22.4863L8.50732 22.6816L8.65208 23.5663Z",
    fill: "#40FFB7"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.449 17.2818L22.325 16.9314L22.6318 16.897L20.7616 17.2474L20.449 17.2818Z",
    fill: "#FFE600"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2526 28.6899L13.9689 28.3452L13.4536 28.799L13.6968 29.1781L14.2526 28.6899Z",
    fill: "#0054FF"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6923 23.5657L19.1919 23.0889L19.0298 23.5484L17.5186 24.0654L17.6923 23.5657Z",
    fill: "#33FFC4"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11434 23.7732L8.64124 23.5664L8.49649 22.6875L7.95801 22.8139L8.11434 23.7732Z",
    fill: "#3CFFBA"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1684 26.7198L14.7937 26.0879L14.4347 26.4096L13.7747 27.0702L14.1684 26.7198Z",
    fill: "#00ACFF"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 8.22852L10.7986 9.10166L11.7134 9.23378L11.6092 8.36064L10.6943 8.22852Z",
    fill: "#800000"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7507 16.2251L16.8376 17.0925L17.1213 18.5918L17.0344 17.7416L16.7507 16.2251Z",
    fill: "#FFEA00"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4307 18.7064L24.2777 18.333L24.4572 18.7868L22.6159 19.1659L22.4307 18.7064Z",
    fill: "#D1FF26"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0225 20.5445L22.8521 20.1826L22.8927 20.7054L21.0688 21.0845L21.0225 20.5445Z",
    fill: "#94FF63"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2791 24.6059L17.5066 24.0659L17.2866 24.4967L16.0417 25.0712L16.2791 24.6059Z",
    fill: "#16FFE1"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1119 25.6683L16.0383 25.0767L15.7488 25.4615L14.7935 26.0934L15.1119 25.6683Z",
    fill: "#00D8FF"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3628 22.0267L21.0709 21.6304L21.013 22.1474L19.3049 22.5782L19.3628 22.0267Z",
    fill: "#66FF90"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7471 17.2474L22.6173 16.897L22.93 16.9487L21.0597 17.2991L20.7471 17.2474Z",
    fill: "#FFE200"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3738 19.8386L15.1919 19.6376L15.3251 19.1436L13.5185 19.3044L13.3738 19.8386Z",
    fill: "#B7FF40"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2749 22.3481L17.188 22.9915L17.0491 24.3414L17.1301 23.7383L17.2749 22.3481Z",
    fill: "#43FFB4"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8208 11.951L8.02925 12.8873L8.67774 12.0888L8.48667 11.1353L7.8208 11.951Z",
    fill: "#FF2500"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28715 22.4866L10.3525 22.2396L10.3004 21.4985L9.22925 21.6766L9.28715 22.4866Z",
    fill: "#66FF90"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8652 27.3229L14.1778 26.7197L13.7841 27.0701L13.4309 27.7078L13.8652 27.3229Z",
    fill: "#0098FF"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1016 28.2019L14.731 28.041L14.2446 28.6844L14.5805 28.8854L15.1016 28.2019Z",
    fill: "#0068FF"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2239 18.2924L24.0767 17.9248L24.2967 18.3326L22.4497 18.706L22.2239 18.2924Z",
    fill: "#E1FF16"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M17.908 17.8503L19.8592 17.5975L20.1371 17.3965L18.1975 17.6435L17.908 17.8503Z",
    fill: "#F8F500"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9595 28.3393L13.8032 27.874L13.3284 28.2934L13.4442 28.7931L13.9595 28.3393Z",
    fill: "#006CFF"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 11.2964L15.0987 12.1638L15.7645 13.3931L15.6719 12.5257L15.0002 11.2964Z",
    fill: "#FF2900"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40992 22.7679L7.61257 22.8425L7.5373 21.7913L7.32886 21.6362L7.40992 22.7679Z",
    fill: "#60FF97"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0569 17.2933L22.9271 16.9429L23.234 17.075L21.3696 17.4254L21.0569 17.2933Z",
    fill: "#FFE600"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5039 18.6949L17.432 18.4939L17.652 18.1377L15.7297 18.3158L15.5039 18.6949Z",
    fill: "#DEFF19"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6902 20.6191L13.3056 20.4181L13.3925 19.8379L11.7828 19.9872L11.6902 20.6191Z",
    fill: "#A4FF53"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8141 27.8742L13.8605 27.3228L13.4262 27.7076L13.3394 28.2936L13.8141 27.8742Z",
    fill: "#0080FF"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3049 21.5038L11.6598 21.2797L11.683 20.6191L10.3281 20.78L10.3049 21.5038Z",
    fill: "#87FF70"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9614 17.9366L23.8143 17.5747L24.0632 17.9251L22.2104 18.2928L21.9614 17.9366Z",
    fill: "#EEFF09"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3877 17.431L23.2521 17.0806L23.5474 17.2931L21.6888 17.6493L21.3877 17.431Z",
    fill: "#FFEA00"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05811 9.59604L9.23181 10.5324L10.0598 10.1647L9.89767 9.22266L9.05811 9.59604Z",
    fill: "#AD0000"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M21.686 17.6437L23.5447 17.2876L23.8226 17.5748L21.9698 17.9367L21.686 17.6437Z",
    fill: "#FBF100"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0486 24.3418L16.8401 24.8128L16.5796 26.0192L16.7765 25.5998L17.0486 24.3418Z",
    fill: "#0CF4EB"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 20.0044L22.7554 19.6655L22.848 20.1825L21.0184 20.5444L20.9199 20.0044Z",
    fill: "#AAFF4D"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8225 23.0146L19.3164 22.5723L19.2006 23.0835L17.7009 23.5603L17.8225 23.0146Z",
    fill: "#4DFFAA"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9079 27.3174L15.5373 27.3691L15.103 28.2078H15.4504L15.9079 27.3174Z",
    fill: "#0088FF"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6104 8.36035L11.7146 9.2335L12.6294 9.61837L12.531 8.74522L11.6104 8.36035Z",
    fill: "#800000"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5081 22.6869L9.29555 22.4916L9.24344 21.6816L8.4502 21.7965L8.5081 22.6869Z",
    fill: "#66FF90"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5652 26.019L16.2525 26.2833L15.8936 27.3173L16.1889 27.1047L16.5652 26.019Z",
    fill: "#00B8FF"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5117 26.2548L15.1081 25.6631L14.7896 26.0882L14.1643 26.7201L14.5117 26.2548Z",
    fill: "#00C8FF"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3618 21.4516L21.0699 21.084L21.0641 21.624L19.3618 22.0203V21.4516Z",
    fill: "#7DFF7A"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62093 22.8426L7.96254 22.8081L7.89306 21.8373L7.54565 21.7856L7.62093 22.8426Z",
    fill: "#60FF97"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1833 17.6435L20.123 17.3965L20.4183 17.2759L18.4844 17.5171L18.1833 17.6435Z",
    fill: "#FFEA00"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2446 10.2334L14.3431 11.1065L15.1074 12.1635L15.0147 11.2961L14.2446 10.2334Z",
    fill: "#DF0000"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96457 22.8078L8.50305 22.6814L8.44515 21.791L7.90088 21.837L7.96457 22.8078Z",
    fill: "#63FF94"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18042 21.3605L7.31938 21.6362L7.34833 20.5218L7.21516 20.1714L7.18042 21.3605Z",
    fill: "#90FF66"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4783 24.0604L17.6942 23.5664L17.5205 24.0662L16.293 24.6061L16.4783 24.0604Z",
    fill: "#2CFFCA"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5222 19.3034L15.3287 19.1425L15.514 18.7002L13.7191 18.8266L13.5222 19.3034Z",
    fill: "#D1FF26"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47705 13.8695L7.67391 14.7599L8.2066 13.8063L8.02711 12.8872L7.47705 13.8695Z",
    fill: "#FF6000"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3808 25.1512L16.2841 24.6055L16.0409 25.0765L15.1145 25.6682L15.3808 25.1512Z",
    fill: "#0CF4EB"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5264 8.74561L12.6248 9.61875L13.5107 10.2506L13.4122 9.37749L12.5264 8.74561Z",
    fill: "#920000"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7322 18.3159L17.6545 18.1378L17.9093 17.8506L16.0043 18.0114L15.7322 18.3159Z",
    fill: "#EEFF09"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7815 19.4877L22.6228 19.166L22.7617 19.66L20.9262 19.999L20.7815 19.4877Z",
    fill: "#C1FF36"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7388 28.0471L14.4204 27.7427L13.9688 28.3401L14.2525 28.6847L14.7388 28.0471Z",
    fill: "#007CFF"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M13.408 9.37695L13.5064 10.2501L14.3402 11.106L14.2417 10.2329L13.408 9.37695Z",
    fill: "#B20000"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1289 18.5972L17.1521 19.4071L17.291 20.8892L17.2737 20.1137L17.1289 18.5972Z",
    fill: "#C1FF36"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22925 21.6763L10.3004 21.4982L10.3236 20.7744L9.25241 20.8778L9.22925 21.6763Z",
    fill: "#8AFF6D"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5029 17.5228L20.4368 17.2815L20.7495 17.2471L18.8272 17.4883L18.5029 17.5228Z",
    fill: "#FFE200"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7603 19.9873L13.3699 19.8379L13.5089 19.3037L11.9108 19.4071L11.7603 19.9873Z",
    fill: "#BEFF39"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2311 26.8178L14.5148 26.2549L14.1674 26.7202L13.8547 27.3233L14.2311 26.8178Z",
    fill: "#00B4FF"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 14.7603L16.4198 15.6449L16.8425 17.0925L16.7556 16.2251L16.3271 14.7603Z",
    fill: "#FFA300"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11035 19.6998L7.22615 20.1709L7.37091 19.0278L7.26089 18.4878L7.11035 19.6998Z",
    fill: "#C7FF30"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3391 20.7742L11.694 20.6133L11.7808 19.9814L10.4318 20.0791L10.3391 20.7742Z",
    fill: "#A7FF50"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24878 15.8689L7.4109 16.6559L7.81621 15.5932L7.66567 14.7603L7.24878 15.8689Z",
    fill: "#FFA300"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8689 22.4232L19.3569 22.0269L19.299 22.5783L17.8052 23.0149L17.8689 22.4232Z",
    fill: "#63FF94"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3159 20.8776L21.0298 20.5444L21.0761 21.0902L19.368 21.4578L19.3159 20.8776Z",
    fill: "#97FF60"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12329 17.8391L7.25067 18.4882L7.52281 17.3623L7.40701 16.6558L7.12329 17.8391Z",
    fill: "#FFEA00"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5874 19.0111L22.4402 18.7124L22.6255 19.172L20.7843 19.4936L20.5874 19.0111Z",
    fill: "#D4FF23"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M14.417 27.7421L14.226 27.3228L13.8091 27.8742L13.9654 28.3395L14.417 27.7421Z",
    fill: "#0090FF"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M14.226 27.3229L14.2375 26.8174L13.8554 27.3229L13.8091 27.8743L14.226 27.3229Z",
    fill: "#00A0FF"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M18.824 17.4883L20.7463 17.2471L21.0647 17.2988L19.154 17.54L18.824 17.4883Z",
    fill: "#FFDE00"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32886 21.6364L7.5373 21.7915L7.56046 20.7575L7.35202 20.522L7.32886 21.6364Z",
    fill: "#8DFF6A"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7063 18.8209L15.5012 18.6946L15.727 18.3154L13.9437 18.4131L13.7063 18.8209Z",
    fill: "#E4FF13"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 18.0117L17.901 17.8508L18.1848 17.644L16.2914 17.7934L15.9961 18.0117Z",
    fill: "#FEED00"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43872 21.7967L9.23196 21.676L9.26091 20.8833L8.46767 20.9235L8.43872 21.7967Z",
    fill: "#8AFF6D"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7976 25.6913L15.3708 25.1514L15.1044 25.6684L14.5081 26.26L14.7976 25.6913Z",
    fill: "#02E8F4"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5412 27.363L15.1416 27.2539L14.7363 28.0409L15.1069 28.2017L15.5412 27.363Z",
    fill: "#0098FF"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5987 23.457L17.8031 23.0146L17.6815 23.5661L16.4656 24.0601L16.5987 23.457Z",
    fill: "#46FFB1"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3577 18.5802L22.2221 18.293L22.4421 18.7066L20.5893 19.0053L20.3577 18.5802Z",
    fill: "#E4FF13"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89404 9.22219L10.0562 10.1643L10.9363 10.0436L10.7799 9.10156L9.89404 9.22219Z",
    fill: "#920000"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49585 11.1354L8.68692 12.089L9.42806 11.503L9.25435 10.5322L8.49585 11.1354Z",
    fill: "#DF0000"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M19.145 17.5406L21.0557 17.2993L21.3684 17.4372L19.4693 17.6842L19.145 17.5406Z",
    fill: "#FFDE00"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 24.5536L16.4828 24.0596L16.2917 24.6053L15.3884 25.151L15.5911 24.5536Z",
    fill: "#26FFD1"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2902 20.8892L17.2033 21.5785L17.1975 22.9916L17.2844 22.3482L17.2902 20.8892Z",
    fill: "#83FF73"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0837 18.2065L21.9597 17.9365L22.2145 18.2927L20.3501 18.5799L20.0837 18.2065Z",
    fill: "#F1FC06"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4873 17.6782L21.3865 17.4312L21.6875 17.6494L19.8058 17.9079L19.4873 17.6782Z",
    fill: "#FFE600"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54565 21.7908L7.89306 21.8425L7.91622 20.889L7.56881 20.7568L7.54565 21.7908Z",
    fill: "#8DFF6A"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8894 21.8427L8.43368 21.7968L8.45684 20.9236L7.91257 20.8892L7.8894 21.8427Z",
    fill: "#8DFF6A"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2021 20.3036L20.9218 20.0049L21.0203 20.5449L19.3064 20.878L19.2021 20.3036Z",
    fill: "#ADFF49"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7969 17.9025L21.6786 17.644L21.9624 17.9313L20.0864 18.2012L19.7969 17.9025Z",
    fill: "#FEED00"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9199 19.4078L13.518 19.3044L13.7149 18.8276L12.1284 18.8851L11.9199 19.4078Z",
    fill: "#D7FF1F"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8738 21.8026L19.3676 21.4521L19.3619 22.0266L17.8738 22.4229V21.8026Z",
    fill: "#7DFF7A"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25195 20.8834L10.3231 20.7743L10.4158 20.085L9.35617 20.1252L9.25195 20.8834Z",
    fill: "#AAFF4D"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2622 26.2832L15.8685 26.3923L15.5269 27.3689L15.8974 27.3172L16.2622 26.2832Z",
    fill: "#00C4FF"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3042 17.7924L18.1976 17.6431L18.5044 17.5225L16.6284 17.6661L16.3042 17.7924Z",
    fill: "#FFE200"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4092 20.0854L11.7583 19.9878L11.9088 19.4019L10.5713 19.4421L10.4092 20.0854Z",
    fill: "#C4FF33"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5511 26.1974L14.8059 25.6919L14.5164 26.2606L14.2327 26.8235L14.5511 26.1974Z",
    fill: "#00D8FF"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1797 22.9917L16.9654 23.5144L16.8323 24.8127L17.0407 24.3416L17.1797 22.9917Z",
    fill: "#46FFB1"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2146 20.1656L7.34777 20.516L7.48095 19.4475L7.35356 19.0225L7.2146 20.1656Z",
    fill: "#C1FF36"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 13.3984L15.8763 14.3003L16.4263 15.6502L16.3279 14.7656L15.7778 13.3984Z",
    fill: "#FF6400"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9573 18.4128L15.7406 18.3152L16.007 18.0107L14.241 18.0854L13.9573 18.4128Z",
    fill: "#F8F500"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M15.139 27.2538L14.7916 27.0068L14.4153 27.7421L14.7337 28.0466L15.139 27.2538Z",
    fill: "#00A8FF"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8432 24.8125L16.519 25.1342L16.27 26.2831L16.5827 26.0188L16.8432 24.8125Z",
    fill: "#0FF8E7"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0635 19.7574L20.7947 19.4932L20.9395 20.0102L19.2198 20.3089L19.0635 19.7574Z",
    fill: "#C4FF33"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6662 22.8081L17.8706 22.4175L17.8069 23.0092L16.6025 23.4515L16.6662 22.8081Z",
    fill: "#63FF94"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8323 17.0918L16.8612 17.9305L17.1392 19.4011L17.116 18.5911L16.8323 17.0918Z",
    fill: "#FFEA00"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02637 12.8873L8.20586 13.8064L8.84277 13.0367L8.68065 12.0889L8.02637 12.8873Z",
    fill: "#FF3000"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5686 26.6507L14.5512 26.2026L14.2328 26.8173L14.2212 27.3228L14.5686 26.6507Z",
    fill: "#00C8FF"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6252 17.661L18.5012 17.5174L18.8255 17.4829L16.9727 17.6208L16.6252 17.661Z",
    fill: "#FFDB00"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7886 27.0128L14.5686 26.6509L14.2212 27.3287L14.4123 27.7481L14.7886 27.0128Z",
    fill: "#00B8FF"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0307 25.0362L15.5808 24.5537L15.3782 25.1511L14.8049 25.6911L15.0307 25.0362Z",
    fill: "#1CFFDB"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4729 20.9243L9.26614 20.884L9.36457 20.1258L8.57712 20.0913L8.4729 20.9243Z",
    fill: "#ADFF49"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8086 9.10156L10.9649 10.0494L11.8682 10.1815L11.7234 9.23368L10.8086 9.10156Z",
    fill: "#840000"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8167 21.1765L19.3163 20.8721L19.3684 21.4523L17.8746 21.8027L17.8167 21.1765Z",
    fill: "#97FF60"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7227 23.8936L16.6028 23.457L16.4754 24.0602L15.5837 24.5542L15.7227 23.8936Z",
    fill: "#43FFB4"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24878 18.4877L7.35879 19.0277L7.61356 17.965L7.52091 17.3618L7.24878 18.4877Z",
    fill: "#FBF100"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8469 19.2463L20.5897 19.0107L20.7808 19.4933L19.0496 19.7575L18.8469 19.2463Z",
    fill: "#D7FF1F"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 18.8842L13.7232 18.8268L13.9664 18.4189L12.4031 18.4419L12.1367 18.8842Z",
    fill: "#EEFF09"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35181 20.5216L7.56025 20.7571L7.68763 19.7691L7.48498 19.4531L7.35181 20.5216Z",
    fill: "#BEFF39"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2327 18.0854L15.9987 18.0108L16.2997 17.7925L14.5569 17.8499L14.2327 18.0854Z",
    fill: "#FFE600"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9692 17.6266L18.8221 17.4888L19.1521 17.5405L17.3166 17.6841L16.9692 17.6266Z",
    fill: "#FFD700"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66113 14.7602L7.80589 15.5931L8.32121 14.6798L8.19382 13.8066L7.66113 14.7602Z",
    fill: "#FF6C00"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35474 20.125L10.4201 20.0905L10.5822 19.4472L9.53423 19.4185L9.35474 20.125Z",
    fill: "#CAFF2C"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91235 20.8894L8.45662 20.9239L8.56663 20.091L8.02815 19.9761L7.91235 20.8894Z",
    fill: "#B4FF43"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42017 16.656L7.53597 17.3625L7.91812 16.3515L7.81968 15.5933L7.42017 16.656Z",
    fill: "#FFAE00"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5801 19.4475L11.9176 19.4073L12.126 18.8845L10.8059 18.873L10.5801 19.4475Z",
    fill: "#DEFF19"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M15.103 12.1694L15.213 13.0885L15.8731 14.3006L15.7747 13.3987L15.103 12.1694Z",
    fill: "#FF2D00"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6057 18.7869L20.3659 18.5801L20.5975 19.0109L18.8547 19.2464L18.6057 18.7869Z",
    fill: "#EBFF0C"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8726 26.3921L15.4557 26.3462L15.1372 27.2595L15.5367 27.3687L15.8726 26.3921Z",
    fill: "#00CCFF"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24048 10.5317L9.41997 11.5025L10.2306 11.1464L10.0685 10.1641L9.24048 10.5317Z",
    fill: "#BB0000"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56836 20.7571L7.91577 20.8892L8.03157 19.9758L7.69574 19.769L7.56836 20.7571Z",
    fill: "#B7FF40"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3018 17.6778L19.1372 17.5342L19.4615 17.672L17.6434 17.8214L17.3018 17.6778Z",
    fill: "#FFD700"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6709 22.1354L17.8752 21.8022V22.4169L16.6709 22.8075V22.1354Z",
    fill: "#7DFF7A"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6912 20.5617L19.1966 20.3032L19.3008 20.8777L17.8012 21.1821L17.6912 20.5617Z",
    fill: "#B1FF46"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7912 25.4842L15.0228 25.0361L14.797 25.691L14.5422 26.1965L14.7912 25.4842Z",
    fill: "#16FFE1"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3088 18.3904L20.0864 18.2065L20.3527 18.5799L18.5926 18.7867L18.3088 18.3904Z",
    fill: "#F8F500"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 17.8276L19.4848 17.6782L19.7975 17.9023L18.0026 18.0688L17.6667 17.8276Z",
    fill: "#FFDB00"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7131 9.2334L11.8579 10.1812L12.7611 10.5604L12.628 9.61827L11.7131 9.2334Z",
    fill: "#890000"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 18.0689L19.7942 17.9023L20.0895 18.2068L18.3119 18.3906L17.9993 18.0689Z",
    fill: "#FFE600"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1474 19.4019L17.0605 20.1371L17.1937 21.5732L17.2806 20.8839L17.1474 19.4019Z",
    fill: "#C1FF36"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5537 17.8507L16.2965 17.7933L16.6208 17.6611L14.9011 17.7071L14.5537 17.8507Z",
    fill: "#FFD700"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3894 18.4362L13.9527 18.4133L14.2364 18.0858L12.6963 18.0801L12.3894 18.4362Z",
    fill: "#FFEA00"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7902 23.1869L16.6645 22.8135L16.6008 23.4568L15.7207 23.8934L15.7902 23.1869Z",
    fill: "#60FF97"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1737 24.3129L15.7122 23.8936L15.5733 24.5542L15.0232 25.0367L15.1737 24.3129Z",
    fill: "#3CFFBA"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3469 11.1064L14.4627 12.037L15.2154 13.0825L15.1054 12.1634L14.3469 11.1064Z",
    fill: "#E40000"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4535 26.3464L15.083 26.1626L14.7935 27.007L15.1409 27.254L15.4535 26.3464Z",
    fill: "#00D8FF"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5018 25.1348L16.0907 25.3071L15.8591 26.3928L16.2529 26.2836L16.5018 25.1348Z",
    fill: "#16FFE1"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M14.826 25.8692L14.7854 25.4844L14.5422 26.2024L14.5596 26.6505L14.826 25.8692Z",
    fill: "#0CF4EB"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55444 20.0909L9.3419 20.1254L9.51561 19.4188L8.74552 19.3154L8.55444 20.0909Z",
    fill: "#D1FF26"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6289 9.62451L12.7621 10.5666L13.6364 11.1927L13.5148 10.2506L12.6289 9.62451Z",
    fill: "#9B0000"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36279 19.0277L7.49017 19.4528L7.73336 18.4647L7.62335 17.9707L7.36279 19.0277Z",
    fill: "#F4F802"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5298 19.9704L19.0526 19.7578L19.2089 20.3035L17.7035 20.562L17.5298 19.9704Z",
    fill: "#C7FF30"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4084 15.6504L16.4432 16.5235L16.8543 17.9367L16.8253 17.098L16.4084 15.6504Z",
    fill: "#FFA700"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5107 10.25L13.6381 11.1863L14.4661 12.0308L14.3503 11.1002L13.5107 10.25Z",
    fill: "#BB0000"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0747 26.1625L14.8315 25.8638L14.5652 26.645L14.7852 27.0069L15.0747 26.1625Z",
    fill: "#02E8F4"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1949 21.5786L16.9807 22.1588V23.5145L17.1949 22.9917V21.5786Z",
    fill: "#80FF77"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7986 18.8729L12.1187 18.8844L12.3793 18.4363L11.0823 18.3789L10.7986 18.8729Z",
    fill: "#F8F500"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6025 21.4583L17.8127 21.1826L17.8706 21.8088L16.6604 22.1419L16.6025 21.4583Z",
    fill: "#9AFF5D"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9744 23.5142L16.6386 23.899L16.5112 25.1341L16.8355 24.8124L16.9744 23.5142Z",
    fill: "#49FFAD"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9189 17.707L16.6386 17.6606L16.9802 17.6201L15.2895 17.6664L14.9189 17.707Z",
    fill: "#FFD000"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52734 19.4186L10.5754 19.4473L10.8012 18.8729L9.77053 18.7925L9.52734 19.4186Z",
    fill: "#E7FF0F"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66846 12.0889L8.83058 13.0367L9.55435 12.4737L9.41538 11.5029L8.66846 12.0889Z",
    fill: "#F10800"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03784 19.9758L8.57632 20.0906L8.76739 19.3152L8.24628 19.1313L8.03784 19.9758Z",
    fill: "#DBFF1C"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2903 19.4184L18.8305 19.2461L19.0389 19.7573L17.5161 19.9699L17.2903 19.4184Z",
    fill: "#DEFF19"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 18.0798L14.2277 18.0855L14.5461 17.85L13.0349 17.8213L12.6875 18.0798Z",
    fill: "#FFD700"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.4534L7.70265 19.7693L7.92847 18.8502L7.74318 18.4653L7.5 19.4534Z",
    fill: "#EBFF0C"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0652 10.1706L10.2273 11.1528L11.09 11.038L10.9453 10.0557L10.0652 10.1706Z",
    fill: "#9F0000"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9671 24.6864L15.1871 24.313L15.0365 25.0368L14.8049 25.4848L14.9671 24.6864Z",
    fill: "#36FFC1"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53418 17.3621L7.62682 17.9652L7.9916 17.0117L7.92212 16.3511L7.53418 17.3621Z",
    fill: "#FFB900"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2856 17.6664L16.9764 17.6201L17.3238 17.678L15.6562 17.7243L15.2856 17.6664Z",
    fill: "#FFCC00"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8005 22.4459L16.6748 22.1357V22.8078L15.8005 23.1812V22.4459Z",
    fill: "#80FF77"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68408 19.7692L8.01991 19.976L8.22835 19.1316L7.90411 18.8501L7.68408 19.7692Z",
    fill: "#E1FF16"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0256 18.9245L18.589 18.7866L18.8379 19.2462L17.2978 19.4185L17.0256 18.9245Z",
    fill: "#F1FC06"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2576 23.5317L15.7903 23.187L15.7209 23.8936L15.1824 24.3129L15.2576 23.5317Z",
    fill: "#5DFF9A"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19897 13.8069L8.32636 14.68L8.94011 13.9447L8.83589 13.0371L8.19897 13.8069Z",
    fill: "#FF3B00"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0953 25.3062L15.661 25.3291L15.4468 26.3401L15.8637 26.3861L16.0953 25.3062Z",
    fill: "#1CFFDB"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4656 20.7803L17.6931 20.562L17.8089 21.1767L16.5987 21.4524L16.4656 20.7803Z",
    fill: "#B7FF40"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 17.73L17.3199 17.6841L17.6673 17.8334L16.0287 17.8909L15.6523 17.73Z",
    fill: "#FFCC00"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8208 15.593L7.91923 16.3513L8.41139 15.4839L8.33612 14.6797L7.8208 15.593Z",
    fill: "#FF7A00"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M16.728 18.494L18.3145 18.3906L18.5982 18.787L17.0349 18.9249L16.728 18.494Z",
    fill: "#FFEA00"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0952 18.3843L12.3922 18.4417L12.7049 18.0856L11.4368 17.9937L11.0952 18.3843Z",
    fill: "#FFDB00"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M16.019 17.8909L17.6576 17.8335L17.9935 18.069L16.3838 18.1494L16.019 17.8909Z",
    fill: "#FFD000"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75977 19.3158L9.52985 19.4192L9.77882 18.7873L9.0319 18.6265L8.75977 19.3158Z",
    fill: "#F4F802"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3743 18.1488L17.9897 18.0684L18.3024 18.39L16.7159 18.4934L16.3743 18.1488Z",
    fill: "#FFDB00"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 17.822L14.564 17.8507L14.9114 17.7071L13.4291 17.6611L13.0527 17.822Z",
    fill: "#FFC800"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8591 14.3008L15.9055 15.2026L16.4439 16.5239L16.4092 15.6507L15.8591 14.3008Z",
    fill: "#FF6C00"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8504 17.9365L16.7751 18.7178L17.0473 20.1423L17.1341 19.4071L16.8504 17.9365Z",
    fill: "#FBF100"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M15.025 25.0016L14.9728 24.6914L14.8049 25.4841L14.8455 25.869L15.025 25.0016Z",
    fill: "#30FFC7"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77856 18.7872L10.8092 18.8733L11.0929 18.3851L10.0854 18.2529L9.77856 18.7872Z",
    fill: "#FFE600"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6651 25.3298L15.2772 25.2207L15.0803 26.1628L15.4509 26.3466L15.6651 25.3298Z",
    fill: "#23FFD4"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2904 25.2201L15.0298 24.9961L14.8503 25.8635L15.0935 26.1622L15.2904 25.2201Z",
    fill: "#29FFCE"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M16.293 20.1368L17.5378 19.9702L17.7115 20.5619L16.484 20.7802L16.293 20.1368Z",
    fill: "#D1FF26"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7207 21.6988L16.6066 21.4575L16.6703 22.1411L15.796 22.4513L15.7207 21.6988Z",
    fill: "#9DFF5A"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61548 17.9658L7.72549 18.4598L8.06711 17.5694L7.98026 17.0122L7.61548 17.9658Z",
    fill: "#FFC400"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M16.643 23.8989L16.2262 24.1402L16.1104 25.3063L16.5214 25.134L16.643 23.8989Z",
    fill: "#4DFFAA"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M10.947 10.0493L11.0918 11.0373L11.9719 11.1695L11.8445 10.1872L10.947 10.0493Z",
    fill: "#920000"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4309 17.6606L14.9132 17.707L15.278 17.6664L13.8246 17.6201L13.4309 17.6606Z",
    fill: "#FFC100"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2334 19.1313L8.75451 19.3151L9.02086 18.6258L8.52291 18.373L8.2334 19.1313Z",
    fill: "#FEED00"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0357 23.8363L15.2499 23.5376L15.1746 24.3131L14.9546 24.6865L15.0357 23.8363Z",
    fill: "#5AFF9D"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43457 11.5032L9.57353 12.474L10.361 12.1351L10.2452 11.1528L9.43457 11.5032Z",
    fill: "#C80000"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0522 20.1367L16.8438 20.7743L16.9711 22.153L17.1854 21.5728L17.0522 20.1367Z",
    fill: "#BEFF39"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2627 22.722L15.7954 22.4463V23.1873L15.2627 23.532V22.722Z",
    fill: "#80FF77"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4277 17.988L12.6958 18.0799L13.0432 17.8214L11.8099 17.7065L11.4277 17.988Z",
    fill: "#FFC800"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M16.984 22.1587L16.6482 22.6125V23.905L16.984 23.5201V22.1587Z",
    fill: "#80FF77"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 19.5333L17.304 19.4185L17.5298 19.9699L16.2849 20.1365L16.0417 19.5333Z",
    fill: "#E7FF0F"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72974 18.4651L7.91502 18.85L8.23348 18.0285L8.07135 17.5747L7.72974 18.4651Z",
    fill: "#FFD300"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2058 13.0825L15.2695 14.0131L15.9122 15.1965L15.8659 14.3003L15.2058 13.0825Z",
    fill: "#FF3400"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92358 18.8501L8.24783 19.1316L8.54313 18.3734L8.24783 18.0229L7.92358 18.8501Z",
    fill: "#FFDE00"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8203 17.6201L15.2736 17.6664L15.65 17.7301L14.2314 17.6896L13.8203 17.6201Z",
    fill: "#FFB900"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02368 18.6257L9.7706 18.7866L10.0833 18.2466L9.3653 18.0283L9.02368 18.6257Z",
    fill: "#FFD700"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0881 18.2466L11.0956 18.3787L11.4314 17.9824L10.4587 17.8101L10.0881 18.2466Z",
    fill: "#FFCC00"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92358 16.3508L7.99307 17.0114L8.45627 16.1957L8.40995 15.4834L7.92358 16.3508Z",
    fill: "#FF8600"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5725 20.9583L16.47 20.7803L16.5974 21.4524L15.7115 21.6936L15.5725 20.9583Z",
    fill: "#BAFF3C"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8401 10.1875L11.9675 11.1698L12.8533 11.5489L12.7433 10.5724L11.8401 10.1875Z",
    fill: "#960000"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7437 18.9874L17.0348 18.9185L17.307 19.4125L16.0447 19.5274L15.7437 18.9874Z",
    fill: "#FBF100"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 24.0657L15.0357 23.8359L14.9546 24.6918L15.0067 25.002L15.0993 24.0657Z",
    fill: "#56FFA0"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2309 24.1406L15.7851 24.2383L15.675 25.3297L16.1093 25.3067L16.2309 24.1406Z",
    fill: "#4DFFAA"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8396 13.0366L8.94382 13.9442L9.63863 13.4042L9.56336 12.4736L8.8396 13.0366Z",
    fill: "#FF1300"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2327 17.6841L15.6512 17.7243L16.0218 17.8851L14.638 17.8564L14.2327 17.6841Z",
    fill: "#FFBD00"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M16.438 16.5176L16.3743 17.3448L16.7738 18.7177L16.8491 17.9364L16.438 16.5176Z",
    fill: "#FFAE00"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4609 12.0371L14.5362 12.9849L15.2773 14.0132L15.2194 13.0883L14.4609 12.0371Z",
    fill: "#F10800"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8059 17.7011L13.0392 17.816L13.4156 17.6609L12.217 17.5288L11.8059 17.7011Z",
    fill: "#FFB900"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4111 18.5229L16.7313 18.4941L17.0382 18.9192L15.747 18.9881L15.4111 18.5229Z",
    fill: "#FFDB00"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32471 14.6797L8.39998 15.4839L8.98478 14.7889L8.93846 13.9502L8.32471 14.6797Z",
    fill: "#FF4A00"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6335 17.8623L16.0174 17.891L16.3764 18.1495H15.0273L14.6335 17.8623Z",
    fill: "#FFC100"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0232 18.1436H16.3723L16.7139 18.494L15.3938 18.5227L15.0232 18.1436Z",
    fill: "#FFCC00"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7446 10.5664L12.8546 11.5429L13.7116 12.1518L13.6189 11.1868L12.7446 10.5664Z",
    fill: "#A40000"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1716 21.9003L15.7159 21.6992L15.7912 22.446L15.2585 22.7217L15.1716 21.9003Z",
    fill: "#A0FF56"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6265 11.1924L13.7191 12.1574L14.5297 12.9846L14.4544 12.0368L13.6265 11.1924Z",
    fill: "#C40000"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3765 24.2095L15.1044 24.0659L15.0117 24.9965L15.2723 25.2205L15.3765 24.2095Z",
    fill: "#53FFA4"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0347 22.9452L15.2489 22.7212V23.5312L15.0405 23.8356L15.0347 22.9452Z",
    fill: "#80FF77"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7836 24.2382L15.3841 24.2095L15.2856 25.2205L15.6736 25.3296L15.7836 24.2382Z",
    fill: "#50FFA7"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M15.377 20.2462L16.2976 20.1313L16.4887 20.7805L15.5912 20.9585L15.377 20.2462Z",
    fill: "#D7FF1F"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52002 18.3727L9.01797 18.6255L9.35959 18.0338L8.89059 17.7236L8.52002 18.3727Z",
    fill: "#FFC800"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2363 11.1467L10.3521 12.129L11.1859 12.0199L11.0991 11.0376L10.2363 11.1467Z",
    fill: "#AD0000"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 17.0177L8.07904 17.5749L8.5133 16.8109L8.4554 16.1963L7.99219 17.0177Z",
    fill: "#FF9800"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4548 17.8159L11.4276 17.9883L11.8097 17.7011L10.8775 17.5L10.4548 17.8159Z",
    fill: "#FFB600"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6527 22.6064L16.2358 22.9224V24.1402L16.6527 23.8989V22.6064Z",
    fill: "#80FF77"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2183 17.5346L13.4168 17.6667L13.8163 17.6208L12.6525 17.4829L12.2183 17.5346Z",
    fill: "#FFAE00"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37744 18.034L10.0954 18.2523L10.466 17.8215L9.78275 17.563L9.37744 18.034Z",
    fill: "#FFB900"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7937 18.7178L16.5911 19.4128L16.8516 20.78L17.0601 20.1424L16.7937 18.7178Z",
    fill: "#F8F500"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2334 18.0284L8.52869 18.3789L8.89926 17.7297L8.63292 17.3276L8.2334 18.0284Z",
    fill: "#FFB600"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06226 17.575L8.22438 18.0288L8.62969 17.3223L8.50231 16.811L8.06226 17.575Z",
    fill: "#FFA700"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8527 20.7744L16.5227 21.2914L16.6501 22.6069L16.9859 22.1531L16.8527 20.7744Z",
    fill: "#BAFF3C"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0916 19.5849L16.0353 19.5332L16.2785 20.1364L15.3579 20.2513L15.0916 19.5849Z",
    fill: "#F1FC06"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0117 21.0844L15.5676 20.958L15.7123 21.699L15.1681 21.9001L15.0117 21.0844Z",
    fill: "#C1FF36"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0984 23.0952L15.0347 22.9458V23.8362L15.0984 24.0717V23.0952Z",
    fill: "#80FF77"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9213 15.1968L15.8691 16.0642L16.3902 17.3452L16.4539 16.518L15.9213 15.1968Z",
    fill: "#FF7300"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6533 17.4829L13.8171 17.6208L14.2224 17.6897L13.0992 17.5633L12.6533 17.4829Z",
    fill: "#FFA700"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40454 15.4834L8.45086 16.1957L9.00091 15.5351L8.98933 14.7769L8.40454 15.4834Z",
    fill: "#FF5D00"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9434 22.0381L15.1634 21.8945L15.2444 22.716L15.0302 22.94L14.9434 22.0381Z",
    fill: "#A4FF53"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55029 12.4741L9.62556 13.4046L10.3841 13.0772L10.3377 12.1294L9.55029 12.4741Z",
    fill: "#DA0000"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7705 18.9873H15.7432L16.0385 19.5273L15.0948 19.579L14.7705 18.9873Z",
    fill: "#FFE200"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8672 17.5001L11.8052 17.7012L12.2221 17.5288L11.3246 17.3105L10.8672 17.5001Z",
    fill: "#FFA300"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2351 22.9224L15.7893 23.1004V24.2378L16.2351 24.1402V22.9224Z",
    fill: "#80FF77"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0952 11.0376L11.1879 12.0256L12.0448 12.1578L11.9753 11.1697L11.0952 11.0376Z",
    fill: "#A40000"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0999 17.5576L14.2231 17.684L14.6284 17.8621L13.5457 17.7529L13.0999 17.5576Z",
    fill: "#FFAB00"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9082 17.724L9.3772 18.0342L9.78251 17.5574L9.35404 17.207L8.9082 17.724Z",
    fill: "#FFA700"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3752 23.1522L15.103 23.0947V24.0655L15.3752 24.2091V23.1522Z",
    fill: "#80FF77"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95386 13.9443L9.00018 14.7829L9.66026 14.2717L9.64868 13.4043L8.95386 13.9443Z",
    fill: "#FF2500"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4038 18.4766L15.4113 18.5225L15.7471 18.9878H14.7744L14.4038 18.4766Z",
    fill: "#FFCC00"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5679 17.7524L14.6506 17.8616L15.0443 18.1431L14.0021 18.0569L13.5679 17.7524Z",
    fill: "#FFAE00"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7879 23.1011L15.3884 23.1528V24.2097L15.7879 24.2385V23.1011Z",
    fill: "#80FF77"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77856 17.5576L10.4618 17.816L10.8787 17.5001L10.2302 17.2129L9.77856 17.5576Z",
    fill: "#FF9F00"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0029 18.063L15.0451 18.1492L15.4157 18.5283L14.4082 18.4823L14.0029 18.063Z",
    fill: "#FFBD00"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7935 20.3035L15.3725 20.2461L15.5809 20.9584L15.0251 21.0848L14.7935 20.3035Z",
    fill: "#E1FF16"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2689 14.0132L15.24 14.9151L15.8653 16.0697L15.9174 15.2023L15.2689 14.0132Z",
    fill: "#FF3F00"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46167 16.2016L8.51957 16.8163L9.03489 16.2016L9.01173 15.541L8.46167 16.2016Z",
    fill: "#FF6F00"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3869 17.3452L16.2017 18.092L16.5896 19.4074L16.7923 18.7124L16.3869 17.3452Z",
    fill: "#FFB600"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3137 17.3162L12.2112 17.5345L12.6454 17.4828L11.7943 17.2588L11.3137 17.3162Z",
    fill: "#FF9800"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63428 17.3215L8.90062 17.7236L9.34067 17.2009L9.10907 16.7471L8.63428 17.3215Z",
    fill: "#FF9400"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5214 21.291L16.1104 21.6816L16.2319 22.9224L16.6488 22.6065L16.5214 21.291Z",
    fill: "#B7FF40"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9771 11.1699L12.0407 12.1522L12.9035 12.5198L12.8629 11.5433L11.9771 11.1699Z",
    fill: "#A40000"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9955 22.107L14.9434 22.0381L15.0302 22.94L15.0939 23.0893L14.9955 22.107Z",
    fill: "#A7FF50"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M14.782 21.1472L15.0194 21.084L15.1757 21.8997L14.9557 22.0433L14.782 21.1472Z",
    fill: "#C7FF30"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49731 16.8109L8.6247 17.3222L9.10528 16.7535L9.01263 16.1963L8.49731 16.8109Z",
    fill: "#FF8200"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5885 19.4072L16.27 19.9932L16.519 21.2914L16.849 20.7744L16.5885 19.4072Z",
    fill: "#F1FC06"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4739 19.5742L15.0818 19.5857L15.354 20.2463L14.775 20.3037L14.4739 19.5742Z",
    fill: "#FBF100"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5253 12.9849L14.5195 13.9155L15.2375 14.9092L15.2665 14.0074L14.5253 12.9849Z",
    fill: "#FF1300"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3406 12.1293L10.3869 13.0771L11.1917 12.9794L11.1801 12.0259L10.3406 12.1293Z",
    fill: "#C40000"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 11.5488L12.8999 12.5254L13.7337 13.117L13.7163 12.1635L12.8594 11.5488Z",
    fill: "#B60000"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7944 17.2588L12.6456 17.4828L13.0914 17.5575L12.2808 17.3392L11.7944 17.2588Z",
    fill: "#FF9400"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2363 17.2127L10.8848 17.5056L11.3422 17.3161L10.7401 17.0059L10.2363 17.2127Z",
    fill: "#FF8D00"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34326 17.2073L9.77173 17.5577L10.2291 17.213L9.84121 16.8281L9.34326 17.2073Z",
    fill: "#FF8D00"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7178 12.1577L13.7351 13.1113L14.5226 13.9155L14.5284 12.9849L13.7178 12.1577Z",
    fill: "#D10000"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97803 14.789L8.98961 15.5415L9.61494 15.059L9.64389 14.272L8.97803 14.789Z",
    fill: "#FF3800"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2608 22.0781L15.0002 22.1068L15.0987 23.0949L15.3708 23.1523L15.2608 22.0781Z",
    fill: "#ADFF49"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1039 21.6816L15.6638 21.9401L15.7796 23.1005L16.2255 22.9224L16.1039 21.6816Z",
    fill: "#B4FF43"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1187 18.9185L14.7614 18.9931L15.0856 19.5848L14.4776 19.5733L14.1187 18.9185Z",
    fill: "#FFD300"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63013 13.4046L9.64171 14.272L10.3655 13.9618L10.3886 13.0771L9.63013 13.4046Z",
    fill: "#F10800"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2981 17.3389L13.1087 17.5572L13.5545 17.7525L12.7903 17.5572L12.2981 17.3389Z",
    fill: "#FF9400"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6679 21.9404L15.2742 22.0783L15.3784 23.1525L15.7779 23.1008L15.6679 21.9404Z",
    fill: "#B1FF46"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5081 20.2861L14.7686 20.3034L15.0002 21.0846L14.7628 21.1478L14.5081 20.2861Z",
    fill: "#EBFF0C"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8659 16.064L15.698 16.8624L16.2017 18.0917L16.387 17.345L15.8659 16.064Z",
    fill: "#FF7E00"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7178 18.3506L14.3952 18.477L14.7658 18.9882L14.1231 18.9135L13.7178 18.3506Z",
    fill: "#FFB900"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7903 17.5518L13.5546 17.7471L13.9888 18.0573L13.2651 17.8907L12.7903 17.5518Z",
    fill: "#FF9C00"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8167 21.1304L14.782 21.1476L14.9557 22.038L15.0078 22.1069L14.8167 21.1304Z",
    fill: "#CEFF29"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2598 17.896L13.9835 18.0626L14.3888 18.4819L13.7114 18.3555L13.2598 17.896Z",
    fill: "#FFA700"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11499 16.7534L9.3466 17.2072L9.84455 16.8281L9.65926 16.3398L9.11499 16.7534Z",
    fill: "#FF7700"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7288 17.0061L11.3309 17.3163L11.8115 17.2588L11.2557 16.9429L10.7288 17.0061Z",
    fill: "#FF8200"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9895 15.5407L9.01266 16.2013L9.59746 15.7533L9.61483 15.064L8.9895 15.5407Z",
    fill: "#FF4A00"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M11.198 12.0195L11.2096 12.9788L12.0376 13.1052L12.0549 12.1517L11.198 12.0195Z",
    fill: "#B60000"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2586 19.9927L15.8591 20.458L16.0965 21.6815L16.5076 21.2909L16.2586 19.9927Z",
    fill: "#EBFF0C"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01245 16.1957L9.10509 16.7529L9.64936 16.3393L9.59725 15.7534L9.01245 16.1957Z",
    fill: "#FF6000"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84692 16.8279L10.2349 17.2128L10.7328 17.006L10.3912 16.5981L9.84692 16.8279Z",
    fill: "#FF7700"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1946 18.0918L15.8936 18.7409L16.2641 19.9932L16.5826 19.4073L16.1946 18.0918Z",
    fill: "#FFC100"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M14.187 19.4878L14.4765 19.574L14.7776 20.3035L14.517 20.2863L14.187 19.4878Z",
    fill: "#FFE200"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0766 21.0151L14.8276 21.1243L15.0187 22.1008L15.2793 22.0721L15.0766 21.0151Z",
    fill: "#D7FF1F"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2363 14.9092L15.0916 15.7536L15.6937 16.8623L15.8616 16.0638L15.2363 14.9092Z",
    fill: "#FF4A00"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2666 16.9429L11.8225 17.2588L12.3146 17.3392L11.8051 17.029L11.2666 16.9429Z",
    fill: "#FF7A00"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6476 14.2717L9.61865 15.0587L10.3019 14.7715L10.3714 13.9673L9.6476 14.2717Z",
    fill: "#FF1A00"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3867 13.0768L10.3635 13.9672L11.1278 13.8752L11.1915 12.9849L10.3867 13.0768Z",
    fill: "#DA0000"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5311 20.1885L14.5195 20.2861L14.7743 21.1478L14.809 21.1306L14.5311 20.1885Z",
    fill: "#F4F802"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8525 20.458L15.4241 20.7969L15.6441 21.9401L16.0841 21.6816L15.8525 20.458Z",
    fill: "#E4FF13"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0516 12.1519L12.0342 13.1054L12.8564 13.4616L12.9085 12.5252L12.0516 12.1519Z",
    fill: "#BB0000"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7974 18.7642L14.1216 18.9135L14.4806 19.5684L14.1911 19.4822L13.7974 18.7642Z",
    fill: "#FFC100"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4337 20.7969L15.0574 21.0152L15.2658 22.0779L15.6595 21.94L15.4337 20.7969Z",
    fill: "#DEFF19"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65308 16.3398L9.83836 16.8281L10.3826 16.5983L10.2437 16.0928L9.65308 16.3398Z",
    fill: "#FF6000"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M11.783 17.0293L12.2925 17.3395L12.7846 17.552L12.3272 17.2648L11.783 17.0293Z",
    fill: "#FF7E00"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 16.5979L10.7166 17.0057L11.2435 16.9483L10.9482 16.5347L10.375 16.5979Z",
    fill: "#FF6C00"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5311 13.9209L14.4153 14.8055L15.1043 15.7591L15.2491 14.9147L14.5311 13.9209Z",
    fill: "#FF1E00"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3511 18.1436L13.7216 18.3504L14.1327 18.9133L13.8085 18.7639L13.3511 18.1436Z",
    fill: "#FFA700"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8995 12.52L12.8474 13.4564L13.6464 14.0308L13.7333 13.1174L12.8995 12.52Z",
    fill: "#C80000"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3323 17.2642L12.7897 17.5514L13.2645 17.8903L12.8534 17.6375L12.3323 17.2642Z",
    fill: "#FF8600"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62455 15.0586L9.60718 15.7479L10.2441 15.4779L10.3078 14.7656L9.62455 15.0586Z",
    fill: "#FF3000"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6905 16.8623L15.4126 17.5746L15.8874 18.7465L16.1885 18.0916L15.6905 16.8623Z",
    fill: "#FF8900"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 17.6382L13.2705 17.8909L13.7221 18.3505L13.3515 18.1437L12.8594 17.6382Z",
    fill: "#FF9400"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7245 13.1172L13.6377 14.0305L14.3962 14.806L14.512 13.9214L13.7245 13.1172Z",
    fill: "#E40000"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8975 18.7412L15.5154 19.2754L15.8628 20.453L16.2623 19.9877L15.8975 18.7412Z",
    fill: "#FFC800"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60718 15.7534L9.65929 16.3393L10.2499 16.0923V15.4834L9.60718 15.7534Z",
    fill: "#FF4A00"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1755 19.3154L14.1929 19.4878L14.5229 20.2862L14.5345 20.1886L14.1755 19.3154Z",
    fill: "#FFD300"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7568 19.999L14.531 20.1943L14.8089 21.1364L15.0579 21.0273L14.7568 19.999Z",
    fill: "#FEED00"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2046 12.9795L11.1409 13.8756L11.9283 13.9962L12.0325 13.1059L11.2046 12.9795Z",
    fill: "#CD0000"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9585 16.5288L11.2538 16.9424L11.7923 17.0286L11.5491 16.6265L10.9585 16.5288Z",
    fill: "#FF6400"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3744 13.9673L10.3049 14.7715L11.0287 14.6853L11.1387 13.8696L10.3744 13.9673Z",
    fill: "#F10800"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5198 19.2749L15.1145 19.6942L15.4387 20.7972L15.8672 20.4583L15.5198 19.2749Z",
    fill: "#FFD300"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2478 16.0927L10.3868 16.5982L10.96 16.5293L10.8731 16.0181L10.2478 16.0927Z",
    fill: "#FF5200"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1125 19.6943L14.7593 19.993L15.0604 21.0155L15.4367 20.7973L15.1125 19.6943Z",
    fill: "#FFE200"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7405 18.5229L13.7926 18.7642L14.1863 19.4823L14.1689 19.3099L13.7405 18.5229Z",
    fill: "#FFB200"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 15.7534L14.8503 16.5174L15.4236 17.5744L15.7015 16.8678L15.0993 15.7534Z",
    fill: "#FF5900"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5532 16.6274L11.7964 17.0295L12.3349 17.2651L12.1438 16.8859L11.5532 16.6274Z",
    fill: "#FF6400"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3115 14.7712L10.2478 15.4835L10.9195 15.4031L11.0295 14.6851L10.3115 14.7712Z",
    fill: "#FF2200"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3666 19.0449L14.1755 19.3149L14.5345 20.1881L14.7603 19.9927L14.3666 19.0449Z",
    fill: "#FFC400"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2478 15.4837V16.0926L10.8731 16.018L10.9195 15.4033L10.2478 15.4837Z",
    fill: "#FF3800"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4106 17.5747L15.0574 18.1779L15.509 19.2808L15.8911 18.7465L15.4106 17.5747Z",
    fill: "#FF9400"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0241 13.106L11.9199 13.9963L12.7074 14.3353L12.8463 13.4621L12.0241 13.106Z",
    fill: "#D10000"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2483 17.8447L13.3467 18.1434L13.7984 18.7638L13.7462 18.5226L13.2483 17.8447Z",
    fill: "#FF9400"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1482 16.8853L12.3393 17.2701L12.8604 17.6435L12.7156 17.2988L12.1482 16.8853Z",
    fill: "#FF6C00"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M12.699 17.293L12.8437 17.6376L13.3359 18.1431L13.2375 17.8444L12.699 17.293Z",
    fill: "#FF7E00"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4012 14.8003L14.187 15.6103L14.8413 16.5179L15.0903 15.7539L14.4012 14.8003Z",
    fill: "#FF3000"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8557 16.0181L10.9426 16.5293L11.5332 16.627L11.4984 16.1215L10.8557 16.0181Z",
    fill: "#FF4A00"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1371 13.8696L11.0271 14.6853L11.7682 14.8002L11.9246 13.996L11.1371 13.8696Z",
    fill: "#E80000"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8379 13.4561L12.699 14.3292L13.4633 14.8749L13.6428 14.0305L12.8379 13.4561Z",
    fill: "#DF0000"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6939 18.6665L14.3696 19.0456L14.7634 19.9992L15.1166 19.7005L14.6939 18.6665Z",
    fill: "#FFB200"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6561 14.0303L13.4766 14.8747L14.1945 15.61L14.4088 14.8L13.6561 14.0303Z",
    fill: "#FA0F00"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M15.067 18.1782L14.6907 18.6665L15.1134 19.6947L15.5187 19.2754L15.067 18.1782Z",
    fill: "#FFA300"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8968 18.1836L13.7405 18.5225L14.1689 19.3095L14.36 19.0395L13.8968 18.1836Z",
    fill: "#FF9F00"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8323 16.5176L14.5081 17.1839L15.0523 18.1777L15.4055 17.5745L14.8323 16.5176Z",
    fill: "#FF6800"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M10.902 15.4033L10.8557 16.018L11.4984 16.1214L11.5968 15.5125L10.902 15.4033Z",
    fill: "#FF3000"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5071 16.1211L11.5418 16.6266L12.1324 16.8851L12.144 16.4026L11.5071 16.1211Z",
    fill: "#FF4A00"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0229 14.6851L10.9128 15.4031L11.6077 15.5122L11.7698 14.7999L11.0229 14.6851Z",
    fill: "#FF1A00"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3641 17.4478L13.2483 17.8441L13.7405 18.522L13.8968 18.183L13.3641 17.4478Z",
    fill: "#FF7E00"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9166 13.9961L11.7603 14.8003L12.5014 15.122L12.704 14.335L11.9166 13.9961Z",
    fill: "#ED0400"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1598 16.3975L12.1482 16.88L12.7214 17.2878L12.7851 16.8398L12.1598 16.3975Z",
    fill: "#FF5500"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1897 17.7412L13.9001 18.1893L14.3691 19.0452L14.6934 18.6661L14.1897 17.7412Z",
    fill: "#FF8D00"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7627 16.8447L12.699 17.2928L13.2375 17.8442L13.3475 17.4421L12.7627 16.8447Z",
    fill: "#FF6800"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5172 17.1841L14.1755 17.7413L14.6851 18.6661L15.0614 18.1779L14.5172 17.1841Z",
    fill: "#FF7A00"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1953 15.6099L13.9116 16.3279L14.5312 17.1838L14.8554 16.5175L14.1953 15.6099Z",
    fill: "#FF4300"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6055 15.5122L11.5071 16.1211L12.1498 16.3968L12.3003 15.8109L11.6055 15.5122Z",
    fill: "#FF3400"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7175 14.3296L12.5149 15.1166L13.2329 15.6278L13.476 14.8696L12.7175 14.3296Z",
    fill: "#FA0F00"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7725 14.8003L11.6104 15.5126L12.3052 15.8113L12.5136 15.122L11.7725 14.8003Z",
    fill: "#FF1A00"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4688 14.875L13.2256 15.6333L13.903 16.3283L14.1867 15.6103L13.4688 14.875Z",
    fill: "#FF2200"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6055 16.9429L13.3623 17.4484L13.9008 18.1894L14.1903 17.7413L13.6055 16.9429Z",
    fill: "#FF6800"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9046 16.3281L13.6035 16.9428L14.1825 17.7412L14.5241 17.184L13.9046 16.3281Z",
    fill: "#FF5500"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3102 15.811L12.1597 16.397L12.785 16.845L12.9819 16.2936L12.3102 15.811Z",
    fill: "#FF3B00"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9644 16.2939L12.7676 16.8454L13.3582 17.4486L13.6014 16.9431L12.9644 16.2939Z",
    fill: "#FF4E00"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5065 15.1216L12.2981 15.8109L12.9697 16.2934L13.2245 15.6328L12.5065 15.1216Z",
    fill: "#FF2500"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2391 15.6328L12.9844 16.2934L13.6213 16.9425L13.9224 16.3279L13.2391 15.6328Z",
    fill: "#FF3800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/CURVE.b7668908146b2aca43cbe73df0fcef68.svg";
export { ForwardRef as ReactComponent };